var map = {
	"./LATEST/ambient/cave/cave1.ogg": 580335,
	"./LATEST/ambient/cave/cave10.ogg": 543672,
	"./LATEST/ambient/cave/cave11.ogg": 245154,
	"./LATEST/ambient/cave/cave12.ogg": 499372,
	"./LATEST/ambient/cave/cave13.ogg": 909526,
	"./LATEST/ambient/cave/cave14.ogg": 925952,
	"./LATEST/ambient/cave/cave15.ogg": 424370,
	"./LATEST/ambient/cave/cave16.ogg": 651066,
	"./LATEST/ambient/cave/cave17.ogg": 922024,
	"./LATEST/ambient/cave/cave18.ogg": 214264,
	"./LATEST/ambient/cave/cave19.ogg": 433926,
	"./LATEST/ambient/cave/cave2.ogg": 186268,
	"./LATEST/ambient/cave/cave3.ogg": 346206,
	"./LATEST/ambient/cave/cave4.ogg": 430385,
	"./LATEST/ambient/cave/cave5.ogg": 252610,
	"./LATEST/ambient/cave/cave6.ogg": 473849,
	"./LATEST/ambient/cave/cave7.ogg": 877330,
	"./LATEST/ambient/cave/cave8.ogg": 735127,
	"./LATEST/ambient/cave/cave9.ogg": 816215,
	"./LATEST/ambient/nether/basalt_deltas/active1.ogg": 67796,
	"./LATEST/ambient/nether/basalt_deltas/active2.ogg": 313241,
	"./LATEST/ambient/nether/basalt_deltas/active3.ogg": 325563,
	"./LATEST/ambient/nether/basalt_deltas/active4.ogg": 752750,
	"./LATEST/ambient/nether/basalt_deltas/ambience.ogg": 191249,
	"./LATEST/ambient/nether/basalt_deltas/basaltground1.ogg": 312417,
	"./LATEST/ambient/nether/basalt_deltas/basaltground2.ogg": 663298,
	"./LATEST/ambient/nether/basalt_deltas/basaltground3.ogg": 884178,
	"./LATEST/ambient/nether/basalt_deltas/basaltground4.ogg": 375901,
	"./LATEST/ambient/nether/basalt_deltas/click1.ogg": 682532,
	"./LATEST/ambient/nether/basalt_deltas/click2.ogg": 343825,
	"./LATEST/ambient/nether/basalt_deltas/click3.ogg": 772215,
	"./LATEST/ambient/nether/basalt_deltas/click4.ogg": 202627,
	"./LATEST/ambient/nether/basalt_deltas/click5.ogg": 415324,
	"./LATEST/ambient/nether/basalt_deltas/click6.ogg": 285065,
	"./LATEST/ambient/nether/basalt_deltas/click7.ogg": 656341,
	"./LATEST/ambient/nether/basalt_deltas/click8.ogg": 25836,
	"./LATEST/ambient/nether/basalt_deltas/debris1.ogg": 230447,
	"./LATEST/ambient/nether/basalt_deltas/debris2.ogg": 668206,
	"./LATEST/ambient/nether/basalt_deltas/debris3.ogg": 121251,
	"./LATEST/ambient/nether/basalt_deltas/heavy_click1.ogg": 144581,
	"./LATEST/ambient/nether/basalt_deltas/heavy_click2.ogg": 927136,
	"./LATEST/ambient/nether/basalt_deltas/long_debris1.ogg": 340010,
	"./LATEST/ambient/nether/basalt_deltas/long_debris2.ogg": 9905,
	"./LATEST/ambient/nether/basalt_deltas/plode1.ogg": 256316,
	"./LATEST/ambient/nether/basalt_deltas/plode2.ogg": 916397,
	"./LATEST/ambient/nether/basalt_deltas/plode3.ogg": 635433,
	"./LATEST/ambient/nether/basalt_deltas/twist1.ogg": 398438,
	"./LATEST/ambient/nether/basalt_deltas/twist2.ogg": 824634,
	"./LATEST/ambient/nether/basalt_deltas/twist3.ogg": 879210,
	"./LATEST/ambient/nether/basalt_deltas/twist4.ogg": 51900,
	"./LATEST/ambient/nether/crimson_forest/addition1.ogg": 284584,
	"./LATEST/ambient/nether/crimson_forest/addition2.ogg": 328946,
	"./LATEST/ambient/nether/crimson_forest/addition3.ogg": 812122,
	"./LATEST/ambient/nether/crimson_forest/ambience.ogg": 512704,
	"./LATEST/ambient/nether/crimson_forest/mood1.ogg": 546960,
	"./LATEST/ambient/nether/crimson_forest/mood2.ogg": 127130,
	"./LATEST/ambient/nether/crimson_forest/mood3.ogg": 236722,
	"./LATEST/ambient/nether/crimson_forest/mood4.ogg": 509823,
	"./LATEST/ambient/nether/crimson_forest/particles1.ogg": 780490,
	"./LATEST/ambient/nether/crimson_forest/particles2.ogg": 80842,
	"./LATEST/ambient/nether/crimson_forest/particles3.ogg": 870879,
	"./LATEST/ambient/nether/crimson_forest/shine1.ogg": 744929,
	"./LATEST/ambient/nether/crimson_forest/shine2.ogg": 879726,
	"./LATEST/ambient/nether/crimson_forest/shine3.ogg": 417350,
	"./LATEST/ambient/nether/crimson_forest/shroom1.ogg": 217892,
	"./LATEST/ambient/nether/crimson_forest/shroom2.ogg": 408021,
	"./LATEST/ambient/nether/crimson_forest/shroom3.ogg": 870638,
	"./LATEST/ambient/nether/crimson_forest/twang1.ogg": 411357,
	"./LATEST/ambient/nether/crimson_forest/voom1.ogg": 521820,
	"./LATEST/ambient/nether/crimson_forest/voom2.ogg": 851807,
	"./LATEST/ambient/nether/nether_wastes/addition1.ogg": 846730,
	"./LATEST/ambient/nether/nether_wastes/addition2.ogg": 953196,
	"./LATEST/ambient/nether/nether_wastes/addition3.ogg": 605953,
	"./LATEST/ambient/nether/nether_wastes/addition4.ogg": 208828,
	"./LATEST/ambient/nether/nether_wastes/addition5.ogg": 511506,
	"./LATEST/ambient/nether/nether_wastes/addition6.ogg": 652660,
	"./LATEST/ambient/nether/nether_wastes/addition7.ogg": 880845,
	"./LATEST/ambient/nether/nether_wastes/addition8.ogg": 417803,
	"./LATEST/ambient/nether/nether_wastes/ambience.ogg": 447504,
	"./LATEST/ambient/nether/nether_wastes/dark1.ogg": 842778,
	"./LATEST/ambient/nether/nether_wastes/dark2.ogg": 755906,
	"./LATEST/ambient/nether/nether_wastes/ground1.ogg": 556728,
	"./LATEST/ambient/nether/nether_wastes/ground2.ogg": 567257,
	"./LATEST/ambient/nether/nether_wastes/ground3.ogg": 629455,
	"./LATEST/ambient/nether/nether_wastes/ground4.ogg": 875028,
	"./LATEST/ambient/nether/nether_wastes/mood1.ogg": 997982,
	"./LATEST/ambient/nether/nether_wastes/mood2.ogg": 39888,
	"./LATEST/ambient/nether/nether_wastes/mood3.ogg": 378646,
	"./LATEST/ambient/nether/nether_wastes/mood4.ogg": 31100,
	"./LATEST/ambient/nether/nether_wastes/mood5.ogg": 65192,
	"./LATEST/ambient/nether/soulsand_valley/ambience.ogg": 422523,
	"./LATEST/ambient/nether/soulsand_valley/mood1.ogg": 464727,
	"./LATEST/ambient/nether/soulsand_valley/mood2.ogg": 989540,
	"./LATEST/ambient/nether/soulsand_valley/mood3.ogg": 987712,
	"./LATEST/ambient/nether/soulsand_valley/mood4.ogg": 937441,
	"./LATEST/ambient/nether/soulsand_valley/sand1.ogg": 437455,
	"./LATEST/ambient/nether/soulsand_valley/sand2.ogg": 718674,
	"./LATEST/ambient/nether/soulsand_valley/sand3.ogg": 881716,
	"./LATEST/ambient/nether/soulsand_valley/voices1.ogg": 464880,
	"./LATEST/ambient/nether/soulsand_valley/voices2.ogg": 111327,
	"./LATEST/ambient/nether/soulsand_valley/voices3.ogg": 440673,
	"./LATEST/ambient/nether/soulsand_valley/voices4.ogg": 424061,
	"./LATEST/ambient/nether/soulsand_valley/voices5.ogg": 301247,
	"./LATEST/ambient/nether/soulsand_valley/whisper1.ogg": 612322,
	"./LATEST/ambient/nether/soulsand_valley/whisper2.ogg": 576827,
	"./LATEST/ambient/nether/soulsand_valley/whisper3.ogg": 432528,
	"./LATEST/ambient/nether/soulsand_valley/whisper4.ogg": 812732,
	"./LATEST/ambient/nether/soulsand_valley/whisper5.ogg": 92557,
	"./LATEST/ambient/nether/soulsand_valley/whisper6.ogg": 527095,
	"./LATEST/ambient/nether/soulsand_valley/whisper7.ogg": 255578,
	"./LATEST/ambient/nether/soulsand_valley/whisper8.ogg": 946900,
	"./LATEST/ambient/nether/soulsand_valley/wind1.ogg": 999164,
	"./LATEST/ambient/nether/soulsand_valley/wind2.ogg": 478757,
	"./LATEST/ambient/nether/soulsand_valley/wind3.ogg": 130391,
	"./LATEST/ambient/nether/soulsand_valley/wind4.ogg": 490025,
	"./LATEST/ambient/nether/soulsand_valley/with1.ogg": 862871,
	"./LATEST/ambient/nether/warped_forest/addition1.ogg": 931561,
	"./LATEST/ambient/nether/warped_forest/addition2.ogg": 585728,
	"./LATEST/ambient/nether/warped_forest/addition3.ogg": 816804,
	"./LATEST/ambient/nether/warped_forest/addition4.ogg": 26656,
	"./LATEST/ambient/nether/warped_forest/addition5.ogg": 825587,
	"./LATEST/ambient/nether/warped_forest/addition6.ogg": 481879,
	"./LATEST/ambient/nether/warped_forest/ambience.ogg": 679414,
	"./LATEST/ambient/nether/warped_forest/creak1.ogg": 887172,
	"./LATEST/ambient/nether/warped_forest/creak2.ogg": 641893,
	"./LATEST/ambient/nether/warped_forest/creak3.ogg": 914157,
	"./LATEST/ambient/nether/warped_forest/creak4.ogg": 250050,
	"./LATEST/ambient/nether/warped_forest/creak5.ogg": 853873,
	"./LATEST/ambient/nether/warped_forest/enish1.ogg": 531199,
	"./LATEST/ambient/nether/warped_forest/enish2.ogg": 861857,
	"./LATEST/ambient/nether/warped_forest/enish3.ogg": 599948,
	"./LATEST/ambient/nether/warped_forest/help1.ogg": 359171,
	"./LATEST/ambient/nether/warped_forest/help2.ogg": 638823,
	"./LATEST/ambient/nether/warped_forest/here1.ogg": 512655,
	"./LATEST/ambient/nether/warped_forest/here2.ogg": 591670,
	"./LATEST/ambient/nether/warped_forest/here3.ogg": 570276,
	"./LATEST/ambient/nether/warped_forest/mood1.ogg": 495310,
	"./LATEST/ambient/nether/warped_forest/mood2.ogg": 979039,
	"./LATEST/ambient/nether/warped_forest/mood3.ogg": 128208,
	"./LATEST/ambient/nether/warped_forest/mood4.ogg": 162999,
	"./LATEST/ambient/nether/warped_forest/mood5.ogg": 945697,
	"./LATEST/ambient/nether/warped_forest/mood6.ogg": 807047,
	"./LATEST/ambient/nether/warped_forest/mood7.ogg": 339450,
	"./LATEST/ambient/nether/warped_forest/mood8.ogg": 422321,
	"./LATEST/ambient/nether/warped_forest/mood9.ogg": 698070,
	"./LATEST/ambient/underwater/additions/animal1.ogg": 183317,
	"./LATEST/ambient/underwater/additions/animal2.ogg": 189155,
	"./LATEST/ambient/underwater/additions/bass_whale1.ogg": 261718,
	"./LATEST/ambient/underwater/additions/bass_whale2.ogg": 649101,
	"./LATEST/ambient/underwater/additions/bubbles1.ogg": 757997,
	"./LATEST/ambient/underwater/additions/bubbles2.ogg": 580905,
	"./LATEST/ambient/underwater/additions/bubbles3.ogg": 812416,
	"./LATEST/ambient/underwater/additions/bubbles4.ogg": 402380,
	"./LATEST/ambient/underwater/additions/bubbles5.ogg": 877347,
	"./LATEST/ambient/underwater/additions/bubbles6.ogg": 140360,
	"./LATEST/ambient/underwater/additions/crackles1.ogg": 653689,
	"./LATEST/ambient/underwater/additions/crackles2.ogg": 211007,
	"./LATEST/ambient/underwater/additions/dark1.ogg": 551695,
	"./LATEST/ambient/underwater/additions/dark2.ogg": 240004,
	"./LATEST/ambient/underwater/additions/dark3.ogg": 382889,
	"./LATEST/ambient/underwater/additions/dark4.ogg": 910814,
	"./LATEST/ambient/underwater/additions/driplets1.ogg": 827589,
	"./LATEST/ambient/underwater/additions/driplets2.ogg": 954595,
	"./LATEST/ambient/underwater/additions/earth_crack.ogg": 513977,
	"./LATEST/ambient/underwater/additions/water1.ogg": 186125,
	"./LATEST/ambient/underwater/additions/water2.ogg": 651058,
	"./LATEST/ambient/underwater/enter1.ogg": 14725,
	"./LATEST/ambient/underwater/enter2.ogg": 83116,
	"./LATEST/ambient/underwater/enter3.ogg": 707322,
	"./LATEST/ambient/underwater/exit1.ogg": 726557,
	"./LATEST/ambient/underwater/exit2.ogg": 481464,
	"./LATEST/ambient/underwater/exit3.ogg": 985485,
	"./LATEST/ambient/underwater/underwater_ambience.ogg": 401368,
	"./LATEST/ambient/weather/rain1.ogg": 450273,
	"./LATEST/ambient/weather/rain2.ogg": 191023,
	"./LATEST/ambient/weather/rain3.ogg": 332933,
	"./LATEST/ambient/weather/rain4.ogg": 589929,
	"./LATEST/ambient/weather/rain5.ogg": 348271,
	"./LATEST/ambient/weather/rain6.ogg": 113376,
	"./LATEST/ambient/weather/rain7.ogg": 405869,
	"./LATEST/ambient/weather/rain8.ogg": 804814,
	"./LATEST/ambient/weather/thunder1.ogg": 345870,
	"./LATEST/ambient/weather/thunder2.ogg": 147791,
	"./LATEST/ambient/weather/thunder3.ogg": 378063,
	"./LATEST/block/amethyst/break1.ogg": 519517,
	"./LATEST/block/amethyst/break2.ogg": 604597,
	"./LATEST/block/amethyst/break3.ogg": 301418,
	"./LATEST/block/amethyst/break4.ogg": 553893,
	"./LATEST/block/amethyst/place1.ogg": 678732,
	"./LATEST/block/amethyst/place2.ogg": 928790,
	"./LATEST/block/amethyst/place3.ogg": 458609,
	"./LATEST/block/amethyst/place4.ogg": 84818,
	"./LATEST/block/amethyst/resonate1.ogg": 700686,
	"./LATEST/block/amethyst/resonate2.ogg": 400956,
	"./LATEST/block/amethyst/resonate3.ogg": 159909,
	"./LATEST/block/amethyst/resonate4.ogg": 774070,
	"./LATEST/block/amethyst/shimmer.ogg": 458136,
	"./LATEST/block/amethyst/step1.ogg": 175235,
	"./LATEST/block/amethyst/step10.ogg": 75042,
	"./LATEST/block/amethyst/step11.ogg": 189882,
	"./LATEST/block/amethyst/step12.ogg": 591737,
	"./LATEST/block/amethyst/step13.ogg": 199690,
	"./LATEST/block/amethyst/step14.ogg": 608010,
	"./LATEST/block/amethyst/step2.ogg": 24688,
	"./LATEST/block/amethyst/step3.ogg": 757239,
	"./LATEST/block/amethyst/step4.ogg": 810722,
	"./LATEST/block/amethyst/step5.ogg": 153940,
	"./LATEST/block/amethyst/step6.ogg": 520261,
	"./LATEST/block/amethyst/step7.ogg": 368433,
	"./LATEST/block/amethyst/step8.ogg": 14634,
	"./LATEST/block/amethyst/step9.ogg": 127446,
	"./LATEST/block/amethyst_cluster/break1.ogg": 548721,
	"./LATEST/block/amethyst_cluster/break2.ogg": 719920,
	"./LATEST/block/amethyst_cluster/break3.ogg": 371720,
	"./LATEST/block/amethyst_cluster/break4.ogg": 962147,
	"./LATEST/block/amethyst_cluster/place1.ogg": 312779,
	"./LATEST/block/amethyst_cluster/place2.ogg": 336867,
	"./LATEST/block/amethyst_cluster/place3.ogg": 58286,
	"./LATEST/block/amethyst_cluster/place4.ogg": 503064,
	"./LATEST/block/ancient_debris/break1.ogg": 726776,
	"./LATEST/block/ancient_debris/break2.ogg": 891103,
	"./LATEST/block/ancient_debris/break3.ogg": 965853,
	"./LATEST/block/ancient_debris/break4.ogg": 535819,
	"./LATEST/block/ancient_debris/break5.ogg": 344378,
	"./LATEST/block/azalea/break1.ogg": 794615,
	"./LATEST/block/azalea/break2.ogg": 400055,
	"./LATEST/block/azalea/break3.ogg": 302667,
	"./LATEST/block/azalea/break4.ogg": 516428,
	"./LATEST/block/azalea/break5.ogg": 258149,
	"./LATEST/block/azalea/break6.ogg": 264198,
	"./LATEST/block/azalea/step1.ogg": 165396,
	"./LATEST/block/azalea/step2.ogg": 985536,
	"./LATEST/block/azalea/step3.ogg": 865255,
	"./LATEST/block/azalea/step4.ogg": 593042,
	"./LATEST/block/azalea/step5.ogg": 107369,
	"./LATEST/block/azalea/step6.ogg": 43159,
	"./LATEST/block/azalea_leaves/break1.ogg": 962172,
	"./LATEST/block/azalea_leaves/break2.ogg": 213887,
	"./LATEST/block/azalea_leaves/break3.ogg": 897280,
	"./LATEST/block/azalea_leaves/break4.ogg": 280921,
	"./LATEST/block/azalea_leaves/break5.ogg": 381370,
	"./LATEST/block/azalea_leaves/break6.ogg": 199799,
	"./LATEST/block/azalea_leaves/break7.ogg": 460121,
	"./LATEST/block/azalea_leaves/step1.ogg": 55938,
	"./LATEST/block/azalea_leaves/step2.ogg": 419593,
	"./LATEST/block/azalea_leaves/step3.ogg": 759681,
	"./LATEST/block/azalea_leaves/step4.ogg": 69937,
	"./LATEST/block/azalea_leaves/step5.ogg": 362696,
	"./LATEST/block/bamboo/place1.ogg": 800365,
	"./LATEST/block/bamboo/place2.ogg": 668839,
	"./LATEST/block/bamboo/place3.ogg": 701163,
	"./LATEST/block/bamboo/place4.ogg": 371830,
	"./LATEST/block/bamboo/place5.ogg": 129202,
	"./LATEST/block/bamboo/place6.ogg": 991261,
	"./LATEST/block/bamboo/sapling_hit1.ogg": 180518,
	"./LATEST/block/bamboo/sapling_hit2.ogg": 708347,
	"./LATEST/block/bamboo/sapling_hit3.ogg": 791567,
	"./LATEST/block/bamboo/sapling_hit4.ogg": 104972,
	"./LATEST/block/bamboo/sapling_hit5.ogg": 347086,
	"./LATEST/block/bamboo/sapling_place1.ogg": 679278,
	"./LATEST/block/bamboo/sapling_place2.ogg": 201859,
	"./LATEST/block/bamboo/sapling_place3.ogg": 157838,
	"./LATEST/block/bamboo/sapling_place4.ogg": 949342,
	"./LATEST/block/bamboo/sapling_place5.ogg": 131356,
	"./LATEST/block/bamboo/sapling_place6.ogg": 404520,
	"./LATEST/block/bamboo/step1.ogg": 972002,
	"./LATEST/block/bamboo/step2.ogg": 808123,
	"./LATEST/block/bamboo/step3.ogg": 247102,
	"./LATEST/block/bamboo/step4.ogg": 137716,
	"./LATEST/block/bamboo/step5.ogg": 349178,
	"./LATEST/block/bamboo/step6.ogg": 873256,
	"./LATEST/block/bamboo_wood/break1.ogg": 234443,
	"./LATEST/block/bamboo_wood/break2.ogg": 946909,
	"./LATEST/block/bamboo_wood/break3.ogg": 460011,
	"./LATEST/block/bamboo_wood/break4.ogg": 915829,
	"./LATEST/block/bamboo_wood/break5.ogg": 716500,
	"./LATEST/block/bamboo_wood/step1.ogg": 304014,
	"./LATEST/block/bamboo_wood/step2.ogg": 232059,
	"./LATEST/block/bamboo_wood/step3.ogg": 14206,
	"./LATEST/block/bamboo_wood/step4.ogg": 657279,
	"./LATEST/block/bamboo_wood/step5.ogg": 675139,
	"./LATEST/block/bamboo_wood/step6.ogg": 548406,
	"./LATEST/block/bamboo_wood_button/bamboo_wood_button.ogg": 827408,
	"./LATEST/block/bamboo_wood_door/toggle1.ogg": 973553,
	"./LATEST/block/bamboo_wood_door/toggle2.ogg": 250473,
	"./LATEST/block/bamboo_wood_door/toggle3.ogg": 938252,
	"./LATEST/block/bamboo_wood_door/toggle4.ogg": 772426,
	"./LATEST/block/bamboo_wood_fence/toggle1.ogg": 813677,
	"./LATEST/block/bamboo_wood_fence/toggle2.ogg": 56908,
	"./LATEST/block/bamboo_wood_fence/toggle3.ogg": 867843,
	"./LATEST/block/bamboo_wood_fence/toggle4.ogg": 435253,
	"./LATEST/block/bamboo_wood_hanging_sign/break1.ogg": 215084,
	"./LATEST/block/bamboo_wood_hanging_sign/break2.ogg": 917750,
	"./LATEST/block/bamboo_wood_hanging_sign/break3.ogg": 522859,
	"./LATEST/block/bamboo_wood_hanging_sign/break4.ogg": 311504,
	"./LATEST/block/bamboo_wood_hanging_sign/step1.ogg": 948514,
	"./LATEST/block/bamboo_wood_hanging_sign/step2.ogg": 856230,
	"./LATEST/block/bamboo_wood_hanging_sign/step3.ogg": 516443,
	"./LATEST/block/bamboo_wood_hanging_sign/step4.ogg": 904539,
	"./LATEST/block/bamboo_wood_trapdoor/toggle1.ogg": 152899,
	"./LATEST/block/bamboo_wood_trapdoor/toggle2.ogg": 975635,
	"./LATEST/block/bamboo_wood_trapdoor/toggle3.ogg": 840749,
	"./LATEST/block/bamboo_wood_trapdoor/toggle4.ogg": 606668,
	"./LATEST/block/barrel/close.ogg": 710136,
	"./LATEST/block/barrel/open1.ogg": 611092,
	"./LATEST/block/barrel/open2.ogg": 785208,
	"./LATEST/block/basalt/break1.ogg": 763393,
	"./LATEST/block/basalt/break2.ogg": 919759,
	"./LATEST/block/basalt/break3.ogg": 275410,
	"./LATEST/block/basalt/break4.ogg": 774741,
	"./LATEST/block/basalt/break5.ogg": 249592,
	"./LATEST/block/basalt/step1.ogg": 135725,
	"./LATEST/block/basalt/step2.ogg": 281847,
	"./LATEST/block/basalt/step3.ogg": 943168,
	"./LATEST/block/basalt/step4.ogg": 764600,
	"./LATEST/block/basalt/step5.ogg": 220153,
	"./LATEST/block/basalt/step6.ogg": 172025,
	"./LATEST/block/beacon/activate.ogg": 541287,
	"./LATEST/block/beacon/ambient.ogg": 14772,
	"./LATEST/block/beacon/deactivate.ogg": 12225,
	"./LATEST/block/beacon/power1.ogg": 545794,
	"./LATEST/block/beacon/power2.ogg": 277529,
	"./LATEST/block/beacon/power3.ogg": 585152,
	"./LATEST/block/beehive/drip1.ogg": 337959,
	"./LATEST/block/beehive/drip2.ogg": 974220,
	"./LATEST/block/beehive/drip3.ogg": 275751,
	"./LATEST/block/beehive/drip4.ogg": 894922,
	"./LATEST/block/beehive/drip5.ogg": 117423,
	"./LATEST/block/beehive/drip6.ogg": 997545,
	"./LATEST/block/beehive/enter.ogg": 730075,
	"./LATEST/block/beehive/exit.ogg": 320520,
	"./LATEST/block/beehive/shear.ogg": 636789,
	"./LATEST/block/beehive/work1.ogg": 465886,
	"./LATEST/block/beehive/work2.ogg": 887619,
	"./LATEST/block/beehive/work3.ogg": 800700,
	"./LATEST/block/beehive/work4.ogg": 742762,
	"./LATEST/block/bell/bell_use01.ogg": 678733,
	"./LATEST/block/bell/bell_use02.ogg": 740322,
	"./LATEST/block/bell/resonate.ogg": 383048,
	"./LATEST/block/big_dripleaf/break1.ogg": 226592,
	"./LATEST/block/big_dripleaf/break2.ogg": 536700,
	"./LATEST/block/big_dripleaf/break3.ogg": 446128,
	"./LATEST/block/big_dripleaf/break4.ogg": 589514,
	"./LATEST/block/big_dripleaf/break5.ogg": 388940,
	"./LATEST/block/big_dripleaf/break6.ogg": 817952,
	"./LATEST/block/big_dripleaf/step1.ogg": 554131,
	"./LATEST/block/big_dripleaf/step2.ogg": 165046,
	"./LATEST/block/big_dripleaf/step3.ogg": 887160,
	"./LATEST/block/big_dripleaf/step4.ogg": 107059,
	"./LATEST/block/big_dripleaf/step5.ogg": 295518,
	"./LATEST/block/big_dripleaf/step6.ogg": 916611,
	"./LATEST/block/big_dripleaf/tilt_down1.ogg": 987043,
	"./LATEST/block/big_dripleaf/tilt_down2.ogg": 206941,
	"./LATEST/block/big_dripleaf/tilt_down3.ogg": 76342,
	"./LATEST/block/big_dripleaf/tilt_down4.ogg": 448859,
	"./LATEST/block/big_dripleaf/tilt_down5.ogg": 522062,
	"./LATEST/block/big_dripleaf/tilt_up1.ogg": 970896,
	"./LATEST/block/big_dripleaf/tilt_up2.ogg": 266454,
	"./LATEST/block/big_dripleaf/tilt_up3.ogg": 505258,
	"./LATEST/block/big_dripleaf/tilt_up4.ogg": 345350,
	"./LATEST/block/blastfurnace/blastfurnace1.ogg": 508281,
	"./LATEST/block/blastfurnace/blastfurnace2.ogg": 867160,
	"./LATEST/block/blastfurnace/blastfurnace3.ogg": 147400,
	"./LATEST/block/blastfurnace/blastfurnace4.ogg": 244791,
	"./LATEST/block/blastfurnace/blastfurnace5.ogg": 44066,
	"./LATEST/block/bone_block/break1.ogg": 816580,
	"./LATEST/block/bone_block/break2.ogg": 47118,
	"./LATEST/block/bone_block/break3.ogg": 204646,
	"./LATEST/block/bone_block/break4.ogg": 265431,
	"./LATEST/block/bone_block/break5.ogg": 79360,
	"./LATEST/block/bone_block/step1.ogg": 347245,
	"./LATEST/block/bone_block/step2.ogg": 219185,
	"./LATEST/block/bone_block/step3.ogg": 478067,
	"./LATEST/block/bone_block/step4.ogg": 31931,
	"./LATEST/block/bone_block/step5.ogg": 180092,
	"./LATEST/block/brewing_stand/brew1.ogg": 764154,
	"./LATEST/block/brewing_stand/brew2.ogg": 263955,
	"./LATEST/block/bubble_column/bubble1.ogg": 775495,
	"./LATEST/block/bubble_column/bubble2.ogg": 271538,
	"./LATEST/block/bubble_column/bubble3.ogg": 882185,
	"./LATEST/block/bubble_column/upwards_ambient1.ogg": 387042,
	"./LATEST/block/bubble_column/upwards_ambient2.ogg": 362056,
	"./LATEST/block/bubble_column/upwards_ambient3.ogg": 285332,
	"./LATEST/block/bubble_column/upwards_ambient4.ogg": 203575,
	"./LATEST/block/bubble_column/upwards_ambient5.ogg": 463834,
	"./LATEST/block/bubble_column/upwards_inside.ogg": 196539,
	"./LATEST/block/bubble_column/whirlpool_ambient1.ogg": 397921,
	"./LATEST/block/bubble_column/whirlpool_ambient2.ogg": 175716,
	"./LATEST/block/bubble_column/whirlpool_ambient3.ogg": 915358,
	"./LATEST/block/bubble_column/whirlpool_ambient4.ogg": 766152,
	"./LATEST/block/bubble_column/whirlpool_ambient5.ogg": 541334,
	"./LATEST/block/bubble_column/whirlpool_inside.ogg": 614774,
	"./LATEST/block/cake/add_candle1.ogg": 722014,
	"./LATEST/block/cake/add_candle2.ogg": 174905,
	"./LATEST/block/cake/add_candle3.ogg": 885994,
	"./LATEST/block/calcite/break1.ogg": 613106,
	"./LATEST/block/calcite/break2.ogg": 749537,
	"./LATEST/block/calcite/break3.ogg": 212740,
	"./LATEST/block/calcite/break4.ogg": 258949,
	"./LATEST/block/calcite/place1.ogg": 277717,
	"./LATEST/block/calcite/place2.ogg": 452159,
	"./LATEST/block/calcite/place3.ogg": 202220,
	"./LATEST/block/calcite/place4.ogg": 515692,
	"./LATEST/block/calcite/step1.ogg": 752042,
	"./LATEST/block/calcite/step2.ogg": 97735,
	"./LATEST/block/calcite/step3.ogg": 101978,
	"./LATEST/block/calcite/step4.ogg": 4276,
	"./LATEST/block/calcite/step5.ogg": 519943,
	"./LATEST/block/calcite/step6.ogg": 496972,
	"./LATEST/block/campfire/crackle1.ogg": 399543,
	"./LATEST/block/campfire/crackle2.ogg": 191380,
	"./LATEST/block/campfire/crackle3.ogg": 370313,
	"./LATEST/block/campfire/crackle4.ogg": 343013,
	"./LATEST/block/campfire/crackle5.ogg": 650815,
	"./LATEST/block/campfire/crackle6.ogg": 40420,
	"./LATEST/block/candle/ambient1.ogg": 510522,
	"./LATEST/block/candle/ambient2.ogg": 875274,
	"./LATEST/block/candle/ambient3.ogg": 844435,
	"./LATEST/block/candle/ambient4.ogg": 301941,
	"./LATEST/block/candle/ambient5.ogg": 117453,
	"./LATEST/block/candle/ambient6.ogg": 200433,
	"./LATEST/block/candle/ambient7.ogg": 451029,
	"./LATEST/block/candle/ambient8.ogg": 506196,
	"./LATEST/block/candle/ambient9.ogg": 951284,
	"./LATEST/block/candle/break1.ogg": 788593,
	"./LATEST/block/candle/break2.ogg": 409909,
	"./LATEST/block/candle/break3.ogg": 423685,
	"./LATEST/block/candle/break4.ogg": 258498,
	"./LATEST/block/candle/break5.ogg": 283431,
	"./LATEST/block/candle/extinguish1.ogg": 165758,
	"./LATEST/block/candle/extinguish2.ogg": 941296,
	"./LATEST/block/candle/extinguish3.ogg": 645125,
	"./LATEST/block/candle/step1.ogg": 848866,
	"./LATEST/block/candle/step2.ogg": 798494,
	"./LATEST/block/candle/step3.ogg": 808777,
	"./LATEST/block/candle/step4.ogg": 987835,
	"./LATEST/block/candle/step5.ogg": 549409,
	"./LATEST/block/cauldron/dye1.ogg": 257397,
	"./LATEST/block/cauldron/dye2.ogg": 568588,
	"./LATEST/block/cauldron/dye3.ogg": 394502,
	"./LATEST/block/cave_vines/break1.ogg": 94754,
	"./LATEST/block/cave_vines/break2.ogg": 635459,
	"./LATEST/block/cave_vines/break3.ogg": 630779,
	"./LATEST/block/cave_vines/break4.ogg": 134347,
	"./LATEST/block/cave_vines/break5.ogg": 125710,
	"./LATEST/block/chain/break1.ogg": 438102,
	"./LATEST/block/chain/break2.ogg": 77620,
	"./LATEST/block/chain/break3.ogg": 306823,
	"./LATEST/block/chain/break4.ogg": 653756,
	"./LATEST/block/chain/step1.ogg": 801327,
	"./LATEST/block/chain/step2.ogg": 452299,
	"./LATEST/block/chain/step3.ogg": 404319,
	"./LATEST/block/chain/step4.ogg": 855181,
	"./LATEST/block/chain/step5.ogg": 281250,
	"./LATEST/block/chain/step6.ogg": 354789,
	"./LATEST/block/cherry_leaves/break1.ogg": 706299,
	"./LATEST/block/cherry_leaves/break2.ogg": 538437,
	"./LATEST/block/cherry_leaves/break3.ogg": 482346,
	"./LATEST/block/cherry_leaves/break4.ogg": 314930,
	"./LATEST/block/cherry_leaves/break5.ogg": 663371,
	"./LATEST/block/cherry_leaves/step1.ogg": 120243,
	"./LATEST/block/cherry_leaves/step2.ogg": 371204,
	"./LATEST/block/cherry_leaves/step3.ogg": 763453,
	"./LATEST/block/cherry_leaves/step4.ogg": 379337,
	"./LATEST/block/cherry_leaves/step5.ogg": 638460,
	"./LATEST/block/cherry_wood/break1.ogg": 816030,
	"./LATEST/block/cherry_wood/break2.ogg": 570372,
	"./LATEST/block/cherry_wood/break3.ogg": 349925,
	"./LATEST/block/cherry_wood/break4.ogg": 959453,
	"./LATEST/block/cherry_wood/break5.ogg": 455320,
	"./LATEST/block/cherry_wood/step1.ogg": 712955,
	"./LATEST/block/cherry_wood/step2.ogg": 447691,
	"./LATEST/block/cherry_wood/step3.ogg": 685836,
	"./LATEST/block/cherry_wood/step4.ogg": 192792,
	"./LATEST/block/cherry_wood/step5.ogg": 219455,
	"./LATEST/block/cherry_wood/step6.ogg": 768817,
	"./LATEST/block/cherry_wood_hanging_sign/break1.ogg": 552746,
	"./LATEST/block/cherry_wood_hanging_sign/break2.ogg": 626572,
	"./LATEST/block/cherry_wood_hanging_sign/break3.ogg": 543387,
	"./LATEST/block/cherry_wood_hanging_sign/break4.ogg": 841810,
	"./LATEST/block/cherry_wood_hanging_sign/step1.ogg": 712881,
	"./LATEST/block/cherry_wood_hanging_sign/step2.ogg": 298907,
	"./LATEST/block/cherry_wood_hanging_sign/step3.ogg": 373187,
	"./LATEST/block/cherry_wood_hanging_sign/step4.ogg": 815214,
	"./LATEST/block/cherrywood_button/cherrywood_click.ogg": 465237,
	"./LATEST/block/cherrywood_door/toggle1.ogg": 392552,
	"./LATEST/block/cherrywood_door/toggle2.ogg": 661784,
	"./LATEST/block/cherrywood_door/toggle3.ogg": 113072,
	"./LATEST/block/cherrywood_door/toggle4.ogg": 916518,
	"./LATEST/block/cherrywood_fence_gate/toggle1.ogg": 820596,
	"./LATEST/block/cherrywood_fence_gate/toggle2.ogg": 857142,
	"./LATEST/block/cherrywood_fence_gate/toggle3.ogg": 720662,
	"./LATEST/block/cherrywood_trapdoor/toggle1.ogg": 406753,
	"./LATEST/block/cherrywood_trapdoor/toggle2.ogg": 226920,
	"./LATEST/block/cherrywood_trapdoor/toggle3.ogg": 62372,
	"./LATEST/block/chest/close1.ogg": 441450,
	"./LATEST/block/chest/close2.ogg": 653508,
	"./LATEST/block/chest/close3.ogg": 833577,
	"./LATEST/block/chest/close_locked.ogg": 166734,
	"./LATEST/block/chest/open.ogg": 702338,
	"./LATEST/block/chest/open_locked.ogg": 690355,
	"./LATEST/block/chiseled_bookshelf/break1.ogg": 533453,
	"./LATEST/block/chiseled_bookshelf/break2.ogg": 501768,
	"./LATEST/block/chiseled_bookshelf/break3.ogg": 610459,
	"./LATEST/block/chiseled_bookshelf/break4.ogg": 681461,
	"./LATEST/block/chiseled_bookshelf/break5.ogg": 221659,
	"./LATEST/block/chiseled_bookshelf/break6.ogg": 216605,
	"./LATEST/block/chiseled_bookshelf/insert1.ogg": 522347,
	"./LATEST/block/chiseled_bookshelf/insert2.ogg": 257701,
	"./LATEST/block/chiseled_bookshelf/insert3.ogg": 19596,
	"./LATEST/block/chiseled_bookshelf/insert4.ogg": 846181,
	"./LATEST/block/chiseled_bookshelf/insert_enchanted1.ogg": 410813,
	"./LATEST/block/chiseled_bookshelf/insert_enchanted2.ogg": 48605,
	"./LATEST/block/chiseled_bookshelf/insert_enchanted3.ogg": 548620,
	"./LATEST/block/chiseled_bookshelf/insert_enchanted4.ogg": 30568,
	"./LATEST/block/chiseled_bookshelf/pickup1.ogg": 401922,
	"./LATEST/block/chiseled_bookshelf/pickup2.ogg": 329170,
	"./LATEST/block/chiseled_bookshelf/pickup3.ogg": 291589,
	"./LATEST/block/chiseled_bookshelf/pickup_enchanted1.ogg": 481355,
	"./LATEST/block/chiseled_bookshelf/pickup_enchanted2.ogg": 53827,
	"./LATEST/block/chiseled_bookshelf/pickup_enchanted3.ogg": 450290,
	"./LATEST/block/chiseled_bookshelf/step1.ogg": 786707,
	"./LATEST/block/chiseled_bookshelf/step2.ogg": 68939,
	"./LATEST/block/chiseled_bookshelf/step3.ogg": 57561,
	"./LATEST/block/chiseled_bookshelf/step4.ogg": 351327,
	"./LATEST/block/chiseled_bookshelf/step5.ogg": 218281,
	"./LATEST/block/chorus_flower/death1.ogg": 764853,
	"./LATEST/block/chorus_flower/death2.ogg": 200755,
	"./LATEST/block/chorus_flower/death3.ogg": 560531,
	"./LATEST/block/chorus_flower/grow1.ogg": 102732,
	"./LATEST/block/chorus_flower/grow2.ogg": 484157,
	"./LATEST/block/chorus_flower/grow3.ogg": 202915,
	"./LATEST/block/chorus_flower/grow4.ogg": 472250,
	"./LATEST/block/composter/empty1.ogg": 853003,
	"./LATEST/block/composter/empty2.ogg": 558139,
	"./LATEST/block/composter/empty3.ogg": 991134,
	"./LATEST/block/composter/fill1.ogg": 592875,
	"./LATEST/block/composter/fill2.ogg": 155181,
	"./LATEST/block/composter/fill3.ogg": 296106,
	"./LATEST/block/composter/fill4.ogg": 356378,
	"./LATEST/block/composter/fill_success1.ogg": 342653,
	"./LATEST/block/composter/fill_success2.ogg": 679070,
	"./LATEST/block/composter/fill_success3.ogg": 340498,
	"./LATEST/block/composter/fill_success4.ogg": 395198,
	"./LATEST/block/composter/ready1.ogg": 269803,
	"./LATEST/block/composter/ready2.ogg": 882692,
	"./LATEST/block/composter/ready3.ogg": 732496,
	"./LATEST/block/composter/ready4.ogg": 931415,
	"./LATEST/block/conduit/activate.ogg": 566829,
	"./LATEST/block/conduit/ambient.ogg": 426704,
	"./LATEST/block/conduit/attack1.ogg": 402180,
	"./LATEST/block/conduit/attack2.ogg": 538991,
	"./LATEST/block/conduit/attack3.ogg": 917001,
	"./LATEST/block/conduit/deactivate.ogg": 654377,
	"./LATEST/block/conduit/short1.ogg": 791822,
	"./LATEST/block/conduit/short2.ogg": 782881,
	"./LATEST/block/conduit/short3.ogg": 712776,
	"./LATEST/block/conduit/short4.ogg": 970490,
	"./LATEST/block/conduit/short5.ogg": 611372,
	"./LATEST/block/conduit/short6.ogg": 275800,
	"./LATEST/block/conduit/short7.ogg": 440561,
	"./LATEST/block/conduit/short8.ogg": 890543,
	"./LATEST/block/conduit/short9.ogg": 11852,
	"./LATEST/block/copper/break1.ogg": 261044,
	"./LATEST/block/copper/break2.ogg": 874359,
	"./LATEST/block/copper/break3.ogg": 251730,
	"./LATEST/block/copper/break4.ogg": 264126,
	"./LATEST/block/copper/step1.ogg": 988480,
	"./LATEST/block/copper/step2.ogg": 580187,
	"./LATEST/block/copper/step3.ogg": 86209,
	"./LATEST/block/copper/step4.ogg": 740594,
	"./LATEST/block/copper/step5.ogg": 743076,
	"./LATEST/block/copper/step6.ogg": 182975,
	"./LATEST/block/crafter/craft.ogg": 670566,
	"./LATEST/block/crafter/fail.ogg": 100151,
	"./LATEST/block/decorated_pot/break1.ogg": 602815,
	"./LATEST/block/decorated_pot/break2.ogg": 176705,
	"./LATEST/block/decorated_pot/break3.ogg": 921565,
	"./LATEST/block/decorated_pot/break4.ogg": 887848,
	"./LATEST/block/decorated_pot/insert1.ogg": 526222,
	"./LATEST/block/decorated_pot/insert2.ogg": 249137,
	"./LATEST/block/decorated_pot/insert3.ogg": 251032,
	"./LATEST/block/decorated_pot/insert4.ogg": 778963,
	"./LATEST/block/decorated_pot/insert_fail1.ogg": 934617,
	"./LATEST/block/decorated_pot/insert_fail2.ogg": 843834,
	"./LATEST/block/decorated_pot/insert_fail3.ogg": 843822,
	"./LATEST/block/decorated_pot/insert_fail4.ogg": 809643,
	"./LATEST/block/decorated_pot/insert_fail5.ogg": 728705,
	"./LATEST/block/decorated_pot/shatter1.ogg": 444927,
	"./LATEST/block/decorated_pot/shatter2.ogg": 919265,
	"./LATEST/block/decorated_pot/shatter3.ogg": 944769,
	"./LATEST/block/decorated_pot/shatter4.ogg": 651853,
	"./LATEST/block/decorated_pot/shatter5.ogg": 587535,
	"./LATEST/block/decorated_pot/shatter6.ogg": 357298,
	"./LATEST/block/decorated_pot/step1.ogg": 271024,
	"./LATEST/block/decorated_pot/step2.ogg": 835503,
	"./LATEST/block/decorated_pot/step3.ogg": 794852,
	"./LATEST/block/decorated_pot/step4.ogg": 211138,
	"./LATEST/block/decorated_pot/step5.ogg": 813337,
	"./LATEST/block/deepslate/break1.ogg": 825819,
	"./LATEST/block/deepslate/break2.ogg": 405043,
	"./LATEST/block/deepslate/break3.ogg": 410318,
	"./LATEST/block/deepslate/break4.ogg": 918621,
	"./LATEST/block/deepslate/place1.ogg": 82605,
	"./LATEST/block/deepslate/place2.ogg": 702044,
	"./LATEST/block/deepslate/place3.ogg": 550783,
	"./LATEST/block/deepslate/place4.ogg": 514608,
	"./LATEST/block/deepslate/place5.ogg": 60633,
	"./LATEST/block/deepslate/place6.ogg": 431636,
	"./LATEST/block/deepslate/step1.ogg": 44618,
	"./LATEST/block/deepslate/step2.ogg": 871505,
	"./LATEST/block/deepslate/step3.ogg": 532604,
	"./LATEST/block/deepslate/step4.ogg": 918182,
	"./LATEST/block/deepslate/step5.ogg": 184058,
	"./LATEST/block/deepslate/step6.ogg": 277633,
	"./LATEST/block/deepslate_bricks/place1.ogg": 903454,
	"./LATEST/block/deepslate_bricks/place2.ogg": 607692,
	"./LATEST/block/deepslate_bricks/place3.ogg": 812077,
	"./LATEST/block/deepslate_bricks/place4.ogg": 317622,
	"./LATEST/block/deepslate_bricks/place5.ogg": 163557,
	"./LATEST/block/deepslate_bricks/place6.ogg": 732148,
	"./LATEST/block/deepslate_bricks/step1.ogg": 506035,
	"./LATEST/block/deepslate_bricks/step2.ogg": 464764,
	"./LATEST/block/deepslate_bricks/step3.ogg": 279821,
	"./LATEST/block/deepslate_bricks/step4.ogg": 231262,
	"./LATEST/block/deepslate_bricks/step5.ogg": 972308,
	"./LATEST/block/dripstone/break1.ogg": 823675,
	"./LATEST/block/dripstone/break2.ogg": 731063,
	"./LATEST/block/dripstone/break3.ogg": 87,
	"./LATEST/block/dripstone/break4.ogg": 578019,
	"./LATEST/block/dripstone/break5.ogg": 448046,
	"./LATEST/block/dripstone/step1.ogg": 783744,
	"./LATEST/block/dripstone/step2.ogg": 347702,
	"./LATEST/block/dripstone/step3.ogg": 369797,
	"./LATEST/block/dripstone/step4.ogg": 957556,
	"./LATEST/block/dripstone/step5.ogg": 959382,
	"./LATEST/block/dripstone/step6.ogg": 778997,
	"./LATEST/block/enchantment_table/enchant1.ogg": 732439,
	"./LATEST/block/enchantment_table/enchant2.ogg": 659510,
	"./LATEST/block/enchantment_table/enchant3.ogg": 81,
	"./LATEST/block/end_portal/endportal.ogg": 119852,
	"./LATEST/block/end_portal/eyeplace1.ogg": 398970,
	"./LATEST/block/end_portal/eyeplace2.ogg": 411708,
	"./LATEST/block/end_portal/eyeplace3.ogg": 466139,
	"./LATEST/block/enderchest/close.ogg": 845129,
	"./LATEST/block/enderchest/open.ogg": 958543,
	"./LATEST/block/fence_gate/close1.ogg": 896097,
	"./LATEST/block/fence_gate/close2.ogg": 794783,
	"./LATEST/block/fence_gate/open1.ogg": 676320,
	"./LATEST/block/fence_gate/open2.ogg": 745609,
	"./LATEST/block/fletching_table/fletching_table1.ogg": 387494,
	"./LATEST/block/fletching_table/fletching_table2.ogg": 693305,
	"./LATEST/block/froglight/break1.ogg": 12206,
	"./LATEST/block/froglight/break2.ogg": 372669,
	"./LATEST/block/froglight/break3.ogg": 435260,
	"./LATEST/block/froglight/break4.ogg": 823737,
	"./LATEST/block/froglight/step1.ogg": 51665,
	"./LATEST/block/froglight/step2.ogg": 253639,
	"./LATEST/block/froglight/step3.ogg": 804288,
	"./LATEST/block/froglight/step4.ogg": 538416,
	"./LATEST/block/froglight/step5.ogg": 369554,
	"./LATEST/block/froglight/step6.ogg": 234299,
	"./LATEST/block/frogspawn/break1.ogg": 653452,
	"./LATEST/block/frogspawn/break2.ogg": 848995,
	"./LATEST/block/frogspawn/break3.ogg": 107156,
	"./LATEST/block/frogspawn/break4.ogg": 571420,
	"./LATEST/block/frogspawn/hatch1.ogg": 986101,
	"./LATEST/block/frogspawn/hatch2.ogg": 416784,
	"./LATEST/block/frogspawn/hatch3.ogg": 121652,
	"./LATEST/block/frogspawn/hatch4.ogg": 894358,
	"./LATEST/block/frogspawn/hatch5.ogg": 391260,
	"./LATEST/block/frogspawn/step1.ogg": 384508,
	"./LATEST/block/frogspawn/step2.ogg": 226945,
	"./LATEST/block/frogspawn/step3.ogg": 194055,
	"./LATEST/block/frogspawn/step4.ogg": 625348,
	"./LATEST/block/frogspawn/step5.ogg": 535594,
	"./LATEST/block/frogspawn/step6.ogg": 791236,
	"./LATEST/block/fungus/break1.ogg": 909456,
	"./LATEST/block/fungus/break2.ogg": 804534,
	"./LATEST/block/fungus/break3.ogg": 398618,
	"./LATEST/block/fungus/break4.ogg": 958462,
	"./LATEST/block/fungus/break5.ogg": 361322,
	"./LATEST/block/fungus/break6.ogg": 161913,
	"./LATEST/block/furnace/fire_crackle1.ogg": 541293,
	"./LATEST/block/furnace/fire_crackle2.ogg": 868809,
	"./LATEST/block/furnace/fire_crackle3.ogg": 546751,
	"./LATEST/block/furnace/fire_crackle4.ogg": 299014,
	"./LATEST/block/furnace/fire_crackle5.ogg": 441819,
	"./LATEST/block/grindstone/grindstone1.ogg": 944294,
	"./LATEST/block/grindstone/grindstone2.ogg": 236402,
	"./LATEST/block/grindstone/grindstone3.ogg": 902955,
	"./LATEST/block/hanging_roots/break1.ogg": 306113,
	"./LATEST/block/hanging_roots/break2.ogg": 690449,
	"./LATEST/block/hanging_roots/break3.ogg": 271979,
	"./LATEST/block/hanging_roots/break4.ogg": 773770,
	"./LATEST/block/hanging_roots/step1.ogg": 839650,
	"./LATEST/block/hanging_roots/step2.ogg": 351302,
	"./LATEST/block/hanging_roots/step3.ogg": 779735,
	"./LATEST/block/hanging_roots/step4.ogg": 665794,
	"./LATEST/block/hanging_roots/step5.ogg": 485806,
	"./LATEST/block/hanging_roots/step6.ogg": 915080,
	"./LATEST/block/hanging_sign/break1.ogg": 790800,
	"./LATEST/block/hanging_sign/break2.ogg": 177359,
	"./LATEST/block/hanging_sign/break3.ogg": 325639,
	"./LATEST/block/hanging_sign/break4.ogg": 656219,
	"./LATEST/block/hanging_sign/step1.ogg": 537556,
	"./LATEST/block/hanging_sign/step2.ogg": 666410,
	"./LATEST/block/hanging_sign/step3.ogg": 132299,
	"./LATEST/block/hanging_sign/step4.ogg": 574753,
	"./LATEST/block/honeyblock/break1.ogg": 30438,
	"./LATEST/block/honeyblock/break2.ogg": 506223,
	"./LATEST/block/honeyblock/break3.ogg": 145201,
	"./LATEST/block/honeyblock/break4.ogg": 271200,
	"./LATEST/block/honeyblock/break5.ogg": 112405,
	"./LATEST/block/honeyblock/slide1.ogg": 120934,
	"./LATEST/block/honeyblock/slide2.ogg": 51629,
	"./LATEST/block/honeyblock/slide3.ogg": 21689,
	"./LATEST/block/honeyblock/slide4.ogg": 650895,
	"./LATEST/block/honeyblock/step1.ogg": 39454,
	"./LATEST/block/honeyblock/step2.ogg": 226161,
	"./LATEST/block/honeyblock/step3.ogg": 883339,
	"./LATEST/block/honeyblock/step4.ogg": 827977,
	"./LATEST/block/honeyblock/step5.ogg": 869883,
	"./LATEST/block/iron_door/close1.ogg": 803904,
	"./LATEST/block/iron_door/close2.ogg": 492987,
	"./LATEST/block/iron_door/close3.ogg": 708955,
	"./LATEST/block/iron_door/close4.ogg": 12540,
	"./LATEST/block/iron_door/open1.ogg": 899093,
	"./LATEST/block/iron_door/open2.ogg": 804725,
	"./LATEST/block/iron_door/open3.ogg": 27372,
	"./LATEST/block/iron_door/open4.ogg": 451648,
	"./LATEST/block/iron_trapdoor/close1.ogg": 965971,
	"./LATEST/block/iron_trapdoor/close2.ogg": 299681,
	"./LATEST/block/iron_trapdoor/close3.ogg": 501393,
	"./LATEST/block/iron_trapdoor/close4.ogg": 704614,
	"./LATEST/block/iron_trapdoor/open1.ogg": 662759,
	"./LATEST/block/iron_trapdoor/open2.ogg": 375762,
	"./LATEST/block/iron_trapdoor/open3.ogg": 671888,
	"./LATEST/block/iron_trapdoor/open4.ogg": 191629,
	"./LATEST/block/lantern/break1.ogg": 299411,
	"./LATEST/block/lantern/break2.ogg": 407698,
	"./LATEST/block/lantern/break3.ogg": 283722,
	"./LATEST/block/lantern/break4.ogg": 239852,
	"./LATEST/block/lantern/break5.ogg": 414148,
	"./LATEST/block/lantern/break6.ogg": 723635,
	"./LATEST/block/lantern/place1.ogg": 589262,
	"./LATEST/block/lantern/place2.ogg": 982316,
	"./LATEST/block/lantern/place3.ogg": 66084,
	"./LATEST/block/lantern/place4.ogg": 200360,
	"./LATEST/block/lantern/place5.ogg": 509808,
	"./LATEST/block/lantern/place6.ogg": 174621,
	"./LATEST/block/lodestone/lock1.ogg": 294499,
	"./LATEST/block/lodestone/lock2.ogg": 734907,
	"./LATEST/block/lodestone/place1.ogg": 292518,
	"./LATEST/block/lodestone/place2.ogg": 390257,
	"./LATEST/block/lodestone/place3.ogg": 232325,
	"./LATEST/block/lodestone/place4.ogg": 110628,
	"./LATEST/block/mangrove_roots/break1.ogg": 409259,
	"./LATEST/block/mangrove_roots/break2.ogg": 857834,
	"./LATEST/block/mangrove_roots/break3.ogg": 8247,
	"./LATEST/block/mangrove_roots/break4.ogg": 526741,
	"./LATEST/block/mangrove_roots/break5.ogg": 943159,
	"./LATEST/block/mangrove_roots/break6.ogg": 931137,
	"./LATEST/block/mangrove_roots/step1.ogg": 121480,
	"./LATEST/block/mangrove_roots/step2.ogg": 343194,
	"./LATEST/block/mangrove_roots/step3.ogg": 869493,
	"./LATEST/block/mangrove_roots/step4.ogg": 603175,
	"./LATEST/block/mangrove_roots/step5.ogg": 73208,
	"./LATEST/block/mangrove_roots/step6.ogg": 216494,
	"./LATEST/block/moss/break1.ogg": 362033,
	"./LATEST/block/moss/break2.ogg": 704400,
	"./LATEST/block/moss/break3.ogg": 4631,
	"./LATEST/block/moss/break4.ogg": 610241,
	"./LATEST/block/moss/break5.ogg": 944042,
	"./LATEST/block/moss/step1.ogg": 154592,
	"./LATEST/block/moss/step2.ogg": 2522,
	"./LATEST/block/moss/step3.ogg": 801335,
	"./LATEST/block/moss/step4.ogg": 897339,
	"./LATEST/block/moss/step5.ogg": 250300,
	"./LATEST/block/moss/step6.ogg": 303804,
	"./LATEST/block/mud/break1.ogg": 638707,
	"./LATEST/block/mud/break2.ogg": 874180,
	"./LATEST/block/mud/break3.ogg": 272967,
	"./LATEST/block/mud/break4.ogg": 514179,
	"./LATEST/block/mud/break5.ogg": 783566,
	"./LATEST/block/mud/break6.ogg": 922505,
	"./LATEST/block/mud/step1.ogg": 95983,
	"./LATEST/block/mud/step2.ogg": 654263,
	"./LATEST/block/mud/step3.ogg": 790614,
	"./LATEST/block/mud/step4.ogg": 480056,
	"./LATEST/block/mud/step5.ogg": 862036,
	"./LATEST/block/mud/step6.ogg": 921704,
	"./LATEST/block/mud_bricks/break1.ogg": 950878,
	"./LATEST/block/mud_bricks/break2.ogg": 294558,
	"./LATEST/block/mud_bricks/break3.ogg": 154690,
	"./LATEST/block/mud_bricks/break4.ogg": 387138,
	"./LATEST/block/mud_bricks/break5.ogg": 531802,
	"./LATEST/block/mud_bricks/break6.ogg": 895149,
	"./LATEST/block/mud_bricks/step1.ogg": 187412,
	"./LATEST/block/mud_bricks/step2.ogg": 969347,
	"./LATEST/block/mud_bricks/step3.ogg": 674018,
	"./LATEST/block/mud_bricks/step4.ogg": 607606,
	"./LATEST/block/mud_bricks/step5.ogg": 178685,
	"./LATEST/block/mud_bricks/step6.ogg": 617968,
	"./LATEST/block/muddy_mangrove_roots/break1.ogg": 951279,
	"./LATEST/block/muddy_mangrove_roots/break2.ogg": 174532,
	"./LATEST/block/muddy_mangrove_roots/break3.ogg": 289058,
	"./LATEST/block/muddy_mangrove_roots/break4.ogg": 661608,
	"./LATEST/block/muddy_mangrove_roots/break5.ogg": 490973,
	"./LATEST/block/muddy_mangrove_roots/break6.ogg": 493121,
	"./LATEST/block/muddy_mangrove_roots/step1.ogg": 944924,
	"./LATEST/block/muddy_mangrove_roots/step2.ogg": 39534,
	"./LATEST/block/muddy_mangrove_roots/step3.ogg": 755196,
	"./LATEST/block/muddy_mangrove_roots/step4.ogg": 472357,
	"./LATEST/block/muddy_mangrove_roots/step5.ogg": 102278,
	"./LATEST/block/muddy_mangrove_roots/step6.ogg": 866975,
	"./LATEST/block/nether_bricks/break1.ogg": 360364,
	"./LATEST/block/nether_bricks/break2.ogg": 256771,
	"./LATEST/block/nether_bricks/break3.ogg": 824012,
	"./LATEST/block/nether_bricks/break4.ogg": 539484,
	"./LATEST/block/nether_bricks/break5.ogg": 559599,
	"./LATEST/block/nether_bricks/break6.ogg": 755235,
	"./LATEST/block/nether_bricks/step1.ogg": 764131,
	"./LATEST/block/nether_bricks/step2.ogg": 19620,
	"./LATEST/block/nether_bricks/step3.ogg": 666437,
	"./LATEST/block/nether_bricks/step4.ogg": 829022,
	"./LATEST/block/nether_bricks/step5.ogg": 403007,
	"./LATEST/block/nether_bricks/step6.ogg": 437265,
	"./LATEST/block/nether_ore/break1.ogg": 380862,
	"./LATEST/block/nether_ore/break2.ogg": 953541,
	"./LATEST/block/nether_ore/break3.ogg": 176649,
	"./LATEST/block/nether_ore/break4.ogg": 649653,
	"./LATEST/block/nether_ore/step1.ogg": 797991,
	"./LATEST/block/nether_ore/step2.ogg": 59827,
	"./LATEST/block/nether_ore/step3.ogg": 865251,
	"./LATEST/block/nether_ore/step4.ogg": 893378,
	"./LATEST/block/nether_ore/step5.ogg": 960264,
	"./LATEST/block/nether_sprouts/break1.ogg": 147978,
	"./LATEST/block/nether_sprouts/break2.ogg": 359005,
	"./LATEST/block/nether_sprouts/break3.ogg": 395359,
	"./LATEST/block/nether_sprouts/break4.ogg": 423452,
	"./LATEST/block/nether_sprouts/step1.ogg": 40475,
	"./LATEST/block/nether_sprouts/step2.ogg": 630046,
	"./LATEST/block/nether_sprouts/step3.ogg": 440165,
	"./LATEST/block/nether_sprouts/step4.ogg": 775625,
	"./LATEST/block/nether_sprouts/step5.ogg": 944648,
	"./LATEST/block/nether_wood/break1.ogg": 450198,
	"./LATEST/block/nether_wood/break2.ogg": 136974,
	"./LATEST/block/nether_wood/break3.ogg": 956896,
	"./LATEST/block/nether_wood/break4.ogg": 902094,
	"./LATEST/block/nether_wood/step1.ogg": 978173,
	"./LATEST/block/nether_wood/step2.ogg": 246936,
	"./LATEST/block/nether_wood/step3.ogg": 605158,
	"./LATEST/block/nether_wood/step4.ogg": 425193,
	"./LATEST/block/nether_wood/step5.ogg": 496720,
	"./LATEST/block/nether_wood_button/nether_wood_button.ogg": 233493,
	"./LATEST/block/nether_wood_door/toggle1.ogg": 12330,
	"./LATEST/block/nether_wood_door/toggle2.ogg": 245387,
	"./LATEST/block/nether_wood_door/toggle3.ogg": 135523,
	"./LATEST/block/nether_wood_door/toggle4.ogg": 251650,
	"./LATEST/block/nether_wood_fence/toggle1.ogg": 502518,
	"./LATEST/block/nether_wood_fence/toggle2.ogg": 517434,
	"./LATEST/block/nether_wood_fence/toggle3.ogg": 434852,
	"./LATEST/block/nether_wood_fence/toggle4.ogg": 3042,
	"./LATEST/block/nether_wood_hanging_sign/break1.ogg": 835656,
	"./LATEST/block/nether_wood_hanging_sign/break2.ogg": 723281,
	"./LATEST/block/nether_wood_hanging_sign/break3.ogg": 9932,
	"./LATEST/block/nether_wood_hanging_sign/break4.ogg": 770928,
	"./LATEST/block/nether_wood_hanging_sign/step1.ogg": 378717,
	"./LATEST/block/nether_wood_hanging_sign/step2.ogg": 173482,
	"./LATEST/block/nether_wood_hanging_sign/step3.ogg": 107014,
	"./LATEST/block/nether_wood_hanging_sign/step4.ogg": 499556,
	"./LATEST/block/nether_wood_trapdoor/toggle1.ogg": 902320,
	"./LATEST/block/nether_wood_trapdoor/toggle2.ogg": 799727,
	"./LATEST/block/nether_wood_trapdoor/toggle3.ogg": 245713,
	"./LATEST/block/nether_wood_trapdoor/toggle4.ogg": 316138,
	"./LATEST/block/netherite/break1.ogg": 335634,
	"./LATEST/block/netherite/break2.ogg": 490731,
	"./LATEST/block/netherite/break3.ogg": 91571,
	"./LATEST/block/netherite/break4.ogg": 106940,
	"./LATEST/block/netherite/step1.ogg": 350159,
	"./LATEST/block/netherite/step2.ogg": 314295,
	"./LATEST/block/netherite/step3.ogg": 76666,
	"./LATEST/block/netherite/step4.ogg": 302741,
	"./LATEST/block/netherite/step5.ogg": 450989,
	"./LATEST/block/netherite/step6.ogg": 288042,
	"./LATEST/block/netherrack/break1.ogg": 760447,
	"./LATEST/block/netherrack/break2.ogg": 273452,
	"./LATEST/block/netherrack/break3.ogg": 987130,
	"./LATEST/block/netherrack/break4.ogg": 184496,
	"./LATEST/block/netherrack/break5.ogg": 647192,
	"./LATEST/block/netherrack/break6.ogg": 350927,
	"./LATEST/block/netherrack/step1.ogg": 357335,
	"./LATEST/block/netherrack/step2.ogg": 972154,
	"./LATEST/block/netherrack/step3.ogg": 915617,
	"./LATEST/block/netherrack/step4.ogg": 324363,
	"./LATEST/block/netherrack/step5.ogg": 742007,
	"./LATEST/block/netherrack/step6.ogg": 234643,
	"./LATEST/block/netherwart/break1.ogg": 89637,
	"./LATEST/block/netherwart/break2.ogg": 790357,
	"./LATEST/block/netherwart/break3.ogg": 56883,
	"./LATEST/block/netherwart/break4.ogg": 589360,
	"./LATEST/block/netherwart/break5.ogg": 703665,
	"./LATEST/block/netherwart/break6.ogg": 872325,
	"./LATEST/block/netherwart/step1.ogg": 843326,
	"./LATEST/block/netherwart/step2.ogg": 39679,
	"./LATEST/block/netherwart/step3.ogg": 903678,
	"./LATEST/block/netherwart/step4.ogg": 518223,
	"./LATEST/block/netherwart/step5.ogg": 972958,
	"./LATEST/block/nylium/break1.ogg": 429456,
	"./LATEST/block/nylium/break2.ogg": 805475,
	"./LATEST/block/nylium/break3.ogg": 924305,
	"./LATEST/block/nylium/break4.ogg": 934430,
	"./LATEST/block/nylium/break5.ogg": 884402,
	"./LATEST/block/nylium/break6.ogg": 427252,
	"./LATEST/block/nylium/step1.ogg": 512575,
	"./LATEST/block/nylium/step2.ogg": 532519,
	"./LATEST/block/nylium/step3.ogg": 611423,
	"./LATEST/block/nylium/step4.ogg": 796471,
	"./LATEST/block/nylium/step5.ogg": 636619,
	"./LATEST/block/nylium/step6.ogg": 398808,
	"./LATEST/block/packed_mud/break1.ogg": 725343,
	"./LATEST/block/packed_mud/break2.ogg": 881013,
	"./LATEST/block/packed_mud/break3.ogg": 769664,
	"./LATEST/block/packed_mud/break4.ogg": 473618,
	"./LATEST/block/packed_mud/break5.ogg": 248361,
	"./LATEST/block/packed_mud/break6.ogg": 115011,
	"./LATEST/block/packed_mud/step1.ogg": 299805,
	"./LATEST/block/packed_mud/step2.ogg": 974325,
	"./LATEST/block/packed_mud/step3.ogg": 803831,
	"./LATEST/block/packed_mud/step4.ogg": 148912,
	"./LATEST/block/packed_mud/step5.ogg": 574123,
	"./LATEST/block/packed_mud/step6.ogg": 791563,
	"./LATEST/block/pointed_dripstone/drip_lava1.ogg": 480997,
	"./LATEST/block/pointed_dripstone/drip_lava2.ogg": 174982,
	"./LATEST/block/pointed_dripstone/drip_lava3.ogg": 510289,
	"./LATEST/block/pointed_dripstone/drip_lava4.ogg": 774881,
	"./LATEST/block/pointed_dripstone/drip_lava5.ogg": 106603,
	"./LATEST/block/pointed_dripstone/drip_lava6.ogg": 788228,
	"./LATEST/block/pointed_dripstone/drip_lava_cauldron1.ogg": 131178,
	"./LATEST/block/pointed_dripstone/drip_lava_cauldron2.ogg": 936204,
	"./LATEST/block/pointed_dripstone/drip_lava_cauldron3.ogg": 28448,
	"./LATEST/block/pointed_dripstone/drip_lava_cauldron4.ogg": 201840,
	"./LATEST/block/pointed_dripstone/drip_water1.ogg": 676251,
	"./LATEST/block/pointed_dripstone/drip_water10.ogg": 189174,
	"./LATEST/block/pointed_dripstone/drip_water11.ogg": 281394,
	"./LATEST/block/pointed_dripstone/drip_water12.ogg": 507331,
	"./LATEST/block/pointed_dripstone/drip_water13.ogg": 31268,
	"./LATEST/block/pointed_dripstone/drip_water14.ogg": 799009,
	"./LATEST/block/pointed_dripstone/drip_water15.ogg": 653316,
	"./LATEST/block/pointed_dripstone/drip_water2.ogg": 452348,
	"./LATEST/block/pointed_dripstone/drip_water3.ogg": 424687,
	"./LATEST/block/pointed_dripstone/drip_water4.ogg": 236699,
	"./LATEST/block/pointed_dripstone/drip_water5.ogg": 499032,
	"./LATEST/block/pointed_dripstone/drip_water6.ogg": 941122,
	"./LATEST/block/pointed_dripstone/drip_water7.ogg": 660504,
	"./LATEST/block/pointed_dripstone/drip_water8.ogg": 813163,
	"./LATEST/block/pointed_dripstone/drip_water9.ogg": 995336,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron1.ogg": 925332,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron2.ogg": 966811,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron3.ogg": 908484,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron4.ogg": 45079,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron5.ogg": 811012,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron6.ogg": 478581,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron7.ogg": 733288,
	"./LATEST/block/pointed_dripstone/drip_water_cauldron8.ogg": 817250,
	"./LATEST/block/pointed_dripstone/land1.ogg": 374312,
	"./LATEST/block/pointed_dripstone/land2.ogg": 545716,
	"./LATEST/block/pointed_dripstone/land3.ogg": 566047,
	"./LATEST/block/pointed_dripstone/land4.ogg": 487922,
	"./LATEST/block/pointed_dripstone/land5.ogg": 105650,
	"./LATEST/block/powder_snow/break1.ogg": 978042,
	"./LATEST/block/powder_snow/break2.ogg": 823505,
	"./LATEST/block/powder_snow/break3.ogg": 340437,
	"./LATEST/block/powder_snow/break4.ogg": 17674,
	"./LATEST/block/powder_snow/break5.ogg": 272268,
	"./LATEST/block/powder_snow/break6.ogg": 365619,
	"./LATEST/block/powder_snow/break7.ogg": 357094,
	"./LATEST/block/powder_snow/step1.ogg": 708707,
	"./LATEST/block/powder_snow/step10.ogg": 471524,
	"./LATEST/block/powder_snow/step2.ogg": 383983,
	"./LATEST/block/powder_snow/step3.ogg": 603403,
	"./LATEST/block/powder_snow/step4.ogg": 698914,
	"./LATEST/block/powder_snow/step5.ogg": 412679,
	"./LATEST/block/powder_snow/step6.ogg": 750118,
	"./LATEST/block/powder_snow/step7.ogg": 244670,
	"./LATEST/block/powder_snow/step8.ogg": 237558,
	"./LATEST/block/powder_snow/step9.ogg": 248668,
	"./LATEST/block/pumpkin/carve1.ogg": 140627,
	"./LATEST/block/pumpkin/carve2.ogg": 136352,
	"./LATEST/block/respawn_anchor/ambient1.ogg": 36410,
	"./LATEST/block/respawn_anchor/ambient2.ogg": 483255,
	"./LATEST/block/respawn_anchor/ambient3.ogg": 862525,
	"./LATEST/block/respawn_anchor/charge1.ogg": 332552,
	"./LATEST/block/respawn_anchor/charge2.ogg": 650477,
	"./LATEST/block/respawn_anchor/charge3.ogg": 790901,
	"./LATEST/block/respawn_anchor/deplete1.ogg": 496561,
	"./LATEST/block/respawn_anchor/deplete2.ogg": 516694,
	"./LATEST/block/respawn_anchor/set_spawn1.ogg": 886101,
	"./LATEST/block/respawn_anchor/set_spawn2.ogg": 536398,
	"./LATEST/block/respawn_anchor/set_spawn3.ogg": 910678,
	"./LATEST/block/rooted_dirt/break1.ogg": 928564,
	"./LATEST/block/rooted_dirt/break2.ogg": 787125,
	"./LATEST/block/rooted_dirt/break3.ogg": 939783,
	"./LATEST/block/rooted_dirt/break4.ogg": 711695,
	"./LATEST/block/rooted_dirt/step1.ogg": 431631,
	"./LATEST/block/rooted_dirt/step2.ogg": 111130,
	"./LATEST/block/rooted_dirt/step3.ogg": 266132,
	"./LATEST/block/rooted_dirt/step4.ogg": 288694,
	"./LATEST/block/rooted_dirt/step5.ogg": 818716,
	"./LATEST/block/rooted_dirt/step6.ogg": 417046,
	"./LATEST/block/roots/break1.ogg": 120020,
	"./LATEST/block/roots/break2.ogg": 42370,
	"./LATEST/block/roots/break3.ogg": 842261,
	"./LATEST/block/roots/break4.ogg": 418361,
	"./LATEST/block/roots/break5.ogg": 698769,
	"./LATEST/block/roots/break6.ogg": 151986,
	"./LATEST/block/roots/step1.ogg": 800076,
	"./LATEST/block/roots/step2.ogg": 198962,
	"./LATEST/block/roots/step3.ogg": 624032,
	"./LATEST/block/roots/step4.ogg": 253943,
	"./LATEST/block/roots/step5.ogg": 38575,
	"./LATEST/block/scaffold/place1.ogg": 348685,
	"./LATEST/block/scaffold/place2.ogg": 502952,
	"./LATEST/block/scaffold/place3.ogg": 24969,
	"./LATEST/block/scaffold/place4.ogg": 678373,
	"./LATEST/block/sculk/break1.ogg": 437690,
	"./LATEST/block/sculk/break10.ogg": 196117,
	"./LATEST/block/sculk/break11.ogg": 237564,
	"./LATEST/block/sculk/break12.ogg": 279499,
	"./LATEST/block/sculk/break13.ogg": 643585,
	"./LATEST/block/sculk/break14.ogg": 518576,
	"./LATEST/block/sculk/break2.ogg": 698895,
	"./LATEST/block/sculk/break3.ogg": 543435,
	"./LATEST/block/sculk/break4.ogg": 785436,
	"./LATEST/block/sculk/break5.ogg": 978583,
	"./LATEST/block/sculk/break6.ogg": 714023,
	"./LATEST/block/sculk/break7.ogg": 916352,
	"./LATEST/block/sculk/break8.ogg": 454499,
	"./LATEST/block/sculk/break9.ogg": 308351,
	"./LATEST/block/sculk/charge1.ogg": 63460,
	"./LATEST/block/sculk/charge2.ogg": 620617,
	"./LATEST/block/sculk/charge3.ogg": 227291,
	"./LATEST/block/sculk/charge4.ogg": 972656,
	"./LATEST/block/sculk/charge5.ogg": 958042,
	"./LATEST/block/sculk/place1.ogg": 765030,
	"./LATEST/block/sculk/place2.ogg": 738751,
	"./LATEST/block/sculk/place3.ogg": 491726,
	"./LATEST/block/sculk/place4.ogg": 886864,
	"./LATEST/block/sculk/place5.ogg": 894685,
	"./LATEST/block/sculk/spread1.ogg": 282772,
	"./LATEST/block/sculk/spread2.ogg": 291444,
	"./LATEST/block/sculk/spread3.ogg": 963568,
	"./LATEST/block/sculk/spread4.ogg": 636342,
	"./LATEST/block/sculk/spread5.ogg": 636529,
	"./LATEST/block/sculk/step1.ogg": 824864,
	"./LATEST/block/sculk/step2.ogg": 649983,
	"./LATEST/block/sculk/step3.ogg": 94708,
	"./LATEST/block/sculk/step4.ogg": 187277,
	"./LATEST/block/sculk/step5.ogg": 986280,
	"./LATEST/block/sculk/step6.ogg": 841878,
	"./LATEST/block/sculk_catalyst/break1.ogg": 192981,
	"./LATEST/block/sculk_catalyst/break10.ogg": 975909,
	"./LATEST/block/sculk_catalyst/break2.ogg": 450516,
	"./LATEST/block/sculk_catalyst/break3.ogg": 511274,
	"./LATEST/block/sculk_catalyst/break4.ogg": 621994,
	"./LATEST/block/sculk_catalyst/break5.ogg": 205628,
	"./LATEST/block/sculk_catalyst/break6.ogg": 371481,
	"./LATEST/block/sculk_catalyst/break7.ogg": 428761,
	"./LATEST/block/sculk_catalyst/break8.ogg": 873818,
	"./LATEST/block/sculk_catalyst/break9.ogg": 161826,
	"./LATEST/block/sculk_catalyst/place1.ogg": 317906,
	"./LATEST/block/sculk_catalyst/place2.ogg": 614993,
	"./LATEST/block/sculk_catalyst/place3.ogg": 182837,
	"./LATEST/block/sculk_catalyst/place4.ogg": 178914,
	"./LATEST/block/sculk_catalyst/place5.ogg": 710420,
	"./LATEST/block/sculk_catalyst/step1.ogg": 643254,
	"./LATEST/block/sculk_catalyst/step2.ogg": 388657,
	"./LATEST/block/sculk_catalyst/step3.ogg": 294868,
	"./LATEST/block/sculk_catalyst/step4.ogg": 475533,
	"./LATEST/block/sculk_catalyst/step5.ogg": 109585,
	"./LATEST/block/sculk_catalyst/step6.ogg": 106996,
	"./LATEST/block/sculk_sensor/break1.ogg": 639515,
	"./LATEST/block/sculk_sensor/break2.ogg": 508241,
	"./LATEST/block/sculk_sensor/break3.ogg": 594406,
	"./LATEST/block/sculk_sensor/break4.ogg": 184625,
	"./LATEST/block/sculk_sensor/break5.ogg": 37088,
	"./LATEST/block/sculk_sensor/place1.ogg": 777479,
	"./LATEST/block/sculk_sensor/place2.ogg": 178999,
	"./LATEST/block/sculk_sensor/place3.ogg": 718123,
	"./LATEST/block/sculk_sensor/place4.ogg": 310480,
	"./LATEST/block/sculk_sensor/place5.ogg": 394153,
	"./LATEST/block/sculk_sensor/sculk_clicking1.ogg": 259867,
	"./LATEST/block/sculk_sensor/sculk_clicking2.ogg": 679757,
	"./LATEST/block/sculk_sensor/sculk_clicking3.ogg": 890003,
	"./LATEST/block/sculk_sensor/sculk_clicking4.ogg": 610798,
	"./LATEST/block/sculk_sensor/sculk_clicking5.ogg": 96908,
	"./LATEST/block/sculk_sensor/sculk_clicking6.ogg": 711218,
	"./LATEST/block/sculk_sensor/sculk_clicking_stop1.ogg": 693813,
	"./LATEST/block/sculk_sensor/sculk_clicking_stop2.ogg": 724995,
	"./LATEST/block/sculk_sensor/sculk_clicking_stop3.ogg": 129454,
	"./LATEST/block/sculk_sensor/sculk_clicking_stop4.ogg": 642000,
	"./LATEST/block/sculk_sensor/sculk_clicking_stop5.ogg": 27067,
	"./LATEST/block/sculk_shrieker/break1.ogg": 270625,
	"./LATEST/block/sculk_shrieker/break2.ogg": 342088,
	"./LATEST/block/sculk_shrieker/break3.ogg": 516629,
	"./LATEST/block/sculk_shrieker/break4.ogg": 920779,
	"./LATEST/block/sculk_shrieker/break5.ogg": 861724,
	"./LATEST/block/sculk_shrieker/break6.ogg": 859867,
	"./LATEST/block/sculk_shrieker/place1.ogg": 565586,
	"./LATEST/block/sculk_shrieker/place2.ogg": 466669,
	"./LATEST/block/sculk_shrieker/place3.ogg": 603608,
	"./LATEST/block/sculk_shrieker/place4.ogg": 743711,
	"./LATEST/block/sculk_shrieker/place5.ogg": 746938,
	"./LATEST/block/sculk_shrieker/shriek1.ogg": 273587,
	"./LATEST/block/sculk_shrieker/shriek2.ogg": 971636,
	"./LATEST/block/sculk_shrieker/shriek3.ogg": 321876,
	"./LATEST/block/sculk_shrieker/shriek4.ogg": 888781,
	"./LATEST/block/sculk_shrieker/shriek5.ogg": 516095,
	"./LATEST/block/sculk_vein/break1.ogg": 806280,
	"./LATEST/block/sculk_vein/break2.ogg": 828013,
	"./LATEST/block/sculk_vein/break3.ogg": 689474,
	"./LATEST/block/sculk_vein/break4.ogg": 157604,
	"./LATEST/block/sculk_vein/break5.ogg": 214407,
	"./LATEST/block/shroomlight/break1.ogg": 15188,
	"./LATEST/block/shroomlight/break2.ogg": 202007,
	"./LATEST/block/shroomlight/break3.ogg": 701328,
	"./LATEST/block/shroomlight/break4.ogg": 165287,
	"./LATEST/block/shroomlight/break5.ogg": 598038,
	"./LATEST/block/shroomlight/step1.ogg": 957850,
	"./LATEST/block/shroomlight/step2.ogg": 708065,
	"./LATEST/block/shroomlight/step3.ogg": 329696,
	"./LATEST/block/shroomlight/step4.ogg": 758382,
	"./LATEST/block/shroomlight/step5.ogg": 704310,
	"./LATEST/block/shroomlight/step6.ogg": 443548,
	"./LATEST/block/shulker_box/close.ogg": 507453,
	"./LATEST/block/shulker_box/open.ogg": 785524,
	"./LATEST/block/sign/waxed_interact_fail1.ogg": 557310,
	"./LATEST/block/sign/waxed_interact_fail2.ogg": 950247,
	"./LATEST/block/sign/waxed_interact_fail3.ogg": 208574,
	"./LATEST/block/smithing_table/smithing_table1.ogg": 133148,
	"./LATEST/block/smithing_table/smithing_table2.ogg": 621368,
	"./LATEST/block/smithing_table/smithing_table3.ogg": 990856,
	"./LATEST/block/smoker/smoker1.ogg": 943142,
	"./LATEST/block/smoker/smoker2.ogg": 610190,
	"./LATEST/block/smoker/smoker3.ogg": 469160,
	"./LATEST/block/smoker/smoker4.ogg": 856410,
	"./LATEST/block/smoker/smoker5.ogg": 975830,
	"./LATEST/block/soul_sand/break1.ogg": 916893,
	"./LATEST/block/soul_sand/break2.ogg": 913791,
	"./LATEST/block/soul_sand/break3.ogg": 172333,
	"./LATEST/block/soul_sand/break4.ogg": 883433,
	"./LATEST/block/soul_sand/break5.ogg": 365356,
	"./LATEST/block/soul_sand/break6.ogg": 495633,
	"./LATEST/block/soul_sand/break7.ogg": 53799,
	"./LATEST/block/soul_sand/break8.ogg": 996963,
	"./LATEST/block/soul_sand/break9.ogg": 657996,
	"./LATEST/block/soul_sand/step1.ogg": 420669,
	"./LATEST/block/soul_sand/step2.ogg": 938064,
	"./LATEST/block/soul_sand/step3.ogg": 880283,
	"./LATEST/block/soul_sand/step4.ogg": 530249,
	"./LATEST/block/soul_sand/step5.ogg": 526032,
	"./LATEST/block/soul_soil/break1.ogg": 924183,
	"./LATEST/block/soul_soil/break2.ogg": 704037,
	"./LATEST/block/soul_soil/break3.ogg": 793355,
	"./LATEST/block/soul_soil/break4.ogg": 429815,
	"./LATEST/block/soul_soil/break5.ogg": 707128,
	"./LATEST/block/soul_soil/break6.ogg": 323009,
	"./LATEST/block/soul_soil/step1.ogg": 828816,
	"./LATEST/block/soul_soil/step2.ogg": 987649,
	"./LATEST/block/soul_soil/step3.ogg": 831095,
	"./LATEST/block/soul_soil/step4.ogg": 460809,
	"./LATEST/block/soul_soil/step5.ogg": 536331,
	"./LATEST/block/sponge/absorb1.ogg": 376881,
	"./LATEST/block/sponge/absorb2.ogg": 703517,
	"./LATEST/block/sponge/absorb3.ogg": 192270,
	"./LATEST/block/sponge/break1.ogg": 539871,
	"./LATEST/block/sponge/break2.ogg": 96314,
	"./LATEST/block/sponge/break3.ogg": 419282,
	"./LATEST/block/sponge/break4.ogg": 593423,
	"./LATEST/block/sponge/step1.ogg": 375959,
	"./LATEST/block/sponge/step2.ogg": 194615,
	"./LATEST/block/sponge/step3.ogg": 18776,
	"./LATEST/block/sponge/step4.ogg": 367894,
	"./LATEST/block/sponge/step5.ogg": 527852,
	"./LATEST/block/sponge/step6.ogg": 973144,
	"./LATEST/block/sponge/wet_sponge/break1.ogg": 818739,
	"./LATEST/block/sponge/wet_sponge/break2.ogg": 528940,
	"./LATEST/block/sponge/wet_sponge/break3.ogg": 217768,
	"./LATEST/block/sponge/wet_sponge/break4.ogg": 655072,
	"./LATEST/block/sponge/wet_sponge/step1.ogg": 84501,
	"./LATEST/block/sponge/wet_sponge/step2.ogg": 231036,
	"./LATEST/block/sponge/wet_sponge/step3.ogg": 62834,
	"./LATEST/block/sponge/wet_sponge/step4.ogg": 701198,
	"./LATEST/block/spore_blossom/break1.ogg": 77309,
	"./LATEST/block/spore_blossom/break2.ogg": 18186,
	"./LATEST/block/spore_blossom/break3.ogg": 670774,
	"./LATEST/block/spore_blossom/break4.ogg": 826755,
	"./LATEST/block/spore_blossom/break5.ogg": 610343,
	"./LATEST/block/spore_blossom/step1.ogg": 838255,
	"./LATEST/block/spore_blossom/step2.ogg": 600152,
	"./LATEST/block/spore_blossom/step3.ogg": 918820,
	"./LATEST/block/spore_blossom/step4.ogg": 946623,
	"./LATEST/block/spore_blossom/step5.ogg": 824338,
	"./LATEST/block/spore_blossom/step6.ogg": 143162,
	"./LATEST/block/stem/break1.ogg": 770307,
	"./LATEST/block/stem/break2.ogg": 234046,
	"./LATEST/block/stem/break3.ogg": 100465,
	"./LATEST/block/stem/break4.ogg": 943120,
	"./LATEST/block/stem/break5.ogg": 294612,
	"./LATEST/block/stem/break6.ogg": 317392,
	"./LATEST/block/stem/step1.ogg": 271028,
	"./LATEST/block/stem/step2.ogg": 534292,
	"./LATEST/block/stem/step3.ogg": 72773,
	"./LATEST/block/stem/step4.ogg": 346584,
	"./LATEST/block/stem/step5.ogg": 213344,
	"./LATEST/block/stem/step6.ogg": 112399,
	"./LATEST/block/suspicious_gravel/break1.ogg": 699888,
	"./LATEST/block/suspicious_gravel/break2.ogg": 527449,
	"./LATEST/block/suspicious_gravel/break3.ogg": 833614,
	"./LATEST/block/suspicious_gravel/break4.ogg": 251796,
	"./LATEST/block/suspicious_gravel/break5.ogg": 587928,
	"./LATEST/block/suspicious_gravel/break6.ogg": 880156,
	"./LATEST/block/suspicious_gravel/place1.ogg": 223235,
	"./LATEST/block/suspicious_gravel/place2.ogg": 363748,
	"./LATEST/block/suspicious_gravel/place3.ogg": 393800,
	"./LATEST/block/suspicious_gravel/place4.ogg": 250088,
	"./LATEST/block/suspicious_gravel/step1.ogg": 761016,
	"./LATEST/block/suspicious_gravel/step2.ogg": 891449,
	"./LATEST/block/suspicious_gravel/step3.ogg": 814648,
	"./LATEST/block/suspicious_gravel/step4.ogg": 52913,
	"./LATEST/block/suspicious_sand/break1.ogg": 931551,
	"./LATEST/block/suspicious_sand/break2.ogg": 126907,
	"./LATEST/block/suspicious_sand/break3.ogg": 326788,
	"./LATEST/block/suspicious_sand/break4.ogg": 103397,
	"./LATEST/block/suspicious_sand/break5.ogg": 342852,
	"./LATEST/block/suspicious_sand/break6.ogg": 184523,
	"./LATEST/block/suspicious_sand/place1.ogg": 120482,
	"./LATEST/block/suspicious_sand/place2.ogg": 888406,
	"./LATEST/block/suspicious_sand/place3.ogg": 925568,
	"./LATEST/block/suspicious_sand/place4.ogg": 984073,
	"./LATEST/block/suspicious_sand/place5.ogg": 244262,
	"./LATEST/block/suspicious_sand/step1.ogg": 881284,
	"./LATEST/block/suspicious_sand/step2.ogg": 574524,
	"./LATEST/block/suspicious_sand/step3.ogg": 398067,
	"./LATEST/block/suspicious_sand/step4.ogg": 118228,
	"./LATEST/block/suspicious_sand/step5.ogg": 677823,
	"./LATEST/block/sweet_berry_bush/break1.ogg": 394042,
	"./LATEST/block/sweet_berry_bush/break2.ogg": 923141,
	"./LATEST/block/sweet_berry_bush/break3.ogg": 160069,
	"./LATEST/block/sweet_berry_bush/break4.ogg": 638683,
	"./LATEST/block/sweet_berry_bush/place1.ogg": 397316,
	"./LATEST/block/sweet_berry_bush/place2.ogg": 442112,
	"./LATEST/block/sweet_berry_bush/place3.ogg": 741247,
	"./LATEST/block/sweet_berry_bush/place4.ogg": 430956,
	"./LATEST/block/sweet_berry_bush/place5.ogg": 379596,
	"./LATEST/block/sweet_berry_bush/place6.ogg": 744274,
	"./LATEST/block/tuff/break1.ogg": 668448,
	"./LATEST/block/tuff/break2.ogg": 240818,
	"./LATEST/block/tuff/break3.ogg": 530612,
	"./LATEST/block/tuff/break4.ogg": 274877,
	"./LATEST/block/tuff/break5.ogg": 637214,
	"./LATEST/block/tuff/step1.ogg": 650016,
	"./LATEST/block/tuff/step2.ogg": 443703,
	"./LATEST/block/tuff/step3.ogg": 474914,
	"./LATEST/block/tuff/step4.ogg": 164949,
	"./LATEST/block/tuff/step5.ogg": 237561,
	"./LATEST/block/tuff/step6.ogg": 568201,
	"./LATEST/block/vine/break1.ogg": 198667,
	"./LATEST/block/vine/break2.ogg": 162742,
	"./LATEST/block/vine/break3.ogg": 581035,
	"./LATEST/block/vine/break4.ogg": 148292,
	"./LATEST/block/vine/climb1.ogg": 829231,
	"./LATEST/block/vine/climb2.ogg": 934887,
	"./LATEST/block/vine/climb3.ogg": 686513,
	"./LATEST/block/vine/climb4.ogg": 775188,
	"./LATEST/block/vine/climb5.ogg": 891857,
	"./LATEST/block/waterlily/place1.ogg": 946377,
	"./LATEST/block/waterlily/place2.ogg": 168294,
	"./LATEST/block/waterlily/place3.ogg": 769805,
	"./LATEST/block/waterlily/place4.ogg": 453908,
	"./LATEST/block/wooden_door/close1.ogg": 137556,
	"./LATEST/block/wooden_door/close2.ogg": 471429,
	"./LATEST/block/wooden_door/close3.ogg": 764061,
	"./LATEST/block/wooden_door/open1.ogg": 487616,
	"./LATEST/block/wooden_door/open2.ogg": 624996,
	"./LATEST/block/wooden_trapdoor/close1.ogg": 86265,
	"./LATEST/block/wooden_trapdoor/close2.ogg": 617909,
	"./LATEST/block/wooden_trapdoor/close3.ogg": 803100,
	"./LATEST/block/wooden_trapdoor/open1.ogg": 806318,
	"./LATEST/block/wooden_trapdoor/open2.ogg": 741765,
	"./LATEST/block/wooden_trapdoor/open3.ogg": 40900,
	"./LATEST/block/wooden_trapdoor/open4.ogg": 412400,
	"./LATEST/block/wooden_trapdoor/open5.ogg": 980451,
	"./LATEST/damage/fallbig.ogg": 339252,
	"./LATEST/damage/fallsmall.ogg": 815506,
	"./LATEST/damage/hit1.ogg": 821612,
	"./LATEST/damage/hit2.ogg": 9100,
	"./LATEST/damage/hit3.ogg": 175360,
	"./LATEST/dig/cloth1.ogg": 141534,
	"./LATEST/dig/cloth2.ogg": 46220,
	"./LATEST/dig/cloth3.ogg": 311028,
	"./LATEST/dig/cloth4.ogg": 396219,
	"./LATEST/dig/coral1.ogg": 906201,
	"./LATEST/dig/coral2.ogg": 318457,
	"./LATEST/dig/coral3.ogg": 561078,
	"./LATEST/dig/coral4.ogg": 263363,
	"./LATEST/dig/grass1.ogg": 226474,
	"./LATEST/dig/grass2.ogg": 288022,
	"./LATEST/dig/grass3.ogg": 51986,
	"./LATEST/dig/grass4.ogg": 281669,
	"./LATEST/dig/gravel1.ogg": 359917,
	"./LATEST/dig/gravel2.ogg": 459831,
	"./LATEST/dig/gravel3.ogg": 868675,
	"./LATEST/dig/gravel4.ogg": 339387,
	"./LATEST/dig/sand1.ogg": 445018,
	"./LATEST/dig/sand2.ogg": 608641,
	"./LATEST/dig/sand3.ogg": 181464,
	"./LATEST/dig/sand4.ogg": 597179,
	"./LATEST/dig/snow1.ogg": 412767,
	"./LATEST/dig/snow2.ogg": 56174,
	"./LATEST/dig/snow3.ogg": 121147,
	"./LATEST/dig/snow4.ogg": 966428,
	"./LATEST/dig/stone1.ogg": 970740,
	"./LATEST/dig/stone2.ogg": 405928,
	"./LATEST/dig/stone3.ogg": 908,
	"./LATEST/dig/stone4.ogg": 639986,
	"./LATEST/dig/wet_grass1.ogg": 514782,
	"./LATEST/dig/wet_grass2.ogg": 491860,
	"./LATEST/dig/wet_grass3.ogg": 550308,
	"./LATEST/dig/wet_grass4.ogg": 460828,
	"./LATEST/dig/wood1.ogg": 883172,
	"./LATEST/dig/wood2.ogg": 307716,
	"./LATEST/dig/wood3.ogg": 711902,
	"./LATEST/dig/wood4.ogg": 935117,
	"./LATEST/enchant/soulspeed/soulspeed1.ogg": 673707,
	"./LATEST/enchant/soulspeed/soulspeed10.ogg": 145788,
	"./LATEST/enchant/soulspeed/soulspeed11.ogg": 283074,
	"./LATEST/enchant/soulspeed/soulspeed12.ogg": 380722,
	"./LATEST/enchant/soulspeed/soulspeed13.ogg": 59923,
	"./LATEST/enchant/soulspeed/soulspeed2.ogg": 266027,
	"./LATEST/enchant/soulspeed/soulspeed3.ogg": 517332,
	"./LATEST/enchant/soulspeed/soulspeed4.ogg": 850288,
	"./LATEST/enchant/soulspeed/soulspeed5.ogg": 483825,
	"./LATEST/enchant/soulspeed/soulspeed6.ogg": 904874,
	"./LATEST/enchant/soulspeed/soulspeed7.ogg": 518911,
	"./LATEST/enchant/soulspeed/soulspeed8.ogg": 352867,
	"./LATEST/enchant/soulspeed/soulspeed9.ogg": 445932,
	"./LATEST/enchant/thorns/hit1.ogg": 226557,
	"./LATEST/enchant/thorns/hit2.ogg": 613708,
	"./LATEST/enchant/thorns/hit3.ogg": 341549,
	"./LATEST/enchant/thorns/hit4.ogg": 572195,
	"./LATEST/entity/armorstand/break1.ogg": 989657,
	"./LATEST/entity/armorstand/break2.ogg": 667493,
	"./LATEST/entity/armorstand/break3.ogg": 773568,
	"./LATEST/entity/armorstand/break4.ogg": 27053,
	"./LATEST/entity/armorstand/hit1.ogg": 472934,
	"./LATEST/entity/armorstand/hit2.ogg": 594984,
	"./LATEST/entity/armorstand/hit3.ogg": 882581,
	"./LATEST/entity/armorstand/hit4.ogg": 584779,
	"./LATEST/entity/boat/paddle_land1.ogg": 165760,
	"./LATEST/entity/boat/paddle_land2.ogg": 166910,
	"./LATEST/entity/boat/paddle_land3.ogg": 169534,
	"./LATEST/entity/boat/paddle_land4.ogg": 83970,
	"./LATEST/entity/boat/paddle_land5.ogg": 566804,
	"./LATEST/entity/boat/paddle_land6.ogg": 822671,
	"./LATEST/entity/boat/paddle_water1.ogg": 779913,
	"./LATEST/entity/boat/paddle_water2.ogg": 922796,
	"./LATEST/entity/boat/paddle_water3.ogg": 14321,
	"./LATEST/entity/boat/paddle_water4.ogg": 880128,
	"./LATEST/entity/boat/paddle_water5.ogg": 416678,
	"./LATEST/entity/boat/paddle_water6.ogg": 486364,
	"./LATEST/entity/boat/paddle_water7.ogg": 67927,
	"./LATEST/entity/boat/paddle_water8.ogg": 120851,
	"./LATEST/entity/bobber/castfast.ogg": 782133,
	"./LATEST/entity/bobber/retrieve1.ogg": 801351,
	"./LATEST/entity/bobber/retrieve2.ogg": 579749,
	"./LATEST/entity/bobber/retrieve3.ogg": 454228,
	"./LATEST/entity/cow/milk1.ogg": 703557,
	"./LATEST/entity/cow/milk2.ogg": 316746,
	"./LATEST/entity/cow/milk3.ogg": 630945,
	"./LATEST/entity/endereye/dead1.ogg": 703911,
	"./LATEST/entity/endereye/dead2.ogg": 810310,
	"./LATEST/entity/endereye/endereye_launch1.ogg": 127802,
	"./LATEST/entity/endereye/endereye_launch2.ogg": 230429,
	"./LATEST/entity/fish/flop1.ogg": 948414,
	"./LATEST/entity/fish/flop2.ogg": 556531,
	"./LATEST/entity/fish/flop3.ogg": 890403,
	"./LATEST/entity/fish/flop4.ogg": 300360,
	"./LATEST/entity/fish/hurt1.ogg": 642267,
	"./LATEST/entity/fish/hurt2.ogg": 137779,
	"./LATEST/entity/fish/hurt3.ogg": 94367,
	"./LATEST/entity/fish/hurt4.ogg": 341777,
	"./LATEST/entity/fish/swim1.ogg": 795162,
	"./LATEST/entity/fish/swim2.ogg": 523535,
	"./LATEST/entity/fish/swim3.ogg": 520503,
	"./LATEST/entity/fish/swim4.ogg": 198510,
	"./LATEST/entity/fish/swim5.ogg": 512381,
	"./LATEST/entity/fish/swim6.ogg": 182727,
	"./LATEST/entity/fish/swim7.ogg": 658528,
	"./LATEST/entity/glow_squid/ambient1.ogg": 111373,
	"./LATEST/entity/glow_squid/ambient2.ogg": 124718,
	"./LATEST/entity/glow_squid/ambient3.ogg": 78773,
	"./LATEST/entity/glow_squid/ambient4.ogg": 175249,
	"./LATEST/entity/glow_squid/ambient5.ogg": 621766,
	"./LATEST/entity/glow_squid/death1.ogg": 866197,
	"./LATEST/entity/glow_squid/death2.ogg": 36068,
	"./LATEST/entity/glow_squid/death3.ogg": 590419,
	"./LATEST/entity/glow_squid/hurt1.ogg": 293337,
	"./LATEST/entity/glow_squid/hurt2.ogg": 299183,
	"./LATEST/entity/glow_squid/hurt3.ogg": 512990,
	"./LATEST/entity/glow_squid/hurt4.ogg": 738869,
	"./LATEST/entity/glow_squid/squirt1.ogg": 532562,
	"./LATEST/entity/glow_squid/squirt2.ogg": 179606,
	"./LATEST/entity/glow_squid/squirt3.ogg": 741353,
	"./LATEST/entity/guardian/ambient1.ogg": 543638,
	"./LATEST/entity/guardian/ambient2.ogg": 53719,
	"./LATEST/entity/guardian/ambient3.ogg": 790320,
	"./LATEST/entity/guardian/ambient4.ogg": 283559,
	"./LATEST/entity/horse/eat1.ogg": 507715,
	"./LATEST/entity/horse/eat2.ogg": 840317,
	"./LATEST/entity/horse/eat3.ogg": 641249,
	"./LATEST/entity/horse/eat4.ogg": 920183,
	"./LATEST/entity/horse/eat5.ogg": 100368,
	"./LATEST/entity/itemframe/add_item1.ogg": 533701,
	"./LATEST/entity/itemframe/add_item2.ogg": 99802,
	"./LATEST/entity/itemframe/add_item3.ogg": 130903,
	"./LATEST/entity/itemframe/add_item4.ogg": 708444,
	"./LATEST/entity/itemframe/break1.ogg": 668863,
	"./LATEST/entity/itemframe/break2.ogg": 915382,
	"./LATEST/entity/itemframe/break3.ogg": 355025,
	"./LATEST/entity/itemframe/place1.ogg": 645796,
	"./LATEST/entity/itemframe/place2.ogg": 586383,
	"./LATEST/entity/itemframe/place3.ogg": 996516,
	"./LATEST/entity/itemframe/place4.ogg": 814942,
	"./LATEST/entity/itemframe/remove_item1.ogg": 141221,
	"./LATEST/entity/itemframe/remove_item2.ogg": 320242,
	"./LATEST/entity/itemframe/remove_item3.ogg": 783789,
	"./LATEST/entity/itemframe/remove_item4.ogg": 558329,
	"./LATEST/entity/itemframe/rotate_item1.ogg": 912520,
	"./LATEST/entity/itemframe/rotate_item2.ogg": 30339,
	"./LATEST/entity/itemframe/rotate_item3.ogg": 457071,
	"./LATEST/entity/itemframe/rotate_item4.ogg": 983558,
	"./LATEST/entity/leashknot/break1.ogg": 315320,
	"./LATEST/entity/leashknot/break2.ogg": 427609,
	"./LATEST/entity/leashknot/break3.ogg": 772394,
	"./LATEST/entity/leashknot/place1.ogg": 771311,
	"./LATEST/entity/leashknot/place2.ogg": 910373,
	"./LATEST/entity/leashknot/place3.ogg": 746061,
	"./LATEST/entity/painting/break1.ogg": 962012,
	"./LATEST/entity/painting/break2.ogg": 25781,
	"./LATEST/entity/painting/break3.ogg": 805715,
	"./LATEST/entity/painting/place1.ogg": 403644,
	"./LATEST/entity/painting/place2.ogg": 270629,
	"./LATEST/entity/painting/place3.ogg": 871341,
	"./LATEST/entity/painting/place4.ogg": 77355,
	"./LATEST/entity/player/attack/crit1.ogg": 912498,
	"./LATEST/entity/player/attack/crit2.ogg": 114244,
	"./LATEST/entity/player/attack/crit3.ogg": 57216,
	"./LATEST/entity/player/attack/knockback1.ogg": 329536,
	"./LATEST/entity/player/attack/knockback2.ogg": 933282,
	"./LATEST/entity/player/attack/knockback3.ogg": 788239,
	"./LATEST/entity/player/attack/knockback4.ogg": 994317,
	"./LATEST/entity/player/attack/strong1.ogg": 466968,
	"./LATEST/entity/player/attack/strong2.ogg": 305746,
	"./LATEST/entity/player/attack/strong3.ogg": 804375,
	"./LATEST/entity/player/attack/strong4.ogg": 336775,
	"./LATEST/entity/player/attack/strong5.ogg": 935578,
	"./LATEST/entity/player/attack/strong6.ogg": 895583,
	"./LATEST/entity/player/attack/sweep1.ogg": 458852,
	"./LATEST/entity/player/attack/sweep2.ogg": 685007,
	"./LATEST/entity/player/attack/sweep3.ogg": 772122,
	"./LATEST/entity/player/attack/sweep4.ogg": 343162,
	"./LATEST/entity/player/attack/sweep5.ogg": 649244,
	"./LATEST/entity/player/attack/sweep6.ogg": 355738,
	"./LATEST/entity/player/attack/sweep7.ogg": 280322,
	"./LATEST/entity/player/attack/weak1.ogg": 52367,
	"./LATEST/entity/player/attack/weak2.ogg": 481031,
	"./LATEST/entity/player/attack/weak3.ogg": 918308,
	"./LATEST/entity/player/attack/weak4.ogg": 845024,
	"./LATEST/entity/player/hurt/berrybush_hurt1.ogg": 683340,
	"./LATEST/entity/player/hurt/berrybush_hurt2.ogg": 883599,
	"./LATEST/entity/player/hurt/drown1.ogg": 42184,
	"./LATEST/entity/player/hurt/drown2.ogg": 492536,
	"./LATEST/entity/player/hurt/drown3.ogg": 737047,
	"./LATEST/entity/player/hurt/drown4.ogg": 866448,
	"./LATEST/entity/player/hurt/fire_hurt1.ogg": 517809,
	"./LATEST/entity/player/hurt/fire_hurt2.ogg": 927661,
	"./LATEST/entity/player/hurt/fire_hurt3.ogg": 32987,
	"./LATEST/entity/player/hurt/freeze_hurt1.ogg": 22458,
	"./LATEST/entity/player/hurt/freeze_hurt2.ogg": 144920,
	"./LATEST/entity/player/hurt/freeze_hurt3.ogg": 664896,
	"./LATEST/entity/player/hurt/freeze_hurt4.ogg": 273149,
	"./LATEST/entity/player/hurt/freeze_hurt5.ogg": 60453,
	"./LATEST/entity/pufferfish/blow_out1.ogg": 610950,
	"./LATEST/entity/pufferfish/blow_out2.ogg": 324057,
	"./LATEST/entity/pufferfish/blow_up1.ogg": 346745,
	"./LATEST/entity/pufferfish/blow_up2.ogg": 747469,
	"./LATEST/entity/pufferfish/death1.ogg": 891373,
	"./LATEST/entity/pufferfish/death2.ogg": 452220,
	"./LATEST/entity/pufferfish/flop1.ogg": 376841,
	"./LATEST/entity/pufferfish/flop2.ogg": 176519,
	"./LATEST/entity/pufferfish/flop3.ogg": 929690,
	"./LATEST/entity/pufferfish/flop4.ogg": 918652,
	"./LATEST/entity/pufferfish/hurt1.ogg": 857897,
	"./LATEST/entity/pufferfish/hurt2.ogg": 211606,
	"./LATEST/entity/pufferfish/sting1.ogg": 863526,
	"./LATEST/entity/pufferfish/sting2.ogg": 880319,
	"./LATEST/entity/rabbit/attack1.ogg": 462259,
	"./LATEST/entity/rabbit/attack2.ogg": 187181,
	"./LATEST/entity/rabbit/attack3.ogg": 218162,
	"./LATEST/entity/rabbit/attack4.ogg": 324765,
	"./LATEST/entity/shulker/ambient1.ogg": 400108,
	"./LATEST/entity/shulker/ambient2.ogg": 707054,
	"./LATEST/entity/shulker/ambient3.ogg": 651978,
	"./LATEST/entity/shulker/ambient4.ogg": 691829,
	"./LATEST/entity/shulker/ambient5.ogg": 796440,
	"./LATEST/entity/shulker/ambient6.ogg": 774404,
	"./LATEST/entity/shulker/ambient7.ogg": 966218,
	"./LATEST/entity/shulker/close1.ogg": 667347,
	"./LATEST/entity/shulker/close2.ogg": 913679,
	"./LATEST/entity/shulker/close3.ogg": 911902,
	"./LATEST/entity/shulker/close4.ogg": 88707,
	"./LATEST/entity/shulker/close5.ogg": 601496,
	"./LATEST/entity/shulker/death1.ogg": 381695,
	"./LATEST/entity/shulker/death2.ogg": 710628,
	"./LATEST/entity/shulker/death3.ogg": 900488,
	"./LATEST/entity/shulker/death4.ogg": 686309,
	"./LATEST/entity/shulker/hurt1.ogg": 741988,
	"./LATEST/entity/shulker/hurt2.ogg": 813319,
	"./LATEST/entity/shulker/hurt3.ogg": 259534,
	"./LATEST/entity/shulker/hurt4.ogg": 688598,
	"./LATEST/entity/shulker/hurt_closed1.ogg": 186114,
	"./LATEST/entity/shulker/hurt_closed2.ogg": 27036,
	"./LATEST/entity/shulker/hurt_closed3.ogg": 82755,
	"./LATEST/entity/shulker/hurt_closed4.ogg": 896378,
	"./LATEST/entity/shulker/hurt_closed5.ogg": 906927,
	"./LATEST/entity/shulker/open1.ogg": 978391,
	"./LATEST/entity/shulker/open2.ogg": 126863,
	"./LATEST/entity/shulker/open3.ogg": 847251,
	"./LATEST/entity/shulker/open4.ogg": 496952,
	"./LATEST/entity/shulker/open5.ogg": 194150,
	"./LATEST/entity/shulker/shoot1.ogg": 356815,
	"./LATEST/entity/shulker/shoot2.ogg": 152965,
	"./LATEST/entity/shulker/shoot3.ogg": 225738,
	"./LATEST/entity/shulker/shoot4.ogg": 954345,
	"./LATEST/entity/shulker_bullet/hit1.ogg": 950800,
	"./LATEST/entity/shulker_bullet/hit2.ogg": 647172,
	"./LATEST/entity/shulker_bullet/hit3.ogg": 149313,
	"./LATEST/entity/shulker_bullet/hit4.ogg": 476591,
	"./LATEST/entity/snowman/death1.ogg": 145041,
	"./LATEST/entity/snowman/death2.ogg": 681247,
	"./LATEST/entity/snowman/death3.ogg": 780017,
	"./LATEST/entity/snowman/hurt1.ogg": 32453,
	"./LATEST/entity/snowman/hurt2.ogg": 360670,
	"./LATEST/entity/snowman/hurt3.ogg": 332216,
	"./LATEST/entity/squid/ambient1.ogg": 12734,
	"./LATEST/entity/squid/ambient2.ogg": 37063,
	"./LATEST/entity/squid/ambient3.ogg": 932907,
	"./LATEST/entity/squid/ambient4.ogg": 75269,
	"./LATEST/entity/squid/ambient5.ogg": 260734,
	"./LATEST/entity/squid/death1.ogg": 6044,
	"./LATEST/entity/squid/death2.ogg": 734898,
	"./LATEST/entity/squid/death3.ogg": 689135,
	"./LATEST/entity/squid/hurt1.ogg": 735407,
	"./LATEST/entity/squid/hurt2.ogg": 160148,
	"./LATEST/entity/squid/hurt3.ogg": 88648,
	"./LATEST/entity/squid/hurt4.ogg": 626263,
	"./LATEST/entity/squid/squirt1.ogg": 139548,
	"./LATEST/entity/squid/squirt2.ogg": 36947,
	"./LATEST/entity/squid/squirt3.ogg": 458395,
	"./LATEST/entity/witch/ambient1.ogg": 149130,
	"./LATEST/entity/witch/ambient2.ogg": 810172,
	"./LATEST/entity/witch/ambient3.ogg": 591664,
	"./LATEST/entity/witch/ambient4.ogg": 133928,
	"./LATEST/entity/witch/ambient5.ogg": 603033,
	"./LATEST/entity/witch/celebrate.ogg": 672689,
	"./LATEST/entity/witch/death1.ogg": 192721,
	"./LATEST/entity/witch/death2.ogg": 729688,
	"./LATEST/entity/witch/death3.ogg": 157535,
	"./LATEST/entity/witch/drink1.ogg": 23731,
	"./LATEST/entity/witch/drink2.ogg": 335908,
	"./LATEST/entity/witch/drink3.ogg": 69819,
	"./LATEST/entity/witch/drink4.ogg": 455339,
	"./LATEST/entity/witch/hurt1.ogg": 303667,
	"./LATEST/entity/witch/hurt2.ogg": 270657,
	"./LATEST/entity/witch/hurt3.ogg": 224954,
	"./LATEST/entity/witch/throw1.ogg": 478411,
	"./LATEST/entity/witch/throw2.ogg": 351080,
	"./LATEST/entity/witch/throw3.ogg": 35867,
	"./LATEST/event/raid/raidhorn_01.ogg": 748207,
	"./LATEST/event/raid/raidhorn_02.ogg": 786726,
	"./LATEST/event/raid/raidhorn_03.ogg": 681882,
	"./LATEST/event/raid/raidhorn_04.ogg": 942175,
	"./LATEST/fire/fire.ogg": 989162,
	"./LATEST/fire/ignite.ogg": 819289,
	"./LATEST/fireworks/blast1.ogg": 930275,
	"./LATEST/fireworks/blast_far1.ogg": 501099,
	"./LATEST/fireworks/largeblast1.ogg": 86998,
	"./LATEST/fireworks/largeblast_far1.ogg": 608859,
	"./LATEST/fireworks/launch1.ogg": 39119,
	"./LATEST/fireworks/twinkle1.ogg": 703209,
	"./LATEST/fireworks/twinkle_far1.ogg": 358822,
	"./LATEST/item/armor/equip_chain1.ogg": 402890,
	"./LATEST/item/armor/equip_chain2.ogg": 277157,
	"./LATEST/item/armor/equip_chain3.ogg": 542785,
	"./LATEST/item/armor/equip_chain4.ogg": 224635,
	"./LATEST/item/armor/equip_chain5.ogg": 346926,
	"./LATEST/item/armor/equip_chain6.ogg": 185394,
	"./LATEST/item/armor/equip_diamond1.ogg": 972844,
	"./LATEST/item/armor/equip_diamond2.ogg": 214217,
	"./LATEST/item/armor/equip_diamond3.ogg": 820175,
	"./LATEST/item/armor/equip_diamond4.ogg": 860423,
	"./LATEST/item/armor/equip_diamond5.ogg": 295466,
	"./LATEST/item/armor/equip_diamond6.ogg": 914878,
	"./LATEST/item/armor/equip_generic1.ogg": 763889,
	"./LATEST/item/armor/equip_generic2.ogg": 270556,
	"./LATEST/item/armor/equip_generic3.ogg": 869158,
	"./LATEST/item/armor/equip_generic4.ogg": 285123,
	"./LATEST/item/armor/equip_generic5.ogg": 886648,
	"./LATEST/item/armor/equip_generic6.ogg": 138172,
	"./LATEST/item/armor/equip_gold1.ogg": 675901,
	"./LATEST/item/armor/equip_gold2.ogg": 433859,
	"./LATEST/item/armor/equip_gold3.ogg": 139415,
	"./LATEST/item/armor/equip_gold4.ogg": 3193,
	"./LATEST/item/armor/equip_gold5.ogg": 863266,
	"./LATEST/item/armor/equip_gold6.ogg": 915336,
	"./LATEST/item/armor/equip_iron1.ogg": 402512,
	"./LATEST/item/armor/equip_iron2.ogg": 531177,
	"./LATEST/item/armor/equip_iron3.ogg": 899240,
	"./LATEST/item/armor/equip_iron4.ogg": 885236,
	"./LATEST/item/armor/equip_iron5.ogg": 882191,
	"./LATEST/item/armor/equip_iron6.ogg": 688796,
	"./LATEST/item/armor/equip_leather1.ogg": 681045,
	"./LATEST/item/armor/equip_leather2.ogg": 973632,
	"./LATEST/item/armor/equip_leather3.ogg": 729835,
	"./LATEST/item/armor/equip_leather4.ogg": 725707,
	"./LATEST/item/armor/equip_leather5.ogg": 738258,
	"./LATEST/item/armor/equip_leather6.ogg": 245168,
	"./LATEST/item/armor/equip_netherite1.ogg": 685660,
	"./LATEST/item/armor/equip_netherite2.ogg": 979002,
	"./LATEST/item/armor/equip_netherite3.ogg": 359357,
	"./LATEST/item/armor/equip_netherite4.ogg": 366015,
	"./LATEST/item/axe/scrape1.ogg": 412329,
	"./LATEST/item/axe/scrape2.ogg": 257717,
	"./LATEST/item/axe/scrape3.ogg": 687909,
	"./LATEST/item/axe/strip1.ogg": 510558,
	"./LATEST/item/axe/strip2.ogg": 711130,
	"./LATEST/item/axe/strip3.ogg": 349828,
	"./LATEST/item/axe/strip4.ogg": 913759,
	"./LATEST/item/axe/wax_off1.ogg": 532173,
	"./LATEST/item/axe/wax_off2.ogg": 951040,
	"./LATEST/item/axe/wax_off3.ogg": 94942,
	"./LATEST/item/bonemeal/bonemeal1.ogg": 409640,
	"./LATEST/item/bonemeal/bonemeal2.ogg": 51416,
	"./LATEST/item/bonemeal/bonemeal3.ogg": 317048,
	"./LATEST/item/bonemeal/bonemeal4.ogg": 400902,
	"./LATEST/item/bonemeal/bonemeal5.ogg": 787752,
	"./LATEST/item/book/close_put1.ogg": 541422,
	"./LATEST/item/book/close_put2.ogg": 142330,
	"./LATEST/item/book/open_flip1.ogg": 904692,
	"./LATEST/item/book/open_flip2.ogg": 810239,
	"./LATEST/item/book/open_flip3.ogg": 384190,
	"./LATEST/item/bottle/drink_honey1.ogg": 460130,
	"./LATEST/item/bottle/drink_honey2.ogg": 439699,
	"./LATEST/item/bottle/drink_honey3.ogg": 324568,
	"./LATEST/item/bottle/empty1.ogg": 254053,
	"./LATEST/item/bottle/empty2.ogg": 268379,
	"./LATEST/item/bottle/fill1.ogg": 262477,
	"./LATEST/item/bottle/fill2.ogg": 49189,
	"./LATEST/item/bottle/fill3.ogg": 979254,
	"./LATEST/item/bottle/fill4.ogg": 804447,
	"./LATEST/item/bottle/fill_dragonbreath1.ogg": 866927,
	"./LATEST/item/bottle/fill_dragonbreath2.ogg": 309156,
	"./LATEST/item/brush/brush_sand_complete1.ogg": 189307,
	"./LATEST/item/brush/brush_sand_complete2.ogg": 386808,
	"./LATEST/item/brush/brush_sand_complete3.ogg": 596257,
	"./LATEST/item/brush/brush_sand_complete4.ogg": 604175,
	"./LATEST/item/brush/brush_sand_complete5.ogg": 538739,
	"./LATEST/item/brush/brushing_generic1.ogg": 227086,
	"./LATEST/item/brush/brushing_generic2.ogg": 872740,
	"./LATEST/item/brush/brushing_generic3.ogg": 23935,
	"./LATEST/item/brush/brushing_generic4.ogg": 757533,
	"./LATEST/item/brush/brushing_gravel1.ogg": 185077,
	"./LATEST/item/brush/brushing_gravel2.ogg": 431702,
	"./LATEST/item/brush/brushing_gravel3.ogg": 454760,
	"./LATEST/item/brush/brushing_gravel4.ogg": 467028,
	"./LATEST/item/brush/brushing_gravel_complete1.ogg": 694275,
	"./LATEST/item/brush/brushing_gravel_complete2.ogg": 865649,
	"./LATEST/item/brush/brushing_gravel_complete3.ogg": 813354,
	"./LATEST/item/brush/brushing_gravel_complete4.ogg": 590977,
	"./LATEST/item/brush/brushing_sand1.ogg": 545460,
	"./LATEST/item/brush/brushing_sand2.ogg": 914148,
	"./LATEST/item/brush/brushing_sand3.ogg": 545136,
	"./LATEST/item/brush/brushing_sand4.ogg": 62104,
	"./LATEST/item/bucket/empty1.ogg": 398857,
	"./LATEST/item/bucket/empty2.ogg": 889390,
	"./LATEST/item/bucket/empty3.ogg": 629595,
	"./LATEST/item/bucket/empty_fish1.ogg": 175029,
	"./LATEST/item/bucket/empty_fish2.ogg": 576276,
	"./LATEST/item/bucket/empty_fish3.ogg": 382671,
	"./LATEST/item/bucket/empty_lava1.ogg": 652256,
	"./LATEST/item/bucket/empty_lava2.ogg": 66878,
	"./LATEST/item/bucket/empty_lava3.ogg": 414055,
	"./LATEST/item/bucket/empty_powder_snow1.ogg": 253249,
	"./LATEST/item/bucket/empty_powder_snow2.ogg": 407405,
	"./LATEST/item/bucket/fill1.ogg": 118927,
	"./LATEST/item/bucket/fill2.ogg": 20013,
	"./LATEST/item/bucket/fill3.ogg": 743083,
	"./LATEST/item/bucket/fill_axolotl1.ogg": 297723,
	"./LATEST/item/bucket/fill_axolotl2.ogg": 49502,
	"./LATEST/item/bucket/fill_axolotl3.ogg": 746096,
	"./LATEST/item/bucket/fill_fish1.ogg": 420556,
	"./LATEST/item/bucket/fill_fish2.ogg": 319169,
	"./LATEST/item/bucket/fill_fish3.ogg": 528308,
	"./LATEST/item/bucket/fill_lava1.ogg": 25501,
	"./LATEST/item/bucket/fill_lava2.ogg": 737509,
	"./LATEST/item/bucket/fill_lava3.ogg": 604,
	"./LATEST/item/bucket/fill_powder_snow1.ogg": 909130,
	"./LATEST/item/bucket/fill_powder_snow2.ogg": 768192,
	"./LATEST/item/bundle/drop_contents1.ogg": 553536,
	"./LATEST/item/bundle/drop_contents2.ogg": 134071,
	"./LATEST/item/bundle/drop_contents3.ogg": 608823,
	"./LATEST/item/bundle/insert1.ogg": 248425,
	"./LATEST/item/bundle/insert2.ogg": 594276,
	"./LATEST/item/bundle/insert3.ogg": 432761,
	"./LATEST/item/bundle/remove_one1.ogg": 436826,
	"./LATEST/item/bundle/remove_one2.ogg": 675322,
	"./LATEST/item/bundle/remove_one3.ogg": 488518,
	"./LATEST/item/crossbow/loading_end.ogg": 265147,
	"./LATEST/item/crossbow/loading_middle1.ogg": 776786,
	"./LATEST/item/crossbow/loading_middle2.ogg": 930514,
	"./LATEST/item/crossbow/loading_middle3.ogg": 469670,
	"./LATEST/item/crossbow/loading_middle4.ogg": 412124,
	"./LATEST/item/crossbow/loading_start.ogg": 380549,
	"./LATEST/item/crossbow/quick_charge/quick1_1.ogg": 508314,
	"./LATEST/item/crossbow/quick_charge/quick1_2.ogg": 372815,
	"./LATEST/item/crossbow/quick_charge/quick1_3.ogg": 299891,
	"./LATEST/item/crossbow/quick_charge/quick2_1.ogg": 159186,
	"./LATEST/item/crossbow/quick_charge/quick2_2.ogg": 721947,
	"./LATEST/item/crossbow/quick_charge/quick2_3.ogg": 150725,
	"./LATEST/item/crossbow/quick_charge/quick3_1.ogg": 865554,
	"./LATEST/item/crossbow/quick_charge/quick3_2.ogg": 773384,
	"./LATEST/item/crossbow/quick_charge/quick3_3.ogg": 322836,
	"./LATEST/item/crossbow/shoot1.ogg": 3412,
	"./LATEST/item/crossbow/shoot2.ogg": 148911,
	"./LATEST/item/crossbow/shoot3.ogg": 384614,
	"./LATEST/item/dye/dye.ogg": 291481,
	"./LATEST/item/elytra/elytra_loop.ogg": 431985,
	"./LATEST/item/goat_horn/call0.ogg": 788290,
	"./LATEST/item/goat_horn/call1.ogg": 763483,
	"./LATEST/item/goat_horn/call2.ogg": 53015,
	"./LATEST/item/goat_horn/call3.ogg": 900199,
	"./LATEST/item/goat_horn/call4.ogg": 873230,
	"./LATEST/item/goat_horn/call5.ogg": 785491,
	"./LATEST/item/goat_horn/call6.ogg": 728059,
	"./LATEST/item/goat_horn/call7.ogg": 936736,
	"./LATEST/item/hoe/till1.ogg": 697688,
	"./LATEST/item/hoe/till2.ogg": 175187,
	"./LATEST/item/hoe/till3.ogg": 496240,
	"./LATEST/item/hoe/till4.ogg": 998877,
	"./LATEST/item/honeycomb/wax_on1.ogg": 994634,
	"./LATEST/item/honeycomb/wax_on2.ogg": 621760,
	"./LATEST/item/honeycomb/wax_on3.ogg": 626718,
	"./LATEST/item/ink_sac/ink_sac1.ogg": 204843,
	"./LATEST/item/ink_sac/ink_sac2.ogg": 799164,
	"./LATEST/item/ink_sac/ink_sac3.ogg": 638469,
	"./LATEST/item/plant/crop1.ogg": 315385,
	"./LATEST/item/plant/crop2.ogg": 567572,
	"./LATEST/item/plant/crop3.ogg": 427771,
	"./LATEST/item/plant/crop4.ogg": 685163,
	"./LATEST/item/plant/crop5.ogg": 345867,
	"./LATEST/item/plant/crop6.ogg": 29836,
	"./LATEST/item/plant/netherwart1.ogg": 633449,
	"./LATEST/item/plant/netherwart2.ogg": 217125,
	"./LATEST/item/plant/netherwart3.ogg": 641215,
	"./LATEST/item/plant/netherwart4.ogg": 696687,
	"./LATEST/item/plant/netherwart5.ogg": 824364,
	"./LATEST/item/plant/netherwart6.ogg": 86759,
	"./LATEST/item/shield/block1.ogg": 159264,
	"./LATEST/item/shield/block2.ogg": 986167,
	"./LATEST/item/shield/block3.ogg": 923633,
	"./LATEST/item/shield/block4.ogg": 150345,
	"./LATEST/item/shield/block5.ogg": 658514,
	"./LATEST/item/shovel/flatten1.ogg": 177373,
	"./LATEST/item/shovel/flatten2.ogg": 909142,
	"./LATEST/item/shovel/flatten3.ogg": 36620,
	"./LATEST/item/shovel/flatten4.ogg": 653489,
	"./LATEST/item/spyglass/stop.ogg": 257278,
	"./LATEST/item/spyglass/use.ogg": 657021,
	"./LATEST/item/sweet_berries/pick_from_bush1.ogg": 942627,
	"./LATEST/item/sweet_berries/pick_from_bush2.ogg": 383728,
	"./LATEST/item/totem/use_totem.ogg": 842158,
	"./LATEST/item/trident/ground_impact1.ogg": 115707,
	"./LATEST/item/trident/ground_impact2.ogg": 867049,
	"./LATEST/item/trident/ground_impact3.ogg": 553504,
	"./LATEST/item/trident/ground_impact4.ogg": 922508,
	"./LATEST/item/trident/pierce1.ogg": 7121,
	"./LATEST/item/trident/pierce2.ogg": 150714,
	"./LATEST/item/trident/pierce3.ogg": 299636,
	"./LATEST/item/trident/return1.ogg": 805778,
	"./LATEST/item/trident/return2.ogg": 632765,
	"./LATEST/item/trident/return3.ogg": 479144,
	"./LATEST/item/trident/riptide1.ogg": 127042,
	"./LATEST/item/trident/riptide2.ogg": 47201,
	"./LATEST/item/trident/riptide3.ogg": 353475,
	"./LATEST/item/trident/throw1.ogg": 454749,
	"./LATEST/item/trident/throw2.ogg": 604952,
	"./LATEST/item/trident/thunder1.ogg": 73462,
	"./LATEST/item/trident/thunder2.ogg": 924249,
	"./LATEST/liquid/heavy_splash.ogg": 736452,
	"./LATEST/liquid/lava.ogg": 188653,
	"./LATEST/liquid/lavapop.ogg": 42373,
	"./LATEST/liquid/splash.ogg": 532063,
	"./LATEST/liquid/splash2.ogg": 9891,
	"./LATEST/liquid/swim1.ogg": 118409,
	"./LATEST/liquid/swim10.ogg": 20696,
	"./LATEST/liquid/swim11.ogg": 961184,
	"./LATEST/liquid/swim12.ogg": 926376,
	"./LATEST/liquid/swim13.ogg": 967949,
	"./LATEST/liquid/swim14.ogg": 260032,
	"./LATEST/liquid/swim15.ogg": 411591,
	"./LATEST/liquid/swim16.ogg": 209294,
	"./LATEST/liquid/swim17.ogg": 823907,
	"./LATEST/liquid/swim18.ogg": 927196,
	"./LATEST/liquid/swim2.ogg": 333394,
	"./LATEST/liquid/swim3.ogg": 57232,
	"./LATEST/liquid/swim4.ogg": 489181,
	"./LATEST/liquid/swim5.ogg": 90711,
	"./LATEST/liquid/swim6.ogg": 320898,
	"./LATEST/liquid/swim7.ogg": 784826,
	"./LATEST/liquid/swim8.ogg": 927675,
	"./LATEST/liquid/swim9.ogg": 237512,
	"./LATEST/liquid/water.ogg": 645344,
	"./LATEST/minecart/base.ogg": 314373,
	"./LATEST/minecart/inside.ogg": 345411,
	"./LATEST/minecart/inside_underwater1.ogg": 753820,
	"./LATEST/minecart/inside_underwater2.ogg": 470782,
	"./LATEST/minecart/inside_underwater3.ogg": 275587,
	"./LATEST/mob/allay/death1.ogg": 451383,
	"./LATEST/mob/allay/death2.ogg": 690873,
	"./LATEST/mob/allay/hurt1.ogg": 171998,
	"./LATEST/mob/allay/hurt2.ogg": 953783,
	"./LATEST/mob/allay/idle_with_item1.ogg": 4185,
	"./LATEST/mob/allay/idle_with_item2.ogg": 362484,
	"./LATEST/mob/allay/idle_with_item3.ogg": 766130,
	"./LATEST/mob/allay/idle_with_item4.ogg": 33811,
	"./LATEST/mob/allay/idle_without_item1.ogg": 886219,
	"./LATEST/mob/allay/idle_without_item2.ogg": 415262,
	"./LATEST/mob/allay/idle_without_item3.ogg": 994875,
	"./LATEST/mob/allay/idle_without_item4.ogg": 673267,
	"./LATEST/mob/allay/item_given1.ogg": 219906,
	"./LATEST/mob/allay/item_given2.ogg": 117229,
	"./LATEST/mob/allay/item_given3.ogg": 999213,
	"./LATEST/mob/allay/item_given4.ogg": 155895,
	"./LATEST/mob/allay/item_taken1.ogg": 575177,
	"./LATEST/mob/allay/item_taken2.ogg": 610420,
	"./LATEST/mob/allay/item_taken3.ogg": 67789,
	"./LATEST/mob/allay/item_taken4.ogg": 797070,
	"./LATEST/mob/allay/item_thrown1.ogg": 347970,
	"./LATEST/mob/axolotl/attack1.ogg": 677076,
	"./LATEST/mob/axolotl/attack2.ogg": 522156,
	"./LATEST/mob/axolotl/attack3.ogg": 740695,
	"./LATEST/mob/axolotl/attack4.ogg": 729129,
	"./LATEST/mob/axolotl/death1.ogg": 598795,
	"./LATEST/mob/axolotl/death2.ogg": 135217,
	"./LATEST/mob/axolotl/hurt1.ogg": 179734,
	"./LATEST/mob/axolotl/hurt2.ogg": 962713,
	"./LATEST/mob/axolotl/hurt3.ogg": 30065,
	"./LATEST/mob/axolotl/hurt4.ogg": 578791,
	"./LATEST/mob/axolotl/idle1.ogg": 450447,
	"./LATEST/mob/axolotl/idle2.ogg": 333489,
	"./LATEST/mob/axolotl/idle3.ogg": 143938,
	"./LATEST/mob/axolotl/idle4.ogg": 957875,
	"./LATEST/mob/axolotl/idle5.ogg": 363438,
	"./LATEST/mob/axolotl/idle_air1.ogg": 924999,
	"./LATEST/mob/axolotl/idle_air2.ogg": 254805,
	"./LATEST/mob/axolotl/idle_air3.ogg": 616997,
	"./LATEST/mob/axolotl/idle_air4.ogg": 725108,
	"./LATEST/mob/axolotl/idle_air5.ogg": 539075,
	"./LATEST/mob/bat/death.ogg": 781341,
	"./LATEST/mob/bat/hurt1.ogg": 47895,
	"./LATEST/mob/bat/hurt2.ogg": 372732,
	"./LATEST/mob/bat/hurt3.ogg": 733032,
	"./LATEST/mob/bat/hurt4.ogg": 614357,
	"./LATEST/mob/bat/idle1.ogg": 849634,
	"./LATEST/mob/bat/idle2.ogg": 57691,
	"./LATEST/mob/bat/idle3.ogg": 920774,
	"./LATEST/mob/bat/idle4.ogg": 300480,
	"./LATEST/mob/bat/loop.ogg": 924625,
	"./LATEST/mob/bat/takeoff.ogg": 371045,
	"./LATEST/mob/bee/aggressive1.ogg": 132160,
	"./LATEST/mob/bee/aggressive2.ogg": 403738,
	"./LATEST/mob/bee/aggressive3.ogg": 492362,
	"./LATEST/mob/bee/death1.ogg": 903932,
	"./LATEST/mob/bee/death2.ogg": 230818,
	"./LATEST/mob/bee/hurt1.ogg": 623899,
	"./LATEST/mob/bee/hurt2.ogg": 956446,
	"./LATEST/mob/bee/hurt3.ogg": 469596,
	"./LATEST/mob/bee/loop1.ogg": 347647,
	"./LATEST/mob/bee/loop2.ogg": 125451,
	"./LATEST/mob/bee/loop3.ogg": 210979,
	"./LATEST/mob/bee/loop4.ogg": 683997,
	"./LATEST/mob/bee/loop5.ogg": 929852,
	"./LATEST/mob/bee/pollinate1.ogg": 827027,
	"./LATEST/mob/bee/pollinate2.ogg": 442382,
	"./LATEST/mob/bee/pollinate3.ogg": 551627,
	"./LATEST/mob/bee/pollinate4.ogg": 365292,
	"./LATEST/mob/bee/sting.ogg": 417583,
	"./LATEST/mob/blaze/breathe1.ogg": 396778,
	"./LATEST/mob/blaze/breathe2.ogg": 90526,
	"./LATEST/mob/blaze/breathe3.ogg": 433685,
	"./LATEST/mob/blaze/breathe4.ogg": 268598,
	"./LATEST/mob/blaze/death.ogg": 79749,
	"./LATEST/mob/blaze/hit1.ogg": 116143,
	"./LATEST/mob/blaze/hit2.ogg": 845960,
	"./LATEST/mob/blaze/hit3.ogg": 456494,
	"./LATEST/mob/blaze/hit4.ogg": 2771,
	"./LATEST/mob/camel/ambient1.ogg": 56541,
	"./LATEST/mob/camel/ambient2.ogg": 213789,
	"./LATEST/mob/camel/ambient3.ogg": 458765,
	"./LATEST/mob/camel/ambient4.ogg": 858502,
	"./LATEST/mob/camel/ambient5.ogg": 74632,
	"./LATEST/mob/camel/ambient6.ogg": 387590,
	"./LATEST/mob/camel/ambient7.ogg": 934607,
	"./LATEST/mob/camel/ambient8.ogg": 37982,
	"./LATEST/mob/camel/dash1.ogg": 913150,
	"./LATEST/mob/camel/dash2.ogg": 14733,
	"./LATEST/mob/camel/dash3.ogg": 572271,
	"./LATEST/mob/camel/dash4.ogg": 113056,
	"./LATEST/mob/camel/dash5.ogg": 184951,
	"./LATEST/mob/camel/dash6.ogg": 757207,
	"./LATEST/mob/camel/dash_ready1.ogg": 317344,
	"./LATEST/mob/camel/death1.ogg": 998970,
	"./LATEST/mob/camel/death2.ogg": 656178,
	"./LATEST/mob/camel/eat1.ogg": 496798,
	"./LATEST/mob/camel/eat2.ogg": 276959,
	"./LATEST/mob/camel/eat3.ogg": 642200,
	"./LATEST/mob/camel/eat4.ogg": 245066,
	"./LATEST/mob/camel/eat5.ogg": 915979,
	"./LATEST/mob/camel/hurt1.ogg": 977400,
	"./LATEST/mob/camel/hurt2.ogg": 250675,
	"./LATEST/mob/camel/hurt3.ogg": 818879,
	"./LATEST/mob/camel/hurt4.ogg": 850518,
	"./LATEST/mob/camel/sit1.ogg": 914271,
	"./LATEST/mob/camel/sit2.ogg": 986974,
	"./LATEST/mob/camel/sit3.ogg": 801323,
	"./LATEST/mob/camel/sit4.ogg": 110758,
	"./LATEST/mob/camel/stand1.ogg": 678676,
	"./LATEST/mob/camel/stand2.ogg": 44768,
	"./LATEST/mob/camel/stand3.ogg": 132563,
	"./LATEST/mob/camel/stand4.ogg": 946521,
	"./LATEST/mob/camel/stand5.ogg": 570985,
	"./LATEST/mob/camel/step1.ogg": 410937,
	"./LATEST/mob/camel/step2.ogg": 553762,
	"./LATEST/mob/camel/step3.ogg": 960364,
	"./LATEST/mob/camel/step4.ogg": 532094,
	"./LATEST/mob/camel/step5.ogg": 945505,
	"./LATEST/mob/camel/step6.ogg": 707349,
	"./LATEST/mob/camel/step_sand1.ogg": 715301,
	"./LATEST/mob/camel/step_sand2.ogg": 416616,
	"./LATEST/mob/camel/step_sand3.ogg": 476472,
	"./LATEST/mob/camel/step_sand4.ogg": 527613,
	"./LATEST/mob/camel/step_sand5.ogg": 55017,
	"./LATEST/mob/camel/step_sand6.ogg": 413555,
	"./LATEST/mob/cat/beg1.ogg": 124990,
	"./LATEST/mob/cat/beg2.ogg": 515436,
	"./LATEST/mob/cat/beg3.ogg": 95404,
	"./LATEST/mob/cat/eat1.ogg": 157083,
	"./LATEST/mob/cat/eat2.ogg": 907834,
	"./LATEST/mob/cat/hiss1.ogg": 62775,
	"./LATEST/mob/cat/hiss2.ogg": 16083,
	"./LATEST/mob/cat/hiss3.ogg": 526886,
	"./LATEST/mob/cat/hitt1.ogg": 520426,
	"./LATEST/mob/cat/hitt2.ogg": 329849,
	"./LATEST/mob/cat/hitt3.ogg": 16767,
	"./LATEST/mob/cat/meow1.ogg": 391847,
	"./LATEST/mob/cat/meow2.ogg": 552718,
	"./LATEST/mob/cat/meow3.ogg": 322425,
	"./LATEST/mob/cat/meow4.ogg": 634773,
	"./LATEST/mob/cat/ocelot/death1.ogg": 924162,
	"./LATEST/mob/cat/ocelot/death2.ogg": 564001,
	"./LATEST/mob/cat/ocelot/death3.ogg": 695700,
	"./LATEST/mob/cat/ocelot/idle1.ogg": 785475,
	"./LATEST/mob/cat/ocelot/idle2.ogg": 261909,
	"./LATEST/mob/cat/ocelot/idle3.ogg": 300348,
	"./LATEST/mob/cat/ocelot/idle4.ogg": 459806,
	"./LATEST/mob/cat/purr1.ogg": 235787,
	"./LATEST/mob/cat/purr2.ogg": 256898,
	"./LATEST/mob/cat/purr3.ogg": 376701,
	"./LATEST/mob/cat/purreow1.ogg": 695759,
	"./LATEST/mob/cat/purreow2.ogg": 966835,
	"./LATEST/mob/cat/stray/idle1.ogg": 577615,
	"./LATEST/mob/cat/stray/idle2.ogg": 286798,
	"./LATEST/mob/cat/stray/idle3.ogg": 526522,
	"./LATEST/mob/cat/stray/idle4.ogg": 43189,
	"./LATEST/mob/chicken/hurt1.ogg": 309030,
	"./LATEST/mob/chicken/hurt2.ogg": 501396,
	"./LATEST/mob/chicken/plop.ogg": 662220,
	"./LATEST/mob/chicken/say1.ogg": 975354,
	"./LATEST/mob/chicken/say2.ogg": 842701,
	"./LATEST/mob/chicken/say3.ogg": 709657,
	"./LATEST/mob/chicken/step1.ogg": 955182,
	"./LATEST/mob/chicken/step2.ogg": 693754,
	"./LATEST/mob/cow/hurt1.ogg": 204872,
	"./LATEST/mob/cow/hurt2.ogg": 235754,
	"./LATEST/mob/cow/hurt3.ogg": 346692,
	"./LATEST/mob/cow/say1.ogg": 509889,
	"./LATEST/mob/cow/say2.ogg": 544999,
	"./LATEST/mob/cow/say3.ogg": 362317,
	"./LATEST/mob/cow/say4.ogg": 444170,
	"./LATEST/mob/cow/step1.ogg": 92317,
	"./LATEST/mob/cow/step2.ogg": 322494,
	"./LATEST/mob/cow/step3.ogg": 874872,
	"./LATEST/mob/cow/step4.ogg": 873795,
	"./LATEST/mob/creeper/death.ogg": 187020,
	"./LATEST/mob/creeper/say1.ogg": 127278,
	"./LATEST/mob/creeper/say2.ogg": 585596,
	"./LATEST/mob/creeper/say3.ogg": 563622,
	"./LATEST/mob/creeper/say4.ogg": 845164,
	"./LATEST/mob/dolphin/attack1.ogg": 625221,
	"./LATEST/mob/dolphin/attack2.ogg": 320804,
	"./LATEST/mob/dolphin/attack3.ogg": 528690,
	"./LATEST/mob/dolphin/blowhole1.ogg": 541782,
	"./LATEST/mob/dolphin/blowhole2.ogg": 658094,
	"./LATEST/mob/dolphin/death1.ogg": 48296,
	"./LATEST/mob/dolphin/death2.ogg": 145247,
	"./LATEST/mob/dolphin/eat1.ogg": 453374,
	"./LATEST/mob/dolphin/eat2.ogg": 153893,
	"./LATEST/mob/dolphin/eat3.ogg": 767188,
	"./LATEST/mob/dolphin/hurt1.ogg": 165538,
	"./LATEST/mob/dolphin/hurt2.ogg": 43815,
	"./LATEST/mob/dolphin/hurt3.ogg": 98457,
	"./LATEST/mob/dolphin/idle1.ogg": 424747,
	"./LATEST/mob/dolphin/idle2.ogg": 317166,
	"./LATEST/mob/dolphin/idle3.ogg": 779771,
	"./LATEST/mob/dolphin/idle4.ogg": 892085,
	"./LATEST/mob/dolphin/idle5.ogg": 573353,
	"./LATEST/mob/dolphin/idle6.ogg": 105319,
	"./LATEST/mob/dolphin/idle_water1.ogg": 606526,
	"./LATEST/mob/dolphin/idle_water10.ogg": 71836,
	"./LATEST/mob/dolphin/idle_water2.ogg": 312266,
	"./LATEST/mob/dolphin/idle_water3.ogg": 659942,
	"./LATEST/mob/dolphin/idle_water4.ogg": 737814,
	"./LATEST/mob/dolphin/idle_water5.ogg": 890473,
	"./LATEST/mob/dolphin/idle_water6.ogg": 162284,
	"./LATEST/mob/dolphin/idle_water7.ogg": 233710,
	"./LATEST/mob/dolphin/idle_water8.ogg": 561874,
	"./LATEST/mob/dolphin/idle_water9.ogg": 850809,
	"./LATEST/mob/dolphin/jump1.ogg": 255980,
	"./LATEST/mob/dolphin/jump2.ogg": 463031,
	"./LATEST/mob/dolphin/jump3.ogg": 84730,
	"./LATEST/mob/dolphin/play1.ogg": 984120,
	"./LATEST/mob/dolphin/play2.ogg": 341448,
	"./LATEST/mob/dolphin/splash1.ogg": 810689,
	"./LATEST/mob/dolphin/splash2.ogg": 556487,
	"./LATEST/mob/dolphin/splash3.ogg": 939097,
	"./LATEST/mob/dolphin/swim1.ogg": 224921,
	"./LATEST/mob/dolphin/swim2.ogg": 315180,
	"./LATEST/mob/dolphin/swim3.ogg": 317313,
	"./LATEST/mob/dolphin/swim4.ogg": 434538,
	"./LATEST/mob/drowned/convert1.ogg": 401246,
	"./LATEST/mob/drowned/convert2.ogg": 132189,
	"./LATEST/mob/drowned/convert3.ogg": 413838,
	"./LATEST/mob/drowned/death1.ogg": 216440,
	"./LATEST/mob/drowned/death2.ogg": 78056,
	"./LATEST/mob/drowned/hurt1.ogg": 832220,
	"./LATEST/mob/drowned/hurt2.ogg": 171938,
	"./LATEST/mob/drowned/hurt3.ogg": 603182,
	"./LATEST/mob/drowned/idle1.ogg": 86731,
	"./LATEST/mob/drowned/idle2.ogg": 833943,
	"./LATEST/mob/drowned/idle3.ogg": 920834,
	"./LATEST/mob/drowned/idle4.ogg": 14258,
	"./LATEST/mob/drowned/idle5.ogg": 559671,
	"./LATEST/mob/drowned/step1.ogg": 230776,
	"./LATEST/mob/drowned/step2.ogg": 281796,
	"./LATEST/mob/drowned/step3.ogg": 203199,
	"./LATEST/mob/drowned/step4.ogg": 440403,
	"./LATEST/mob/drowned/step5.ogg": 924655,
	"./LATEST/mob/drowned/water/death1.ogg": 163766,
	"./LATEST/mob/drowned/water/death2.ogg": 494157,
	"./LATEST/mob/drowned/water/hurt1.ogg": 213758,
	"./LATEST/mob/drowned/water/hurt2.ogg": 651648,
	"./LATEST/mob/drowned/water/hurt3.ogg": 435748,
	"./LATEST/mob/drowned/water/idle1.ogg": 890480,
	"./LATEST/mob/drowned/water/idle2.ogg": 284427,
	"./LATEST/mob/drowned/water/idle3.ogg": 723592,
	"./LATEST/mob/drowned/water/idle4.ogg": 465406,
	"./LATEST/mob/enderdragon/end.ogg": 43255,
	"./LATEST/mob/enderdragon/growl1.ogg": 521110,
	"./LATEST/mob/enderdragon/growl2.ogg": 237735,
	"./LATEST/mob/enderdragon/growl3.ogg": 91869,
	"./LATEST/mob/enderdragon/growl4.ogg": 114267,
	"./LATEST/mob/enderdragon/hit1.ogg": 727781,
	"./LATEST/mob/enderdragon/hit2.ogg": 274738,
	"./LATEST/mob/enderdragon/hit3.ogg": 806043,
	"./LATEST/mob/enderdragon/hit4.ogg": 812932,
	"./LATEST/mob/enderdragon/wings1.ogg": 244762,
	"./LATEST/mob/enderdragon/wings2.ogg": 361326,
	"./LATEST/mob/enderdragon/wings3.ogg": 557576,
	"./LATEST/mob/enderdragon/wings4.ogg": 395144,
	"./LATEST/mob/enderdragon/wings5.ogg": 180876,
	"./LATEST/mob/enderdragon/wings6.ogg": 162254,
	"./LATEST/mob/endermen/death.ogg": 773470,
	"./LATEST/mob/endermen/hit1.ogg": 91457,
	"./LATEST/mob/endermen/hit2.ogg": 166698,
	"./LATEST/mob/endermen/hit3.ogg": 457515,
	"./LATEST/mob/endermen/hit4.ogg": 814100,
	"./LATEST/mob/endermen/idle1.ogg": 382251,
	"./LATEST/mob/endermen/idle2.ogg": 712096,
	"./LATEST/mob/endermen/idle3.ogg": 178176,
	"./LATEST/mob/endermen/idle4.ogg": 302008,
	"./LATEST/mob/endermen/idle5.ogg": 263431,
	"./LATEST/mob/endermen/portal.ogg": 763554,
	"./LATEST/mob/endermen/portal2.ogg": 600851,
	"./LATEST/mob/endermen/scream1.ogg": 74591,
	"./LATEST/mob/endermen/scream2.ogg": 664279,
	"./LATEST/mob/endermen/scream3.ogg": 979199,
	"./LATEST/mob/endermen/scream4.ogg": 690150,
	"./LATEST/mob/endermen/stare.ogg": 80103,
	"./LATEST/mob/evocation_illager/cast1.ogg": 688564,
	"./LATEST/mob/evocation_illager/cast2.ogg": 425861,
	"./LATEST/mob/evocation_illager/celebrate.ogg": 882739,
	"./LATEST/mob/evocation_illager/death1.ogg": 516947,
	"./LATEST/mob/evocation_illager/death2.ogg": 988914,
	"./LATEST/mob/evocation_illager/fangs.ogg": 329668,
	"./LATEST/mob/evocation_illager/hurt1.ogg": 977437,
	"./LATEST/mob/evocation_illager/hurt2.ogg": 118970,
	"./LATEST/mob/evocation_illager/idle1.ogg": 62777,
	"./LATEST/mob/evocation_illager/idle2.ogg": 55867,
	"./LATEST/mob/evocation_illager/idle3.ogg": 915005,
	"./LATEST/mob/evocation_illager/idle4.ogg": 15827,
	"./LATEST/mob/evocation_illager/prepare_attack1.ogg": 496877,
	"./LATEST/mob/evocation_illager/prepare_attack2.ogg": 140430,
	"./LATEST/mob/evocation_illager/prepare_summon.ogg": 147008,
	"./LATEST/mob/evocation_illager/prepare_wololo.ogg": 973275,
	"./LATEST/mob/fox/aggro1.ogg": 315525,
	"./LATEST/mob/fox/aggro2.ogg": 463531,
	"./LATEST/mob/fox/aggro3.ogg": 912187,
	"./LATEST/mob/fox/aggro4.ogg": 878272,
	"./LATEST/mob/fox/aggro5.ogg": 850767,
	"./LATEST/mob/fox/aggro6.ogg": 681107,
	"./LATEST/mob/fox/aggro7.ogg": 646187,
	"./LATEST/mob/fox/bite1.ogg": 47749,
	"./LATEST/mob/fox/bite2.ogg": 57251,
	"./LATEST/mob/fox/bite3.ogg": 582062,
	"./LATEST/mob/fox/death1.ogg": 668745,
	"./LATEST/mob/fox/death2.ogg": 518129,
	"./LATEST/mob/fox/eat1.ogg": 905617,
	"./LATEST/mob/fox/eat2.ogg": 916699,
	"./LATEST/mob/fox/eat3.ogg": 500315,
	"./LATEST/mob/fox/hurt1.ogg": 292065,
	"./LATEST/mob/fox/hurt2.ogg": 832533,
	"./LATEST/mob/fox/hurt3.ogg": 161270,
	"./LATEST/mob/fox/hurt4.ogg": 832750,
	"./LATEST/mob/fox/idle1.ogg": 230707,
	"./LATEST/mob/fox/idle2.ogg": 435355,
	"./LATEST/mob/fox/idle3.ogg": 351979,
	"./LATEST/mob/fox/idle4.ogg": 720116,
	"./LATEST/mob/fox/idle5.ogg": 719345,
	"./LATEST/mob/fox/idle6.ogg": 840798,
	"./LATEST/mob/fox/screech1.ogg": 39975,
	"./LATEST/mob/fox/screech2.ogg": 757698,
	"./LATEST/mob/fox/screech3.ogg": 82888,
	"./LATEST/mob/fox/screech4.ogg": 977186,
	"./LATEST/mob/fox/sleep1.ogg": 617996,
	"./LATEST/mob/fox/sleep2.ogg": 447481,
	"./LATEST/mob/fox/sleep3.ogg": 594256,
	"./LATEST/mob/fox/sleep4.ogg": 338621,
	"./LATEST/mob/fox/sleep5.ogg": 388530,
	"./LATEST/mob/fox/sniff1.ogg": 234865,
	"./LATEST/mob/fox/sniff2.ogg": 36308,
	"./LATEST/mob/fox/sniff3.ogg": 960278,
	"./LATEST/mob/fox/sniff4.ogg": 628776,
	"./LATEST/mob/fox/spit1.ogg": 312605,
	"./LATEST/mob/fox/spit2.ogg": 334344,
	"./LATEST/mob/fox/spit3.ogg": 838027,
	"./LATEST/mob/frog/death1.ogg": 925762,
	"./LATEST/mob/frog/death2.ogg": 122305,
	"./LATEST/mob/frog/death3.ogg": 606600,
	"./LATEST/mob/frog/eat1.ogg": 494168,
	"./LATEST/mob/frog/eat2.ogg": 69194,
	"./LATEST/mob/frog/eat3.ogg": 838647,
	"./LATEST/mob/frog/eat4.ogg": 425611,
	"./LATEST/mob/frog/hurt1.ogg": 521727,
	"./LATEST/mob/frog/hurt2.ogg": 878167,
	"./LATEST/mob/frog/hurt3.ogg": 600411,
	"./LATEST/mob/frog/hurt4.ogg": 372985,
	"./LATEST/mob/frog/hurt5.ogg": 904175,
	"./LATEST/mob/frog/idle1.ogg": 32124,
	"./LATEST/mob/frog/idle2.ogg": 781737,
	"./LATEST/mob/frog/idle3.ogg": 182867,
	"./LATEST/mob/frog/idle4.ogg": 820573,
	"./LATEST/mob/frog/idle5.ogg": 116510,
	"./LATEST/mob/frog/idle6.ogg": 286790,
	"./LATEST/mob/frog/idle7.ogg": 112529,
	"./LATEST/mob/frog/idle8.ogg": 691022,
	"./LATEST/mob/frog/lay_spawn1.ogg": 363993,
	"./LATEST/mob/frog/lay_spawn2.ogg": 678134,
	"./LATEST/mob/frog/long_jump1.ogg": 250718,
	"./LATEST/mob/frog/long_jump2.ogg": 537315,
	"./LATEST/mob/frog/long_jump3.ogg": 990135,
	"./LATEST/mob/frog/long_jump4.ogg": 27030,
	"./LATEST/mob/frog/step1.ogg": 596048,
	"./LATEST/mob/frog/step2.ogg": 287539,
	"./LATEST/mob/frog/step3.ogg": 721905,
	"./LATEST/mob/frog/step4.ogg": 314067,
	"./LATEST/mob/frog/tongue1.ogg": 209165,
	"./LATEST/mob/frog/tongue2.ogg": 122119,
	"./LATEST/mob/frog/tongue3.ogg": 34538,
	"./LATEST/mob/frog/tongue4.ogg": 240172,
	"./LATEST/mob/ghast/affectionate_scream.ogg": 853590,
	"./LATEST/mob/ghast/charge.ogg": 537859,
	"./LATEST/mob/ghast/death.ogg": 103304,
	"./LATEST/mob/ghast/fireball4.ogg": 584000,
	"./LATEST/mob/ghast/moan1.ogg": 760974,
	"./LATEST/mob/ghast/moan2.ogg": 921693,
	"./LATEST/mob/ghast/moan3.ogg": 241963,
	"./LATEST/mob/ghast/moan4.ogg": 129949,
	"./LATEST/mob/ghast/moan5.ogg": 998731,
	"./LATEST/mob/ghast/moan6.ogg": 117938,
	"./LATEST/mob/ghast/moan7.ogg": 607700,
	"./LATEST/mob/ghast/scream1.ogg": 992488,
	"./LATEST/mob/ghast/scream2.ogg": 839320,
	"./LATEST/mob/ghast/scream3.ogg": 540152,
	"./LATEST/mob/ghast/scream4.ogg": 702897,
	"./LATEST/mob/ghast/scream5.ogg": 725642,
	"./LATEST/mob/goat/death1.ogg": 305904,
	"./LATEST/mob/goat/death2.ogg": 372665,
	"./LATEST/mob/goat/death3.ogg": 293873,
	"./LATEST/mob/goat/death4.ogg": 919847,
	"./LATEST/mob/goat/death5.ogg": 447213,
	"./LATEST/mob/goat/eat1.ogg": 857609,
	"./LATEST/mob/goat/eat2.ogg": 168885,
	"./LATEST/mob/goat/eat3.ogg": 930348,
	"./LATEST/mob/goat/horn_break1.ogg": 136531,
	"./LATEST/mob/goat/horn_break2.ogg": 544160,
	"./LATEST/mob/goat/horn_break3.ogg": 585750,
	"./LATEST/mob/goat/horn_break4.ogg": 686115,
	"./LATEST/mob/goat/hurt1.ogg": 917782,
	"./LATEST/mob/goat/hurt2.ogg": 47523,
	"./LATEST/mob/goat/hurt3.ogg": 549023,
	"./LATEST/mob/goat/hurt4.ogg": 490288,
	"./LATEST/mob/goat/idle1.ogg": 761157,
	"./LATEST/mob/goat/idle2.ogg": 119044,
	"./LATEST/mob/goat/idle3.ogg": 902842,
	"./LATEST/mob/goat/idle4.ogg": 531510,
	"./LATEST/mob/goat/idle5.ogg": 319582,
	"./LATEST/mob/goat/idle6.ogg": 900411,
	"./LATEST/mob/goat/idle7.ogg": 490626,
	"./LATEST/mob/goat/idle8.ogg": 288568,
	"./LATEST/mob/goat/impact1.ogg": 195530,
	"./LATEST/mob/goat/impact2.ogg": 417314,
	"./LATEST/mob/goat/impact3.ogg": 109457,
	"./LATEST/mob/goat/jump1.ogg": 263045,
	"./LATEST/mob/goat/jump2.ogg": 695960,
	"./LATEST/mob/goat/pre_ram1.ogg": 18465,
	"./LATEST/mob/goat/pre_ram2.ogg": 643966,
	"./LATEST/mob/goat/pre_ram3.ogg": 349657,
	"./LATEST/mob/goat/pre_ram4.ogg": 342880,
	"./LATEST/mob/goat/scream1.ogg": 624898,
	"./LATEST/mob/goat/scream2.ogg": 433651,
	"./LATEST/mob/goat/scream3.ogg": 580149,
	"./LATEST/mob/goat/scream4.ogg": 4462,
	"./LATEST/mob/goat/scream5.ogg": 576060,
	"./LATEST/mob/goat/scream6.ogg": 35223,
	"./LATEST/mob/goat/scream7.ogg": 277670,
	"./LATEST/mob/goat/scream8.ogg": 294286,
	"./LATEST/mob/goat/scream9.ogg": 781554,
	"./LATEST/mob/goat/screaming_death1.ogg": 147382,
	"./LATEST/mob/goat/screaming_death2.ogg": 546786,
	"./LATEST/mob/goat/screaming_death3.ogg": 924514,
	"./LATEST/mob/goat/screaming_hurt1.ogg": 35570,
	"./LATEST/mob/goat/screaming_hurt2.ogg": 469406,
	"./LATEST/mob/goat/screaming_hurt3.ogg": 76748,
	"./LATEST/mob/goat/screaming_milk1.ogg": 346667,
	"./LATEST/mob/goat/screaming_milk2.ogg": 869064,
	"./LATEST/mob/goat/screaming_milk3.ogg": 304770,
	"./LATEST/mob/goat/screaming_milk4.ogg": 991169,
	"./LATEST/mob/goat/screaming_milk5.ogg": 776087,
	"./LATEST/mob/goat/screaming_pre_ram1.ogg": 640340,
	"./LATEST/mob/goat/screaming_pre_ram2.ogg": 816625,
	"./LATEST/mob/goat/screaming_pre_ram3.ogg": 209758,
	"./LATEST/mob/goat/screaming_pre_ram4.ogg": 292482,
	"./LATEST/mob/goat/screaming_pre_ram5.ogg": 2978,
	"./LATEST/mob/goat/step1.ogg": 254684,
	"./LATEST/mob/goat/step2.ogg": 854060,
	"./LATEST/mob/goat/step3.ogg": 304061,
	"./LATEST/mob/goat/step4.ogg": 559683,
	"./LATEST/mob/goat/step5.ogg": 811489,
	"./LATEST/mob/goat/step6.ogg": 349578,
	"./LATEST/mob/guardian/attack_loop.ogg": 26358,
	"./LATEST/mob/guardian/curse.ogg": 785695,
	"./LATEST/mob/guardian/elder_death.ogg": 697697,
	"./LATEST/mob/guardian/elder_hit1.ogg": 932246,
	"./LATEST/mob/guardian/elder_hit2.ogg": 477980,
	"./LATEST/mob/guardian/elder_hit3.ogg": 237542,
	"./LATEST/mob/guardian/elder_hit4.ogg": 115397,
	"./LATEST/mob/guardian/elder_idle1.ogg": 219337,
	"./LATEST/mob/guardian/elder_idle2.ogg": 579074,
	"./LATEST/mob/guardian/elder_idle3.ogg": 721459,
	"./LATEST/mob/guardian/elder_idle4.ogg": 184875,
	"./LATEST/mob/guardian/flop1.ogg": 147730,
	"./LATEST/mob/guardian/flop2.ogg": 304397,
	"./LATEST/mob/guardian/flop3.ogg": 184326,
	"./LATEST/mob/guardian/flop4.ogg": 704169,
	"./LATEST/mob/guardian/guardian_death.ogg": 258155,
	"./LATEST/mob/guardian/guardian_hit1.ogg": 337454,
	"./LATEST/mob/guardian/guardian_hit2.ogg": 203533,
	"./LATEST/mob/guardian/guardian_hit3.ogg": 141267,
	"./LATEST/mob/guardian/guardian_hit4.ogg": 633650,
	"./LATEST/mob/guardian/land_death.ogg": 467344,
	"./LATEST/mob/guardian/land_hit1.ogg": 763591,
	"./LATEST/mob/guardian/land_hit2.ogg": 941106,
	"./LATEST/mob/guardian/land_hit3.ogg": 298397,
	"./LATEST/mob/guardian/land_hit4.ogg": 720594,
	"./LATEST/mob/guardian/land_idle1.ogg": 307591,
	"./LATEST/mob/guardian/land_idle2.ogg": 988313,
	"./LATEST/mob/guardian/land_idle3.ogg": 562804,
	"./LATEST/mob/guardian/land_idle4.ogg": 231977,
	"./LATEST/mob/hoglin/angry1.ogg": 614865,
	"./LATEST/mob/hoglin/angry2.ogg": 984541,
	"./LATEST/mob/hoglin/angry3.ogg": 797918,
	"./LATEST/mob/hoglin/angry4.ogg": 517209,
	"./LATEST/mob/hoglin/angry5.ogg": 695735,
	"./LATEST/mob/hoglin/angry6.ogg": 401944,
	"./LATEST/mob/hoglin/attack1.ogg": 491765,
	"./LATEST/mob/hoglin/attack2.ogg": 227187,
	"./LATEST/mob/hoglin/converted1.ogg": 492205,
	"./LATEST/mob/hoglin/converted2.ogg": 97967,
	"./LATEST/mob/hoglin/death1.ogg": 916223,
	"./LATEST/mob/hoglin/death2.ogg": 730982,
	"./LATEST/mob/hoglin/death3.ogg": 515200,
	"./LATEST/mob/hoglin/hurt1.ogg": 470974,
	"./LATEST/mob/hoglin/hurt2.ogg": 637502,
	"./LATEST/mob/hoglin/hurt3.ogg": 747715,
	"./LATEST/mob/hoglin/hurt4.ogg": 456268,
	"./LATEST/mob/hoglin/idle1.ogg": 476924,
	"./LATEST/mob/hoglin/idle10.ogg": 689422,
	"./LATEST/mob/hoglin/idle11.ogg": 42383,
	"./LATEST/mob/hoglin/idle2.ogg": 690585,
	"./LATEST/mob/hoglin/idle3.ogg": 969497,
	"./LATEST/mob/hoglin/idle4.ogg": 528033,
	"./LATEST/mob/hoglin/idle5.ogg": 484557,
	"./LATEST/mob/hoglin/idle6.ogg": 122247,
	"./LATEST/mob/hoglin/idle7.ogg": 639820,
	"./LATEST/mob/hoglin/idle8.ogg": 874424,
	"./LATEST/mob/hoglin/idle9.ogg": 250214,
	"./LATEST/mob/hoglin/retreat1.ogg": 805910,
	"./LATEST/mob/hoglin/retreat2.ogg": 130455,
	"./LATEST/mob/hoglin/retreat3.ogg": 76225,
	"./LATEST/mob/hoglin/step1.ogg": 275456,
	"./LATEST/mob/hoglin/step2.ogg": 211312,
	"./LATEST/mob/hoglin/step3.ogg": 341975,
	"./LATEST/mob/hoglin/step4.ogg": 653608,
	"./LATEST/mob/hoglin/step5.ogg": 420017,
	"./LATEST/mob/hoglin/step6.ogg": 761162,
	"./LATEST/mob/horse/angry1.ogg": 397043,
	"./LATEST/mob/horse/armor.ogg": 625486,
	"./LATEST/mob/horse/breathe1.ogg": 63994,
	"./LATEST/mob/horse/breathe2.ogg": 498738,
	"./LATEST/mob/horse/breathe3.ogg": 813135,
	"./LATEST/mob/horse/death.ogg": 410421,
	"./LATEST/mob/horse/donkey/angry1.ogg": 824785,
	"./LATEST/mob/horse/donkey/angry2.ogg": 171478,
	"./LATEST/mob/horse/donkey/death.ogg": 460765,
	"./LATEST/mob/horse/donkey/hit1.ogg": 438066,
	"./LATEST/mob/horse/donkey/hit2.ogg": 217906,
	"./LATEST/mob/horse/donkey/hit3.ogg": 31544,
	"./LATEST/mob/horse/donkey/idle1.ogg": 199970,
	"./LATEST/mob/horse/donkey/idle2.ogg": 607263,
	"./LATEST/mob/horse/donkey/idle3.ogg": 698883,
	"./LATEST/mob/horse/gallop1.ogg": 170060,
	"./LATEST/mob/horse/gallop2.ogg": 33942,
	"./LATEST/mob/horse/gallop3.ogg": 626018,
	"./LATEST/mob/horse/gallop4.ogg": 853422,
	"./LATEST/mob/horse/hit1.ogg": 269262,
	"./LATEST/mob/horse/hit2.ogg": 92902,
	"./LATEST/mob/horse/hit3.ogg": 560150,
	"./LATEST/mob/horse/hit4.ogg": 730867,
	"./LATEST/mob/horse/idle1.ogg": 690619,
	"./LATEST/mob/horse/idle2.ogg": 414131,
	"./LATEST/mob/horse/idle3.ogg": 819923,
	"./LATEST/mob/horse/jump.ogg": 729438,
	"./LATEST/mob/horse/land.ogg": 377661,
	"./LATEST/mob/horse/leather.ogg": 487409,
	"./LATEST/mob/horse/skeleton/death.ogg": 459519,
	"./LATEST/mob/horse/skeleton/hit1.ogg": 855419,
	"./LATEST/mob/horse/skeleton/hit2.ogg": 888336,
	"./LATEST/mob/horse/skeleton/hit3.ogg": 226529,
	"./LATEST/mob/horse/skeleton/hit4.ogg": 726451,
	"./LATEST/mob/horse/skeleton/idle1.ogg": 390071,
	"./LATEST/mob/horse/skeleton/idle2.ogg": 54232,
	"./LATEST/mob/horse/skeleton/idle3.ogg": 131046,
	"./LATEST/mob/horse/skeleton/water/gallop1.ogg": 839227,
	"./LATEST/mob/horse/skeleton/water/gallop2.ogg": 94288,
	"./LATEST/mob/horse/skeleton/water/gallop3.ogg": 426213,
	"./LATEST/mob/horse/skeleton/water/gallop4.ogg": 967919,
	"./LATEST/mob/horse/skeleton/water/idle1.ogg": 905536,
	"./LATEST/mob/horse/skeleton/water/idle2.ogg": 242597,
	"./LATEST/mob/horse/skeleton/water/idle3.ogg": 40869,
	"./LATEST/mob/horse/skeleton/water/idle4.ogg": 959348,
	"./LATEST/mob/horse/skeleton/water/idle5.ogg": 448443,
	"./LATEST/mob/horse/skeleton/water/jump.ogg": 512687,
	"./LATEST/mob/horse/skeleton/water/soft1.ogg": 495101,
	"./LATEST/mob/horse/skeleton/water/soft2.ogg": 252628,
	"./LATEST/mob/horse/skeleton/water/soft3.ogg": 785403,
	"./LATEST/mob/horse/skeleton/water/soft4.ogg": 539466,
	"./LATEST/mob/horse/skeleton/water/soft5.ogg": 230958,
	"./LATEST/mob/horse/skeleton/water/soft6.ogg": 322828,
	"./LATEST/mob/horse/soft1.ogg": 27284,
	"./LATEST/mob/horse/soft2.ogg": 972901,
	"./LATEST/mob/horse/soft3.ogg": 826718,
	"./LATEST/mob/horse/soft4.ogg": 130111,
	"./LATEST/mob/horse/soft5.ogg": 783275,
	"./LATEST/mob/horse/soft6.ogg": 132739,
	"./LATEST/mob/horse/wood1.ogg": 355711,
	"./LATEST/mob/horse/wood2.ogg": 811774,
	"./LATEST/mob/horse/wood3.ogg": 251945,
	"./LATEST/mob/horse/wood4.ogg": 525192,
	"./LATEST/mob/horse/wood5.ogg": 708285,
	"./LATEST/mob/horse/wood6.ogg": 262929,
	"./LATEST/mob/horse/zombie/death.ogg": 778923,
	"./LATEST/mob/horse/zombie/hit1.ogg": 278945,
	"./LATEST/mob/horse/zombie/hit2.ogg": 177915,
	"./LATEST/mob/horse/zombie/hit3.ogg": 504295,
	"./LATEST/mob/horse/zombie/hit4.ogg": 548194,
	"./LATEST/mob/horse/zombie/idle1.ogg": 18348,
	"./LATEST/mob/horse/zombie/idle2.ogg": 600069,
	"./LATEST/mob/horse/zombie/idle3.ogg": 690091,
	"./LATEST/mob/husk/convert1.ogg": 266840,
	"./LATEST/mob/husk/convert2.ogg": 820275,
	"./LATEST/mob/husk/death1.ogg": 509529,
	"./LATEST/mob/husk/death2.ogg": 789566,
	"./LATEST/mob/husk/hurt1.ogg": 914116,
	"./LATEST/mob/husk/hurt2.ogg": 974111,
	"./LATEST/mob/husk/idle1.ogg": 593913,
	"./LATEST/mob/husk/idle2.ogg": 30169,
	"./LATEST/mob/husk/idle3.ogg": 38448,
	"./LATEST/mob/husk/step1.ogg": 310398,
	"./LATEST/mob/husk/step2.ogg": 464528,
	"./LATEST/mob/husk/step3.ogg": 649937,
	"./LATEST/mob/husk/step4.ogg": 812440,
	"./LATEST/mob/husk/step5.ogg": 380038,
	"./LATEST/mob/illusion_illager/death1.ogg": 167732,
	"./LATEST/mob/illusion_illager/death2.ogg": 746207,
	"./LATEST/mob/illusion_illager/hurt1.ogg": 696370,
	"./LATEST/mob/illusion_illager/hurt2.ogg": 992068,
	"./LATEST/mob/illusion_illager/hurt3.ogg": 611107,
	"./LATEST/mob/illusion_illager/idle1.ogg": 940390,
	"./LATEST/mob/illusion_illager/idle2.ogg": 908274,
	"./LATEST/mob/illusion_illager/idle3.ogg": 208986,
	"./LATEST/mob/illusion_illager/idle4.ogg": 702061,
	"./LATEST/mob/illusion_illager/mirror_move1.ogg": 185826,
	"./LATEST/mob/illusion_illager/mirror_move2.ogg": 206815,
	"./LATEST/mob/illusion_illager/prepare_blind.ogg": 182002,
	"./LATEST/mob/illusion_illager/prepare_mirror.ogg": 897055,
	"./LATEST/mob/irongolem/damage1.ogg": 295520,
	"./LATEST/mob/irongolem/damage2.ogg": 547606,
	"./LATEST/mob/irongolem/death.ogg": 983514,
	"./LATEST/mob/irongolem/hit1.ogg": 424697,
	"./LATEST/mob/irongolem/hit2.ogg": 826085,
	"./LATEST/mob/irongolem/hit3.ogg": 301957,
	"./LATEST/mob/irongolem/hit4.ogg": 365439,
	"./LATEST/mob/irongolem/repair.ogg": 467122,
	"./LATEST/mob/irongolem/throw.ogg": 542328,
	"./LATEST/mob/irongolem/walk1.ogg": 560647,
	"./LATEST/mob/irongolem/walk2.ogg": 740567,
	"./LATEST/mob/irongolem/walk3.ogg": 612633,
	"./LATEST/mob/irongolem/walk4.ogg": 600586,
	"./LATEST/mob/llama/angry1.ogg": 62399,
	"./LATEST/mob/llama/death1.ogg": 984620,
	"./LATEST/mob/llama/death2.ogg": 634368,
	"./LATEST/mob/llama/eat1.ogg": 193235,
	"./LATEST/mob/llama/eat2.ogg": 332825,
	"./LATEST/mob/llama/eat3.ogg": 418521,
	"./LATEST/mob/llama/hurt1.ogg": 731905,
	"./LATEST/mob/llama/hurt2.ogg": 754892,
	"./LATEST/mob/llama/hurt3.ogg": 385553,
	"./LATEST/mob/llama/idle1.ogg": 707835,
	"./LATEST/mob/llama/idle2.ogg": 540885,
	"./LATEST/mob/llama/idle3.ogg": 617070,
	"./LATEST/mob/llama/idle4.ogg": 1917,
	"./LATEST/mob/llama/idle5.ogg": 103121,
	"./LATEST/mob/llama/spit1.ogg": 934505,
	"./LATEST/mob/llama/spit2.ogg": 529863,
	"./LATEST/mob/llama/step1.ogg": 745371,
	"./LATEST/mob/llama/step2.ogg": 854588,
	"./LATEST/mob/llama/step3.ogg": 58269,
	"./LATEST/mob/llama/step4.ogg": 145556,
	"./LATEST/mob/llama/step5.ogg": 156505,
	"./LATEST/mob/llama/swag.ogg": 961744,
	"./LATEST/mob/magmacube/big1.ogg": 597938,
	"./LATEST/mob/magmacube/big2.ogg": 783403,
	"./LATEST/mob/magmacube/big3.ogg": 507438,
	"./LATEST/mob/magmacube/big4.ogg": 23713,
	"./LATEST/mob/magmacube/jump1.ogg": 912506,
	"./LATEST/mob/magmacube/jump2.ogg": 233127,
	"./LATEST/mob/magmacube/jump3.ogg": 378176,
	"./LATEST/mob/magmacube/jump4.ogg": 897931,
	"./LATEST/mob/magmacube/small1.ogg": 955758,
	"./LATEST/mob/magmacube/small2.ogg": 185914,
	"./LATEST/mob/magmacube/small3.ogg": 967881,
	"./LATEST/mob/magmacube/small4.ogg": 445942,
	"./LATEST/mob/magmacube/small5.ogg": 510033,
	"./LATEST/mob/mooshroom/convert1.ogg": 394402,
	"./LATEST/mob/mooshroom/convert2.ogg": 188856,
	"./LATEST/mob/mooshroom/eat1.ogg": 494116,
	"./LATEST/mob/mooshroom/eat2.ogg": 736606,
	"./LATEST/mob/mooshroom/eat3.ogg": 63504,
	"./LATEST/mob/mooshroom/eat4.ogg": 210101,
	"./LATEST/mob/mooshroom/milk1.ogg": 565192,
	"./LATEST/mob/mooshroom/milk2.ogg": 932375,
	"./LATEST/mob/mooshroom/milk3.ogg": 243386,
	"./LATEST/mob/panda/aggressive/aggressive1.ogg": 936325,
	"./LATEST/mob/panda/aggressive/aggressive2.ogg": 827334,
	"./LATEST/mob/panda/aggressive/aggressive3.ogg": 17740,
	"./LATEST/mob/panda/aggressive/aggressive4.ogg": 469920,
	"./LATEST/mob/panda/bite1.ogg": 893802,
	"./LATEST/mob/panda/bite2.ogg": 176495,
	"./LATEST/mob/panda/bite3.ogg": 158918,
	"./LATEST/mob/panda/cant_breed1.ogg": 676547,
	"./LATEST/mob/panda/cant_breed2.ogg": 667359,
	"./LATEST/mob/panda/cant_breed3.ogg": 713467,
	"./LATEST/mob/panda/cant_breed4.ogg": 6065,
	"./LATEST/mob/panda/cant_breed5.ogg": 747887,
	"./LATEST/mob/panda/death1.ogg": 456222,
	"./LATEST/mob/panda/death2.ogg": 324378,
	"./LATEST/mob/panda/death3.ogg": 251973,
	"./LATEST/mob/panda/death4.ogg": 577999,
	"./LATEST/mob/panda/eat1.ogg": 210155,
	"./LATEST/mob/panda/eat10.ogg": 731022,
	"./LATEST/mob/panda/eat11.ogg": 322997,
	"./LATEST/mob/panda/eat12.ogg": 622602,
	"./LATEST/mob/panda/eat2.ogg": 218865,
	"./LATEST/mob/panda/eat3.ogg": 655738,
	"./LATEST/mob/panda/eat4.ogg": 836299,
	"./LATEST/mob/panda/eat5.ogg": 819407,
	"./LATEST/mob/panda/eat6.ogg": 352924,
	"./LATEST/mob/panda/eat7.ogg": 407016,
	"./LATEST/mob/panda/eat8.ogg": 242014,
	"./LATEST/mob/panda/eat9.ogg": 888000,
	"./LATEST/mob/panda/hurt1.ogg": 710881,
	"./LATEST/mob/panda/hurt2.ogg": 920199,
	"./LATEST/mob/panda/hurt3.ogg": 393361,
	"./LATEST/mob/panda/hurt4.ogg": 323769,
	"./LATEST/mob/panda/hurt5.ogg": 353375,
	"./LATEST/mob/panda/hurt6.ogg": 295040,
	"./LATEST/mob/panda/idle1.ogg": 978727,
	"./LATEST/mob/panda/idle2.ogg": 798384,
	"./LATEST/mob/panda/idle3.ogg": 900299,
	"./LATEST/mob/panda/idle4.ogg": 410361,
	"./LATEST/mob/panda/nosebreath1.ogg": 245543,
	"./LATEST/mob/panda/nosebreath2.ogg": 280465,
	"./LATEST/mob/panda/nosebreath3.ogg": 884606,
	"./LATEST/mob/panda/pant1.ogg": 590451,
	"./LATEST/mob/panda/pant2.ogg": 999228,
	"./LATEST/mob/panda/pre_sneeze.ogg": 944284,
	"./LATEST/mob/panda/sneeze1.ogg": 799406,
	"./LATEST/mob/panda/sneeze2.ogg": 777667,
	"./LATEST/mob/panda/sneeze3.ogg": 368796,
	"./LATEST/mob/panda/step1.ogg": 886415,
	"./LATEST/mob/panda/step2.ogg": 30933,
	"./LATEST/mob/panda/step3.ogg": 176146,
	"./LATEST/mob/panda/step4.ogg": 946318,
	"./LATEST/mob/panda/step5.ogg": 336369,
	"./LATEST/mob/panda/worried/worried1.ogg": 401304,
	"./LATEST/mob/panda/worried/worried2.ogg": 400158,
	"./LATEST/mob/panda/worried/worried3.ogg": 727883,
	"./LATEST/mob/panda/worried/worried4.ogg": 633876,
	"./LATEST/mob/panda/worried/worried5.ogg": 822873,
	"./LATEST/mob/panda/worried/worried6.ogg": 343618,
	"./LATEST/mob/parrot/death1.ogg": 162483,
	"./LATEST/mob/parrot/death2.ogg": 150300,
	"./LATEST/mob/parrot/death3.ogg": 615676,
	"./LATEST/mob/parrot/death4.ogg": 45351,
	"./LATEST/mob/parrot/eat1.ogg": 625821,
	"./LATEST/mob/parrot/eat2.ogg": 730710,
	"./LATEST/mob/parrot/eat3.ogg": 295839,
	"./LATEST/mob/parrot/fly1.ogg": 388510,
	"./LATEST/mob/parrot/fly2.ogg": 97481,
	"./LATEST/mob/parrot/fly3.ogg": 562028,
	"./LATEST/mob/parrot/fly4.ogg": 613412,
	"./LATEST/mob/parrot/fly5.ogg": 798751,
	"./LATEST/mob/parrot/fly6.ogg": 419607,
	"./LATEST/mob/parrot/fly7.ogg": 632937,
	"./LATEST/mob/parrot/fly8.ogg": 404802,
	"./LATEST/mob/parrot/hurt1.ogg": 739891,
	"./LATEST/mob/parrot/hurt2.ogg": 139729,
	"./LATEST/mob/parrot/idle1.ogg": 171262,
	"./LATEST/mob/parrot/idle2.ogg": 468489,
	"./LATEST/mob/parrot/idle3.ogg": 756973,
	"./LATEST/mob/parrot/idle4.ogg": 552863,
	"./LATEST/mob/parrot/idle5.ogg": 352573,
	"./LATEST/mob/parrot/idle6.ogg": 231338,
	"./LATEST/mob/parrot/step1.ogg": 237595,
	"./LATEST/mob/parrot/step2.ogg": 9558,
	"./LATEST/mob/parrot/step3.ogg": 495100,
	"./LATEST/mob/parrot/step4.ogg": 903479,
	"./LATEST/mob/parrot/step5.ogg": 655234,
	"./LATEST/mob/phantom/bite1.ogg": 704412,
	"./LATEST/mob/phantom/bite2.ogg": 929706,
	"./LATEST/mob/phantom/death1.ogg": 412385,
	"./LATEST/mob/phantom/death2.ogg": 265498,
	"./LATEST/mob/phantom/death3.ogg": 437501,
	"./LATEST/mob/phantom/flap1.ogg": 969205,
	"./LATEST/mob/phantom/flap2.ogg": 174581,
	"./LATEST/mob/phantom/flap3.ogg": 439213,
	"./LATEST/mob/phantom/flap4.ogg": 57845,
	"./LATEST/mob/phantom/flap5.ogg": 879024,
	"./LATEST/mob/phantom/flap6.ogg": 11218,
	"./LATEST/mob/phantom/hurt1.ogg": 259215,
	"./LATEST/mob/phantom/hurt2.ogg": 861484,
	"./LATEST/mob/phantom/hurt3.ogg": 929008,
	"./LATEST/mob/phantom/idle1.ogg": 962331,
	"./LATEST/mob/phantom/idle2.ogg": 719967,
	"./LATEST/mob/phantom/idle3.ogg": 703887,
	"./LATEST/mob/phantom/idle4.ogg": 579525,
	"./LATEST/mob/phantom/idle5.ogg": 807242,
	"./LATEST/mob/phantom/swoop1.ogg": 715673,
	"./LATEST/mob/phantom/swoop2.ogg": 143407,
	"./LATEST/mob/phantom/swoop3.ogg": 485082,
	"./LATEST/mob/phantom/swoop4.ogg": 288611,
	"./LATEST/mob/pig/death.ogg": 966591,
	"./LATEST/mob/pig/say1.ogg": 557872,
	"./LATEST/mob/pig/say2.ogg": 50151,
	"./LATEST/mob/pig/say3.ogg": 874973,
	"./LATEST/mob/pig/step1.ogg": 744700,
	"./LATEST/mob/pig/step2.ogg": 15321,
	"./LATEST/mob/pig/step3.ogg": 740723,
	"./LATEST/mob/pig/step4.ogg": 128718,
	"./LATEST/mob/pig/step5.ogg": 76501,
	"./LATEST/mob/piglin/admire1.ogg": 924473,
	"./LATEST/mob/piglin/admire2.ogg": 739861,
	"./LATEST/mob/piglin/angry1.ogg": 298281,
	"./LATEST/mob/piglin/angry2.ogg": 563208,
	"./LATEST/mob/piglin/angry3.ogg": 646239,
	"./LATEST/mob/piglin/angry4.ogg": 687030,
	"./LATEST/mob/piglin/celebrate1.ogg": 62898,
	"./LATEST/mob/piglin/celebrate2.ogg": 557803,
	"./LATEST/mob/piglin/celebrate3.ogg": 868385,
	"./LATEST/mob/piglin/celebrate4.ogg": 80420,
	"./LATEST/mob/piglin/converted1.ogg": 444229,
	"./LATEST/mob/piglin/converted2.ogg": 838068,
	"./LATEST/mob/piglin/death1.ogg": 726218,
	"./LATEST/mob/piglin/death2.ogg": 771851,
	"./LATEST/mob/piglin/death3.ogg": 445134,
	"./LATEST/mob/piglin/death4.ogg": 260312,
	"./LATEST/mob/piglin/hurt1.ogg": 252849,
	"./LATEST/mob/piglin/hurt2.ogg": 258936,
	"./LATEST/mob/piglin/hurt3.ogg": 739266,
	"./LATEST/mob/piglin/idle1.ogg": 658242,
	"./LATEST/mob/piglin/idle2.ogg": 434089,
	"./LATEST/mob/piglin/idle3.ogg": 809337,
	"./LATEST/mob/piglin/idle4.ogg": 454271,
	"./LATEST/mob/piglin/idle5.ogg": 577383,
	"./LATEST/mob/piglin/jealous1.ogg": 885605,
	"./LATEST/mob/piglin/jealous2.ogg": 805546,
	"./LATEST/mob/piglin/jealous3.ogg": 289208,
	"./LATEST/mob/piglin/jealous4.ogg": 740797,
	"./LATEST/mob/piglin/jealous5.ogg": 239895,
	"./LATEST/mob/piglin/retreat1.ogg": 980222,
	"./LATEST/mob/piglin/retreat2.ogg": 310093,
	"./LATEST/mob/piglin/retreat3.ogg": 850000,
	"./LATEST/mob/piglin/retreat4.ogg": 62060,
	"./LATEST/mob/piglin/step1.ogg": 560290,
	"./LATEST/mob/piglin/step2.ogg": 84419,
	"./LATEST/mob/piglin/step3.ogg": 590186,
	"./LATEST/mob/piglin/step4.ogg": 63242,
	"./LATEST/mob/piglin/step5.ogg": 348559,
	"./LATEST/mob/piglin_brute/angry1.ogg": 664742,
	"./LATEST/mob/piglin_brute/angry2.ogg": 36178,
	"./LATEST/mob/piglin_brute/angry3.ogg": 610019,
	"./LATEST/mob/piglin_brute/angry4.ogg": 439146,
	"./LATEST/mob/piglin_brute/angry5.ogg": 265962,
	"./LATEST/mob/piglin_brute/death1.ogg": 990364,
	"./LATEST/mob/piglin_brute/death2.ogg": 263113,
	"./LATEST/mob/piglin_brute/death3.ogg": 136174,
	"./LATEST/mob/piglin_brute/hurt1.ogg": 16453,
	"./LATEST/mob/piglin_brute/hurt2.ogg": 922186,
	"./LATEST/mob/piglin_brute/hurt3.ogg": 938804,
	"./LATEST/mob/piglin_brute/hurt4.ogg": 815270,
	"./LATEST/mob/piglin_brute/idle1.ogg": 627765,
	"./LATEST/mob/piglin_brute/idle2.ogg": 138473,
	"./LATEST/mob/piglin_brute/idle3.ogg": 310089,
	"./LATEST/mob/piglin_brute/idle4.ogg": 459086,
	"./LATEST/mob/piglin_brute/idle5.ogg": 454170,
	"./LATEST/mob/piglin_brute/idle6.ogg": 30868,
	"./LATEST/mob/piglin_brute/idle7.ogg": 448714,
	"./LATEST/mob/piglin_brute/idle8.ogg": 326241,
	"./LATEST/mob/piglin_brute/idle9.ogg": 659569,
	"./LATEST/mob/piglin_brute/step1.ogg": 306299,
	"./LATEST/mob/piglin_brute/step2.ogg": 844416,
	"./LATEST/mob/piglin_brute/step3.ogg": 708611,
	"./LATEST/mob/piglin_brute/step4.ogg": 899125,
	"./LATEST/mob/piglin_brute/step5.ogg": 314635,
	"./LATEST/mob/pillager/celebrate1.ogg": 131972,
	"./LATEST/mob/pillager/celebrate2.ogg": 27565,
	"./LATEST/mob/pillager/celebrate3.ogg": 782856,
	"./LATEST/mob/pillager/celebrate4.ogg": 325221,
	"./LATEST/mob/pillager/death1.ogg": 218306,
	"./LATEST/mob/pillager/death2.ogg": 984890,
	"./LATEST/mob/pillager/horn_celebrate.ogg": 454016,
	"./LATEST/mob/pillager/hurt1.ogg": 651451,
	"./LATEST/mob/pillager/hurt2.ogg": 459052,
	"./LATEST/mob/pillager/hurt3.ogg": 507216,
	"./LATEST/mob/pillager/idle1.ogg": 573155,
	"./LATEST/mob/pillager/idle2.ogg": 739885,
	"./LATEST/mob/pillager/idle3.ogg": 523666,
	"./LATEST/mob/pillager/idle4.ogg": 285315,
	"./LATEST/mob/polarbear/death1.ogg": 123689,
	"./LATEST/mob/polarbear/death2.ogg": 564906,
	"./LATEST/mob/polarbear/death3.ogg": 172071,
	"./LATEST/mob/polarbear/hurt1.ogg": 297241,
	"./LATEST/mob/polarbear/hurt2.ogg": 590697,
	"./LATEST/mob/polarbear/hurt3.ogg": 112899,
	"./LATEST/mob/polarbear/hurt4.ogg": 35764,
	"./LATEST/mob/polarbear/idle1.ogg": 956326,
	"./LATEST/mob/polarbear/idle2.ogg": 129780,
	"./LATEST/mob/polarbear/idle3.ogg": 2895,
	"./LATEST/mob/polarbear/idle4.ogg": 336639,
	"./LATEST/mob/polarbear/step1.ogg": 639022,
	"./LATEST/mob/polarbear/step2.ogg": 314550,
	"./LATEST/mob/polarbear/step3.ogg": 75307,
	"./LATEST/mob/polarbear/step4.ogg": 820878,
	"./LATEST/mob/polarbear/warning1.ogg": 550023,
	"./LATEST/mob/polarbear/warning2.ogg": 128120,
	"./LATEST/mob/polarbear/warning3.ogg": 639509,
	"./LATEST/mob/polarbear_baby/idle1.ogg": 855533,
	"./LATEST/mob/polarbear_baby/idle2.ogg": 502459,
	"./LATEST/mob/polarbear_baby/idle3.ogg": 493505,
	"./LATEST/mob/polarbear_baby/idle4.ogg": 474488,
	"./LATEST/mob/rabbit/bunnymurder.ogg": 365930,
	"./LATEST/mob/rabbit/hop1.ogg": 249724,
	"./LATEST/mob/rabbit/hop2.ogg": 237733,
	"./LATEST/mob/rabbit/hop3.ogg": 239217,
	"./LATEST/mob/rabbit/hop4.ogg": 480864,
	"./LATEST/mob/rabbit/hurt1.ogg": 823231,
	"./LATEST/mob/rabbit/hurt2.ogg": 723391,
	"./LATEST/mob/rabbit/hurt3.ogg": 376261,
	"./LATEST/mob/rabbit/hurt4.ogg": 803394,
	"./LATEST/mob/rabbit/idle1.ogg": 116672,
	"./LATEST/mob/rabbit/idle2.ogg": 491694,
	"./LATEST/mob/rabbit/idle3.ogg": 996588,
	"./LATEST/mob/rabbit/idle4.ogg": 78505,
	"./LATEST/mob/ravager/bite1.ogg": 420707,
	"./LATEST/mob/ravager/bite2.ogg": 274104,
	"./LATEST/mob/ravager/bite3.ogg": 55397,
	"./LATEST/mob/ravager/celebrate1.ogg": 671101,
	"./LATEST/mob/ravager/celebrate2.ogg": 478731,
	"./LATEST/mob/ravager/death1.ogg": 860981,
	"./LATEST/mob/ravager/death2.ogg": 328500,
	"./LATEST/mob/ravager/death3.ogg": 970008,
	"./LATEST/mob/ravager/hurt1.ogg": 174002,
	"./LATEST/mob/ravager/hurt2.ogg": 580752,
	"./LATEST/mob/ravager/hurt3.ogg": 306827,
	"./LATEST/mob/ravager/hurt4.ogg": 645160,
	"./LATEST/mob/ravager/idle1.ogg": 304425,
	"./LATEST/mob/ravager/idle2.ogg": 19412,
	"./LATEST/mob/ravager/idle3.ogg": 215210,
	"./LATEST/mob/ravager/idle4.ogg": 111387,
	"./LATEST/mob/ravager/idle5.ogg": 815590,
	"./LATEST/mob/ravager/idle6.ogg": 541607,
	"./LATEST/mob/ravager/idle7.ogg": 133186,
	"./LATEST/mob/ravager/idle8.ogg": 649419,
	"./LATEST/mob/ravager/roar1.ogg": 901889,
	"./LATEST/mob/ravager/roar2.ogg": 406410,
	"./LATEST/mob/ravager/roar3.ogg": 789028,
	"./LATEST/mob/ravager/roar4.ogg": 427036,
	"./LATEST/mob/ravager/step1.ogg": 958668,
	"./LATEST/mob/ravager/step2.ogg": 115458,
	"./LATEST/mob/ravager/step3.ogg": 28775,
	"./LATEST/mob/ravager/step4.ogg": 389624,
	"./LATEST/mob/ravager/step5.ogg": 849674,
	"./LATEST/mob/ravager/stun1.ogg": 4430,
	"./LATEST/mob/ravager/stun2.ogg": 166074,
	"./LATEST/mob/ravager/stun3.ogg": 217268,
	"./LATEST/mob/sheep/say1.ogg": 438512,
	"./LATEST/mob/sheep/say2.ogg": 663705,
	"./LATEST/mob/sheep/say3.ogg": 501355,
	"./LATEST/mob/sheep/shear.ogg": 254178,
	"./LATEST/mob/sheep/step1.ogg": 377118,
	"./LATEST/mob/sheep/step2.ogg": 4523,
	"./LATEST/mob/sheep/step3.ogg": 110820,
	"./LATEST/mob/sheep/step4.ogg": 38520,
	"./LATEST/mob/sheep/step5.ogg": 171121,
	"./LATEST/mob/silverfish/hit1.ogg": 414694,
	"./LATEST/mob/silverfish/hit2.ogg": 924545,
	"./LATEST/mob/silverfish/hit3.ogg": 669758,
	"./LATEST/mob/silverfish/kill.ogg": 167407,
	"./LATEST/mob/silverfish/say1.ogg": 956353,
	"./LATEST/mob/silverfish/say2.ogg": 400067,
	"./LATEST/mob/silverfish/say3.ogg": 722378,
	"./LATEST/mob/silverfish/say4.ogg": 44269,
	"./LATEST/mob/silverfish/step1.ogg": 265167,
	"./LATEST/mob/silverfish/step2.ogg": 608775,
	"./LATEST/mob/silverfish/step3.ogg": 670146,
	"./LATEST/mob/silverfish/step4.ogg": 412603,
	"./LATEST/mob/skeleton/death.ogg": 669466,
	"./LATEST/mob/skeleton/hurt1.ogg": 785928,
	"./LATEST/mob/skeleton/hurt2.ogg": 135943,
	"./LATEST/mob/skeleton/hurt3.ogg": 307972,
	"./LATEST/mob/skeleton/hurt4.ogg": 18673,
	"./LATEST/mob/skeleton/say1.ogg": 252734,
	"./LATEST/mob/skeleton/say2.ogg": 73646,
	"./LATEST/mob/skeleton/say3.ogg": 834322,
	"./LATEST/mob/skeleton/step1.ogg": 872181,
	"./LATEST/mob/skeleton/step2.ogg": 614155,
	"./LATEST/mob/skeleton/step3.ogg": 121113,
	"./LATEST/mob/skeleton/step4.ogg": 422400,
	"./LATEST/mob/slime/attack1.ogg": 692302,
	"./LATEST/mob/slime/attack2.ogg": 981878,
	"./LATEST/mob/slime/big1.ogg": 746068,
	"./LATEST/mob/slime/big2.ogg": 163095,
	"./LATEST/mob/slime/big3.ogg": 278611,
	"./LATEST/mob/slime/big4.ogg": 953786,
	"./LATEST/mob/slime/small1.ogg": 600104,
	"./LATEST/mob/slime/small2.ogg": 944996,
	"./LATEST/mob/slime/small3.ogg": 792412,
	"./LATEST/mob/slime/small4.ogg": 650179,
	"./LATEST/mob/slime/small5.ogg": 778766,
	"./LATEST/mob/sniffer/death1.ogg": 84360,
	"./LATEST/mob/sniffer/death2.ogg": 46701,
	"./LATEST/mob/sniffer/digging_stop1.ogg": 175193,
	"./LATEST/mob/sniffer/digging_stop2.ogg": 811770,
	"./LATEST/mob/sniffer/eat1.ogg": 362225,
	"./LATEST/mob/sniffer/eat2.ogg": 691923,
	"./LATEST/mob/sniffer/eat3.ogg": 129476,
	"./LATEST/mob/sniffer/happy1.ogg": 139379,
	"./LATEST/mob/sniffer/happy2.ogg": 508526,
	"./LATEST/mob/sniffer/happy3.ogg": 523652,
	"./LATEST/mob/sniffer/happy4.ogg": 793748,
	"./LATEST/mob/sniffer/happy5.ogg": 801070,
	"./LATEST/mob/sniffer/hurt1.ogg": 292586,
	"./LATEST/mob/sniffer/hurt2.ogg": 91525,
	"./LATEST/mob/sniffer/hurt3.ogg": 709415,
	"./LATEST/mob/sniffer/idle1.ogg": 865991,
	"./LATEST/mob/sniffer/idle10.ogg": 257965,
	"./LATEST/mob/sniffer/idle11.ogg": 782651,
	"./LATEST/mob/sniffer/idle2.ogg": 698013,
	"./LATEST/mob/sniffer/idle3.ogg": 837128,
	"./LATEST/mob/sniffer/idle4.ogg": 237974,
	"./LATEST/mob/sniffer/idle5.ogg": 855264,
	"./LATEST/mob/sniffer/idle6.ogg": 451687,
	"./LATEST/mob/sniffer/idle7.ogg": 200462,
	"./LATEST/mob/sniffer/idle8.ogg": 483576,
	"./LATEST/mob/sniffer/idle9.ogg": 505404,
	"./LATEST/mob/sniffer/longdig1.ogg": 149471,
	"./LATEST/mob/sniffer/longdig2.ogg": 466297,
	"./LATEST/mob/sniffer/scenting1.ogg": 726973,
	"./LATEST/mob/sniffer/scenting2.ogg": 600321,
	"./LATEST/mob/sniffer/scenting3.ogg": 753765,
	"./LATEST/mob/sniffer/searching1.ogg": 969151,
	"./LATEST/mob/sniffer/searching2.ogg": 87694,
	"./LATEST/mob/sniffer/searching3.ogg": 94295,
	"./LATEST/mob/sniffer/searching4.ogg": 973063,
	"./LATEST/mob/sniffer/searching5.ogg": 459514,
	"./LATEST/mob/sniffer/searching6.ogg": 647591,
	"./LATEST/mob/sniffer/sniffing1.ogg": 83560,
	"./LATEST/mob/sniffer/sniffing2.ogg": 368515,
	"./LATEST/mob/sniffer/sniffing3.ogg": 460901,
	"./LATEST/mob/sniffer/step1.ogg": 709299,
	"./LATEST/mob/sniffer/step2.ogg": 306698,
	"./LATEST/mob/sniffer/step3.ogg": 407172,
	"./LATEST/mob/sniffer/step4.ogg": 405464,
	"./LATEST/mob/sniffer/step5.ogg": 410943,
	"./LATEST/mob/sniffer/step6.ogg": 411792,
	"./LATEST/mob/spider/death.ogg": 710723,
	"./LATEST/mob/spider/say1.ogg": 499544,
	"./LATEST/mob/spider/say2.ogg": 423638,
	"./LATEST/mob/spider/say3.ogg": 101988,
	"./LATEST/mob/spider/say4.ogg": 245649,
	"./LATEST/mob/spider/step1.ogg": 521582,
	"./LATEST/mob/spider/step2.ogg": 220765,
	"./LATEST/mob/spider/step3.ogg": 314579,
	"./LATEST/mob/spider/step4.ogg": 568078,
	"./LATEST/mob/stray/convert1.ogg": 241575,
	"./LATEST/mob/stray/convert2.ogg": 436353,
	"./LATEST/mob/stray/convert3.ogg": 100319,
	"./LATEST/mob/stray/death1.ogg": 795749,
	"./LATEST/mob/stray/death2.ogg": 737800,
	"./LATEST/mob/stray/hurt1.ogg": 420973,
	"./LATEST/mob/stray/hurt2.ogg": 834463,
	"./LATEST/mob/stray/hurt3.ogg": 465424,
	"./LATEST/mob/stray/hurt4.ogg": 544530,
	"./LATEST/mob/stray/idle1.ogg": 295239,
	"./LATEST/mob/stray/idle2.ogg": 672219,
	"./LATEST/mob/stray/idle3.ogg": 585694,
	"./LATEST/mob/stray/idle4.ogg": 149687,
	"./LATEST/mob/stray/step1.ogg": 276467,
	"./LATEST/mob/stray/step2.ogg": 685211,
	"./LATEST/mob/stray/step3.ogg": 440261,
	"./LATEST/mob/stray/step4.ogg": 855975,
	"./LATEST/mob/strider/death1.ogg": 28501,
	"./LATEST/mob/strider/death2.ogg": 819334,
	"./LATEST/mob/strider/death3.ogg": 888436,
	"./LATEST/mob/strider/death4.ogg": 955703,
	"./LATEST/mob/strider/eat1.ogg": 13864,
	"./LATEST/mob/strider/eat2.ogg": 643478,
	"./LATEST/mob/strider/eat3.ogg": 501978,
	"./LATEST/mob/strider/happy1.ogg": 715258,
	"./LATEST/mob/strider/happy2.ogg": 389251,
	"./LATEST/mob/strider/happy3.ogg": 927107,
	"./LATEST/mob/strider/happy4.ogg": 907240,
	"./LATEST/mob/strider/happy5.ogg": 86019,
	"./LATEST/mob/strider/hurt1.ogg": 552194,
	"./LATEST/mob/strider/hurt2.ogg": 333716,
	"./LATEST/mob/strider/hurt3.ogg": 437489,
	"./LATEST/mob/strider/hurt4.ogg": 756315,
	"./LATEST/mob/strider/idle1.ogg": 268584,
	"./LATEST/mob/strider/idle2.ogg": 12766,
	"./LATEST/mob/strider/idle3.ogg": 22557,
	"./LATEST/mob/strider/idle4.ogg": 773247,
	"./LATEST/mob/strider/idle5.ogg": 588595,
	"./LATEST/mob/strider/idle6.ogg": 916285,
	"./LATEST/mob/strider/retreat1.ogg": 409896,
	"./LATEST/mob/strider/retreat2.ogg": 804823,
	"./LATEST/mob/strider/retreat3.ogg": 294056,
	"./LATEST/mob/strider/retreat4.ogg": 283958,
	"./LATEST/mob/strider/retreat5.ogg": 552528,
	"./LATEST/mob/strider/step1.ogg": 260180,
	"./LATEST/mob/strider/step2.ogg": 600126,
	"./LATEST/mob/strider/step3.ogg": 91171,
	"./LATEST/mob/strider/step4.ogg": 85510,
	"./LATEST/mob/strider/step5.ogg": 280211,
	"./LATEST/mob/strider/step_lava1.ogg": 524296,
	"./LATEST/mob/strider/step_lava2.ogg": 67522,
	"./LATEST/mob/strider/step_lava3.ogg": 358000,
	"./LATEST/mob/strider/step_lava4.ogg": 426296,
	"./LATEST/mob/strider/step_lava5.ogg": 782625,
	"./LATEST/mob/strider/step_lava6.ogg": 527191,
	"./LATEST/mob/tadpole/death1.ogg": 677988,
	"./LATEST/mob/tadpole/death2.ogg": 948192,
	"./LATEST/mob/tadpole/hurt1.ogg": 115327,
	"./LATEST/mob/tadpole/hurt2.ogg": 243972,
	"./LATEST/mob/tadpole/hurt3.ogg": 391818,
	"./LATEST/mob/tadpole/hurt4.ogg": 662898,
	"./LATEST/mob/turtle/armor.ogg": 310455,
	"./LATEST/mob/turtle/baby/death1.ogg": 691459,
	"./LATEST/mob/turtle/baby/death2.ogg": 503982,
	"./LATEST/mob/turtle/baby/egg_hatched1.ogg": 763708,
	"./LATEST/mob/turtle/baby/egg_hatched2.ogg": 927026,
	"./LATEST/mob/turtle/baby/egg_hatched3.ogg": 770850,
	"./LATEST/mob/turtle/baby/hurt1.ogg": 75238,
	"./LATEST/mob/turtle/baby/hurt2.ogg": 529667,
	"./LATEST/mob/turtle/baby/shamble1.ogg": 963666,
	"./LATEST/mob/turtle/baby/shamble2.ogg": 446229,
	"./LATEST/mob/turtle/baby/shamble3.ogg": 563503,
	"./LATEST/mob/turtle/baby/shamble4.ogg": 797120,
	"./LATEST/mob/turtle/death1.ogg": 632687,
	"./LATEST/mob/turtle/death2.ogg": 953744,
	"./LATEST/mob/turtle/death3.ogg": 254347,
	"./LATEST/mob/turtle/egg/drop_egg1.ogg": 287294,
	"./LATEST/mob/turtle/egg/drop_egg2.ogg": 202640,
	"./LATEST/mob/turtle/egg/egg_break1.ogg": 621309,
	"./LATEST/mob/turtle/egg/egg_break2.ogg": 415849,
	"./LATEST/mob/turtle/egg/egg_crack1.ogg": 651055,
	"./LATEST/mob/turtle/egg/egg_crack2.ogg": 947742,
	"./LATEST/mob/turtle/egg/egg_crack3.ogg": 174816,
	"./LATEST/mob/turtle/egg/egg_crack4.ogg": 63587,
	"./LATEST/mob/turtle/egg/egg_crack5.ogg": 450863,
	"./LATEST/mob/turtle/egg/jump_egg1.ogg": 754534,
	"./LATEST/mob/turtle/egg/jump_egg2.ogg": 771455,
	"./LATEST/mob/turtle/egg/jump_egg3.ogg": 425210,
	"./LATEST/mob/turtle/egg/jump_egg4.ogg": 434642,
	"./LATEST/mob/turtle/hurt1.ogg": 417373,
	"./LATEST/mob/turtle/hurt2.ogg": 702421,
	"./LATEST/mob/turtle/hurt3.ogg": 943957,
	"./LATEST/mob/turtle/hurt4.ogg": 16226,
	"./LATEST/mob/turtle/hurt5.ogg": 250863,
	"./LATEST/mob/turtle/idle1.ogg": 998176,
	"./LATEST/mob/turtle/idle2.ogg": 553799,
	"./LATEST/mob/turtle/idle3.ogg": 846452,
	"./LATEST/mob/turtle/swim/swim1.ogg": 511659,
	"./LATEST/mob/turtle/swim/swim2.ogg": 148002,
	"./LATEST/mob/turtle/swim/swim3.ogg": 637520,
	"./LATEST/mob/turtle/swim/swim4.ogg": 720372,
	"./LATEST/mob/turtle/swim/swim5.ogg": 891890,
	"./LATEST/mob/turtle/walk1.ogg": 570423,
	"./LATEST/mob/turtle/walk2.ogg": 946946,
	"./LATEST/mob/turtle/walk3.ogg": 499502,
	"./LATEST/mob/turtle/walk4.ogg": 822552,
	"./LATEST/mob/turtle/walk5.ogg": 637629,
	"./LATEST/mob/vex/charge1.ogg": 880216,
	"./LATEST/mob/vex/charge2.ogg": 206548,
	"./LATEST/mob/vex/charge3.ogg": 936748,
	"./LATEST/mob/vex/death1.ogg": 198794,
	"./LATEST/mob/vex/death2.ogg": 784848,
	"./LATEST/mob/vex/hurt1.ogg": 7183,
	"./LATEST/mob/vex/hurt2.ogg": 437284,
	"./LATEST/mob/vex/idle1.ogg": 962578,
	"./LATEST/mob/vex/idle2.ogg": 304872,
	"./LATEST/mob/vex/idle3.ogg": 410696,
	"./LATEST/mob/vex/idle4.ogg": 882060,
	"./LATEST/mob/villager/death.ogg": 83171,
	"./LATEST/mob/villager/haggle1.ogg": 883390,
	"./LATEST/mob/villager/haggle2.ogg": 631368,
	"./LATEST/mob/villager/haggle3.ogg": 418644,
	"./LATEST/mob/villager/hit1.ogg": 510219,
	"./LATEST/mob/villager/hit2.ogg": 16037,
	"./LATEST/mob/villager/hit3.ogg": 916326,
	"./LATEST/mob/villager/hit4.ogg": 711910,
	"./LATEST/mob/villager/idle1.ogg": 889907,
	"./LATEST/mob/villager/idle2.ogg": 877098,
	"./LATEST/mob/villager/idle3.ogg": 736481,
	"./LATEST/mob/villager/no1.ogg": 248170,
	"./LATEST/mob/villager/no2.ogg": 540257,
	"./LATEST/mob/villager/no3.ogg": 620353,
	"./LATEST/mob/villager/yes1.ogg": 843752,
	"./LATEST/mob/villager/yes2.ogg": 772703,
	"./LATEST/mob/villager/yes3.ogg": 945588,
	"./LATEST/mob/vindication_illager/celebrate1.ogg": 185581,
	"./LATEST/mob/vindication_illager/celebrate2.ogg": 853017,
	"./LATEST/mob/vindication_illager/death1.ogg": 944497,
	"./LATEST/mob/vindication_illager/death2.ogg": 156670,
	"./LATEST/mob/vindication_illager/hurt1.ogg": 75487,
	"./LATEST/mob/vindication_illager/hurt2.ogg": 375027,
	"./LATEST/mob/vindication_illager/hurt3.ogg": 884375,
	"./LATEST/mob/vindication_illager/idle1.ogg": 614535,
	"./LATEST/mob/vindication_illager/idle2.ogg": 612721,
	"./LATEST/mob/vindication_illager/idle3.ogg": 186036,
	"./LATEST/mob/vindication_illager/idle4.ogg": 644532,
	"./LATEST/mob/vindication_illager/idle5.ogg": 717478,
	"./LATEST/mob/wandering_trader/appeared1.ogg": 936323,
	"./LATEST/mob/wandering_trader/appeared2.ogg": 913075,
	"./LATEST/mob/wandering_trader/death.ogg": 49921,
	"./LATEST/mob/wandering_trader/disappeared1.ogg": 486684,
	"./LATEST/mob/wandering_trader/disappeared2.ogg": 594421,
	"./LATEST/mob/wandering_trader/drink_milk1.ogg": 287714,
	"./LATEST/mob/wandering_trader/drink_milk2.ogg": 261717,
	"./LATEST/mob/wandering_trader/drink_milk3.ogg": 955531,
	"./LATEST/mob/wandering_trader/drink_milk4.ogg": 575612,
	"./LATEST/mob/wandering_trader/drink_milk5.ogg": 82895,
	"./LATEST/mob/wandering_trader/drink_potion.ogg": 689465,
	"./LATEST/mob/wandering_trader/haggle1.ogg": 478068,
	"./LATEST/mob/wandering_trader/haggle2.ogg": 227702,
	"./LATEST/mob/wandering_trader/haggle3.ogg": 626214,
	"./LATEST/mob/wandering_trader/hurt1.ogg": 701677,
	"./LATEST/mob/wandering_trader/hurt2.ogg": 929122,
	"./LATEST/mob/wandering_trader/hurt3.ogg": 465600,
	"./LATEST/mob/wandering_trader/hurt4.ogg": 879028,
	"./LATEST/mob/wandering_trader/idle1.ogg": 667208,
	"./LATEST/mob/wandering_trader/idle2.ogg": 840491,
	"./LATEST/mob/wandering_trader/idle3.ogg": 493418,
	"./LATEST/mob/wandering_trader/idle4.ogg": 982178,
	"./LATEST/mob/wandering_trader/idle5.ogg": 26885,
	"./LATEST/mob/wandering_trader/no1.ogg": 610680,
	"./LATEST/mob/wandering_trader/no2.ogg": 786481,
	"./LATEST/mob/wandering_trader/no3.ogg": 938009,
	"./LATEST/mob/wandering_trader/no4.ogg": 739629,
	"./LATEST/mob/wandering_trader/no5.ogg": 161625,
	"./LATEST/mob/wandering_trader/reappeared1.ogg": 246567,
	"./LATEST/mob/wandering_trader/reappeared2.ogg": 478779,
	"./LATEST/mob/wandering_trader/yes1.ogg": 957781,
	"./LATEST/mob/wandering_trader/yes2.ogg": 159938,
	"./LATEST/mob/wandering_trader/yes3.ogg": 889178,
	"./LATEST/mob/wandering_trader/yes4.ogg": 350928,
	"./LATEST/mob/warden/agitated_1.ogg": 712541,
	"./LATEST/mob/warden/agitated_2.ogg": 790150,
	"./LATEST/mob/warden/agitated_3.ogg": 856780,
	"./LATEST/mob/warden/agitated_4.ogg": 496327,
	"./LATEST/mob/warden/agitated_5.ogg": 984845,
	"./LATEST/mob/warden/agitated_6.ogg": 101442,
	"./LATEST/mob/warden/ambient_1.ogg": 609862,
	"./LATEST/mob/warden/ambient_10.ogg": 460295,
	"./LATEST/mob/warden/ambient_11.ogg": 967121,
	"./LATEST/mob/warden/ambient_12.ogg": 155344,
	"./LATEST/mob/warden/ambient_2.ogg": 270692,
	"./LATEST/mob/warden/ambient_3.ogg": 769226,
	"./LATEST/mob/warden/ambient_4.ogg": 303144,
	"./LATEST/mob/warden/ambient_5.ogg": 343799,
	"./LATEST/mob/warden/ambient_6.ogg": 399329,
	"./LATEST/mob/warden/ambient_7.ogg": 969699,
	"./LATEST/mob/warden/ambient_8.ogg": 401257,
	"./LATEST/mob/warden/ambient_9.ogg": 463919,
	"./LATEST/mob/warden/angry_1.ogg": 925347,
	"./LATEST/mob/warden/angry_2.ogg": 450037,
	"./LATEST/mob/warden/angry_3.ogg": 297036,
	"./LATEST/mob/warden/angry_4.ogg": 121311,
	"./LATEST/mob/warden/angry_5.ogg": 155864,
	"./LATEST/mob/warden/angry_6.ogg": 143927,
	"./LATEST/mob/warden/attack_impact_1.ogg": 832814,
	"./LATEST/mob/warden/attack_impact_2.ogg": 996338,
	"./LATEST/mob/warden/death_1.ogg": 964013,
	"./LATEST/mob/warden/death_2.ogg": 635588,
	"./LATEST/mob/warden/dig.ogg": 289787,
	"./LATEST/mob/warden/emerge.ogg": 719675,
	"./LATEST/mob/warden/heartbeat_1.ogg": 229647,
	"./LATEST/mob/warden/heartbeat_2.ogg": 834908,
	"./LATEST/mob/warden/heartbeat_3.ogg": 928543,
	"./LATEST/mob/warden/heartbeat_4.ogg": 920295,
	"./LATEST/mob/warden/hurt_1.ogg": 245486,
	"./LATEST/mob/warden/hurt_2.ogg": 258068,
	"./LATEST/mob/warden/hurt_3.ogg": 577381,
	"./LATEST/mob/warden/hurt_4.ogg": 812142,
	"./LATEST/mob/warden/listening_1.ogg": 302637,
	"./LATEST/mob/warden/listening_2.ogg": 525006,
	"./LATEST/mob/warden/listening_3.ogg": 990978,
	"./LATEST/mob/warden/listening_4.ogg": 864669,
	"./LATEST/mob/warden/listening_5.ogg": 661356,
	"./LATEST/mob/warden/listening_angry_1.ogg": 674358,
	"./LATEST/mob/warden/listening_angry_2.ogg": 203311,
	"./LATEST/mob/warden/listening_angry_3.ogg": 412517,
	"./LATEST/mob/warden/listening_angry_4.ogg": 472301,
	"./LATEST/mob/warden/listening_angry_5.ogg": 329361,
	"./LATEST/mob/warden/nearby_close_1.ogg": 299858,
	"./LATEST/mob/warden/nearby_close_2.ogg": 814305,
	"./LATEST/mob/warden/nearby_close_3.ogg": 759097,
	"./LATEST/mob/warden/nearby_close_4.ogg": 920192,
	"./LATEST/mob/warden/nearby_closer_1.ogg": 168209,
	"./LATEST/mob/warden/nearby_closer_2.ogg": 495251,
	"./LATEST/mob/warden/nearby_closer_3.ogg": 605482,
	"./LATEST/mob/warden/nearby_closest_1.ogg": 682981,
	"./LATEST/mob/warden/nearby_closest_2.ogg": 303239,
	"./LATEST/mob/warden/nearby_closest_3.ogg": 314109,
	"./LATEST/mob/warden/roar_1.ogg": 183331,
	"./LATEST/mob/warden/roar_2.ogg": 803794,
	"./LATEST/mob/warden/roar_3.ogg": 963978,
	"./LATEST/mob/warden/roar_4.ogg": 889729,
	"./LATEST/mob/warden/roar_5.ogg": 420194,
	"./LATEST/mob/warden/sniff_1.ogg": 594360,
	"./LATEST/mob/warden/sniff_2.ogg": 697627,
	"./LATEST/mob/warden/sniff_3.ogg": 966868,
	"./LATEST/mob/warden/sniff_4.ogg": 763181,
	"./LATEST/mob/warden/sonic_boom1.ogg": 482688,
	"./LATEST/mob/warden/sonic_boom2.ogg": 374222,
	"./LATEST/mob/warden/sonic_boom3.ogg": 485565,
	"./LATEST/mob/warden/sonic_boom4.ogg": 821820,
	"./LATEST/mob/warden/sonic_charge1.ogg": 101429,
	"./LATEST/mob/warden/sonic_charge2.ogg": 499827,
	"./LATEST/mob/warden/sonic_charge3.ogg": 842661,
	"./LATEST/mob/warden/sonic_charge4.ogg": 242622,
	"./LATEST/mob/warden/step_1.ogg": 391513,
	"./LATEST/mob/warden/step_2.ogg": 137787,
	"./LATEST/mob/warden/step_3.ogg": 767661,
	"./LATEST/mob/warden/step_4.ogg": 563256,
	"./LATEST/mob/warden/tendril_clicks_1.ogg": 841869,
	"./LATEST/mob/warden/tendril_clicks_2.ogg": 699684,
	"./LATEST/mob/warden/tendril_clicks_3.ogg": 808461,
	"./LATEST/mob/warden/tendril_clicks_4.ogg": 440926,
	"./LATEST/mob/warden/tendril_clicks_5.ogg": 367261,
	"./LATEST/mob/warden/tendril_clicks_6.ogg": 956230,
	"./LATEST/mob/wither/death.ogg": 818997,
	"./LATEST/mob/wither/hurt1.ogg": 856777,
	"./LATEST/mob/wither/hurt2.ogg": 832179,
	"./LATEST/mob/wither/hurt3.ogg": 691163,
	"./LATEST/mob/wither/hurt4.ogg": 726054,
	"./LATEST/mob/wither/idle1.ogg": 827726,
	"./LATEST/mob/wither/idle2.ogg": 439003,
	"./LATEST/mob/wither/idle3.ogg": 325883,
	"./LATEST/mob/wither/idle4.ogg": 828157,
	"./LATEST/mob/wither/shoot.ogg": 869520,
	"./LATEST/mob/wither/spawn.ogg": 645844,
	"./LATEST/mob/wither_skeleton/death1.ogg": 386559,
	"./LATEST/mob/wither_skeleton/death2.ogg": 552942,
	"./LATEST/mob/wither_skeleton/hurt1.ogg": 661514,
	"./LATEST/mob/wither_skeleton/hurt2.ogg": 673340,
	"./LATEST/mob/wither_skeleton/hurt3.ogg": 620348,
	"./LATEST/mob/wither_skeleton/hurt4.ogg": 122432,
	"./LATEST/mob/wither_skeleton/idle1.ogg": 147973,
	"./LATEST/mob/wither_skeleton/idle2.ogg": 662921,
	"./LATEST/mob/wither_skeleton/idle3.ogg": 649046,
	"./LATEST/mob/wither_skeleton/step1.ogg": 855876,
	"./LATEST/mob/wither_skeleton/step2.ogg": 785910,
	"./LATEST/mob/wither_skeleton/step3.ogg": 416451,
	"./LATEST/mob/wither_skeleton/step4.ogg": 618617,
	"./LATEST/mob/wolf/bark1.ogg": 389846,
	"./LATEST/mob/wolf/bark2.ogg": 542865,
	"./LATEST/mob/wolf/bark3.ogg": 163534,
	"./LATEST/mob/wolf/death.ogg": 997014,
	"./LATEST/mob/wolf/growl1.ogg": 373249,
	"./LATEST/mob/wolf/growl2.ogg": 457397,
	"./LATEST/mob/wolf/growl3.ogg": 290616,
	"./LATEST/mob/wolf/howl1.ogg": 195710,
	"./LATEST/mob/wolf/howl2.ogg": 386837,
	"./LATEST/mob/wolf/hurt1.ogg": 166804,
	"./LATEST/mob/wolf/hurt2.ogg": 44257,
	"./LATEST/mob/wolf/hurt3.ogg": 411882,
	"./LATEST/mob/wolf/panting.ogg": 707019,
	"./LATEST/mob/wolf/shake.ogg": 167864,
	"./LATEST/mob/wolf/step1.ogg": 757030,
	"./LATEST/mob/wolf/step2.ogg": 483625,
	"./LATEST/mob/wolf/step3.ogg": 797601,
	"./LATEST/mob/wolf/step4.ogg": 575139,
	"./LATEST/mob/wolf/step5.ogg": 926356,
	"./LATEST/mob/wolf/whine.ogg": 181491,
	"./LATEST/mob/zoglin/angry1.ogg": 112951,
	"./LATEST/mob/zoglin/angry2.ogg": 630119,
	"./LATEST/mob/zoglin/angry3.ogg": 770178,
	"./LATEST/mob/zoglin/attack1.ogg": 321391,
	"./LATEST/mob/zoglin/attack2.ogg": 842208,
	"./LATEST/mob/zoglin/death1.ogg": 622615,
	"./LATEST/mob/zoglin/death2.ogg": 378619,
	"./LATEST/mob/zoglin/death3.ogg": 985300,
	"./LATEST/mob/zoglin/hurt1.ogg": 143177,
	"./LATEST/mob/zoglin/hurt2.ogg": 751067,
	"./LATEST/mob/zoglin/hurt3.ogg": 374046,
	"./LATEST/mob/zoglin/idle1.ogg": 822282,
	"./LATEST/mob/zoglin/idle2.ogg": 232535,
	"./LATEST/mob/zoglin/idle3.ogg": 505815,
	"./LATEST/mob/zoglin/idle4.ogg": 939092,
	"./LATEST/mob/zoglin/idle5.ogg": 144734,
	"./LATEST/mob/zoglin/idle6.ogg": 134402,
	"./LATEST/mob/zoglin/step1.ogg": 999607,
	"./LATEST/mob/zoglin/step2.ogg": 415866,
	"./LATEST/mob/zoglin/step3.ogg": 544220,
	"./LATEST/mob/zoglin/step4.ogg": 425551,
	"./LATEST/mob/zoglin/step5.ogg": 437441,
	"./LATEST/mob/zombie/death.ogg": 396303,
	"./LATEST/mob/zombie/hurt1.ogg": 723043,
	"./LATEST/mob/zombie/hurt2.ogg": 684371,
	"./LATEST/mob/zombie/infect.ogg": 115010,
	"./LATEST/mob/zombie/metal1.ogg": 578981,
	"./LATEST/mob/zombie/metal2.ogg": 514176,
	"./LATEST/mob/zombie/metal3.ogg": 516938,
	"./LATEST/mob/zombie/remedy.ogg": 669041,
	"./LATEST/mob/zombie/say1.ogg": 453120,
	"./LATEST/mob/zombie/say2.ogg": 800523,
	"./LATEST/mob/zombie/say3.ogg": 983557,
	"./LATEST/mob/zombie/step1.ogg": 561271,
	"./LATEST/mob/zombie/step2.ogg": 272597,
	"./LATEST/mob/zombie/step3.ogg": 953901,
	"./LATEST/mob/zombie/step4.ogg": 653970,
	"./LATEST/mob/zombie/step5.ogg": 180897,
	"./LATEST/mob/zombie/unfect.ogg": 223141,
	"./LATEST/mob/zombie/wood1.ogg": 598042,
	"./LATEST/mob/zombie/wood2.ogg": 733194,
	"./LATEST/mob/zombie/wood3.ogg": 42465,
	"./LATEST/mob/zombie/wood4.ogg": 163363,
	"./LATEST/mob/zombie/woodbreak.ogg": 500490,
	"./LATEST/mob/zombie_villager/death.ogg": 399435,
	"./LATEST/mob/zombie_villager/hurt1.ogg": 739345,
	"./LATEST/mob/zombie_villager/hurt2.ogg": 384834,
	"./LATEST/mob/zombie_villager/say1.ogg": 901126,
	"./LATEST/mob/zombie_villager/say2.ogg": 476006,
	"./LATEST/mob/zombie_villager/say3.ogg": 848665,
	"./LATEST/mob/zombified_piglin/zpig1.ogg": 344177,
	"./LATEST/mob/zombified_piglin/zpig2.ogg": 506356,
	"./LATEST/mob/zombified_piglin/zpig3.ogg": 939316,
	"./LATEST/mob/zombified_piglin/zpig4.ogg": 328671,
	"./LATEST/mob/zombified_piglin/zpigangry1.ogg": 603588,
	"./LATEST/mob/zombified_piglin/zpigangry2.ogg": 847099,
	"./LATEST/mob/zombified_piglin/zpigangry3.ogg": 429486,
	"./LATEST/mob/zombified_piglin/zpigangry4.ogg": 842468,
	"./LATEST/mob/zombified_piglin/zpigdeath.ogg": 223518,
	"./LATEST/mob/zombified_piglin/zpighurt1.ogg": 560717,
	"./LATEST/mob/zombified_piglin/zpighurt2.ogg": 374625,
	"./LATEST/music/game/a_familiar_room.ogg": 363788,
	"./LATEST/music/game/an_ordinary_day.ogg": 919928,
	"./LATEST/music/game/ancestry.ogg": 955164,
	"./LATEST/music/game/bromeliad.ogg": 579623,
	"./LATEST/music/game/calm1.ogg": 674956,
	"./LATEST/music/game/calm2.ogg": 935506,
	"./LATEST/music/game/calm3.ogg": 485091,
	"./LATEST/music/game/comforting_memories.ogg": 850513,
	"./LATEST/music/game/creative/creative1.ogg": 692727,
	"./LATEST/music/game/creative/creative2.ogg": 51351,
	"./LATEST/music/game/creative/creative3.ogg": 507864,
	"./LATEST/music/game/creative/creative4.ogg": 597011,
	"./LATEST/music/game/creative/creative5.ogg": 121585,
	"./LATEST/music/game/creative/creative6.ogg": 165686,
	"./LATEST/music/game/crescent_dunes.ogg": 768992,
	"./LATEST/music/game/echo_in_the_wind.ogg": 613805,
	"./LATEST/music/game/end/boss.ogg": 87532,
	"./LATEST/music/game/end/credits.ogg": 554241,
	"./LATEST/music/game/end/end.ogg": 310561,
	"./LATEST/music/game/floating_dream.ogg": 124131,
	"./LATEST/music/game/hal1.ogg": 6006,
	"./LATEST/music/game/hal2.ogg": 495737,
	"./LATEST/music/game/hal3.ogg": 584242,
	"./LATEST/music/game/hal4.ogg": 239333,
	"./LATEST/music/game/infinite_amethyst.ogg": 188608,
	"./LATEST/music/game/left_to_bloom.ogg": 142682,
	"./LATEST/music/game/nether/crimson_forest/chrysopoeia.ogg": 547769,
	"./LATEST/music/game/nether/nether1.ogg": 331574,
	"./LATEST/music/game/nether/nether2.ogg": 454309,
	"./LATEST/music/game/nether/nether3.ogg": 234215,
	"./LATEST/music/game/nether/nether4.ogg": 365894,
	"./LATEST/music/game/nether/nether_wastes/rubedo.ogg": 820778,
	"./LATEST/music/game/nether/soulsand_valley/so_below.ogg": 991512,
	"./LATEST/music/game/nuance1.ogg": 834135,
	"./LATEST/music/game/nuance2.ogg": 221796,
	"./LATEST/music/game/one_more_day.ogg": 592535,
	"./LATEST/music/game/piano1.ogg": 545035,
	"./LATEST/music/game/piano2.ogg": 984516,
	"./LATEST/music/game/piano3.ogg": 383411,
	"./LATEST/music/game/stand_tall.ogg": 371971,
	"./LATEST/music/game/swamp/aerie.ogg": 334184,
	"./LATEST/music/game/swamp/firebugs.ogg": 130273,
	"./LATEST/music/game/swamp/labyrinthine.ogg": 796917,
	"./LATEST/music/game/water/axolotl.ogg": 163448,
	"./LATEST/music/game/water/dragon_fish.ogg": 625894,
	"./LATEST/music/game/water/shuniji.ogg": 897374,
	"./LATEST/music/game/wending.ogg": 510267,
	"./LATEST/music/menu/menu1.ogg": 350286,
	"./LATEST/music/menu/menu2.ogg": 712161,
	"./LATEST/music/menu/menu3.ogg": 521215,
	"./LATEST/music/menu/menu4.ogg": 154698,
	"./LATEST/note/banjo.ogg": 504727,
	"./LATEST/note/bass.ogg": 235921,
	"./LATEST/note/bassattack.ogg": 237624,
	"./LATEST/note/bd.ogg": 155560,
	"./LATEST/note/bell.ogg": 237025,
	"./LATEST/note/bit.ogg": 565788,
	"./LATEST/note/cow_bell.ogg": 773457,
	"./LATEST/note/didgeridoo.ogg": 847170,
	"./LATEST/note/flute.ogg": 127954,
	"./LATEST/note/guitar.ogg": 22243,
	"./LATEST/note/harp.ogg": 103085,
	"./LATEST/note/harp2.ogg": 771434,
	"./LATEST/note/hat.ogg": 895982,
	"./LATEST/note/icechime.ogg": 969659,
	"./LATEST/note/iron_xylophone.ogg": 517201,
	"./LATEST/note/pling.ogg": 396585,
	"./LATEST/note/snare.ogg": 297079,
	"./LATEST/note/xylobone.ogg": 479683,
	"./LATEST/portal/portal.ogg": 705447,
	"./LATEST/portal/travel.ogg": 977735,
	"./LATEST/portal/trigger.ogg": 267117,
	"./LATEST/random/anvil_break.ogg": 168855,
	"./LATEST/random/anvil_land.ogg": 284315,
	"./LATEST/random/anvil_use.ogg": 421667,
	"./LATEST/random/bow.ogg": 68993,
	"./LATEST/random/bowhit1.ogg": 666239,
	"./LATEST/random/bowhit2.ogg": 716206,
	"./LATEST/random/bowhit3.ogg": 644216,
	"./LATEST/random/bowhit4.ogg": 113480,
	"./LATEST/random/break.ogg": 658153,
	"./LATEST/random/breath.ogg": 446585,
	"./LATEST/random/burp.ogg": 748386,
	"./LATEST/random/chestclosed.ogg": 821073,
	"./LATEST/random/chestopen.ogg": 600964,
	"./LATEST/random/classic_hurt.ogg": 645309,
	"./LATEST/random/click.ogg": 45377,
	"./LATEST/random/click_stereo.ogg": 729795,
	"./LATEST/random/door_close.ogg": 60887,
	"./LATEST/random/door_open.ogg": 324759,
	"./LATEST/random/drink.ogg": 967396,
	"./LATEST/random/eat1.ogg": 9557,
	"./LATEST/random/eat2.ogg": 979115,
	"./LATEST/random/eat3.ogg": 386987,
	"./LATEST/random/explode1.ogg": 373860,
	"./LATEST/random/explode2.ogg": 229710,
	"./LATEST/random/explode3.ogg": 534237,
	"./LATEST/random/explode4.ogg": 996600,
	"./LATEST/random/fizz.ogg": 237151,
	"./LATEST/random/fuse.ogg": 794897,
	"./LATEST/random/glass1.ogg": 589494,
	"./LATEST/random/glass2.ogg": 661157,
	"./LATEST/random/glass3.ogg": 627780,
	"./LATEST/random/levelup.ogg": 6939,
	"./LATEST/random/orb.ogg": 586967,
	"./LATEST/random/pop.ogg": 846735,
	"./LATEST/random/splash.ogg": 857067,
	"./LATEST/random/successful_hit.ogg": 865541,
	"./LATEST/random/wood_click.ogg": 716883,
	"./LATEST/records/11.ogg": 228645,
	"./LATEST/records/13.ogg": 348111,
	"./LATEST/records/5.ogg": 157449,
	"./LATEST/records/blocks.ogg": 98620,
	"./LATEST/records/cat.ogg": 847203,
	"./LATEST/records/chirp.ogg": 39829,
	"./LATEST/records/far.ogg": 952150,
	"./LATEST/records/mall.ogg": 750750,
	"./LATEST/records/mellohi.ogg": 808224,
	"./LATEST/records/otherside.ogg": 857088,
	"./LATEST/records/pigstep.ogg": 511066,
	"./LATEST/records/relic.ogg": 78619,
	"./LATEST/records/stal.ogg": 465304,
	"./LATEST/records/strad.ogg": 762693,
	"./LATEST/records/wait.ogg": 97062,
	"./LATEST/records/ward.ogg": 880331,
	"./LATEST/step/cloth1.ogg": 950998,
	"./LATEST/step/cloth2.ogg": 432143,
	"./LATEST/step/cloth3.ogg": 927782,
	"./LATEST/step/cloth4.ogg": 184861,
	"./LATEST/step/coral1.ogg": 191063,
	"./LATEST/step/coral2.ogg": 825367,
	"./LATEST/step/coral3.ogg": 98811,
	"./LATEST/step/coral4.ogg": 517309,
	"./LATEST/step/coral5.ogg": 182121,
	"./LATEST/step/coral6.ogg": 180339,
	"./LATEST/step/grass1.ogg": 787401,
	"./LATEST/step/grass2.ogg": 638722,
	"./LATEST/step/grass3.ogg": 837504,
	"./LATEST/step/grass4.ogg": 666654,
	"./LATEST/step/grass5.ogg": 718289,
	"./LATEST/step/grass6.ogg": 102064,
	"./LATEST/step/gravel1.ogg": 643851,
	"./LATEST/step/gravel2.ogg": 898989,
	"./LATEST/step/gravel3.ogg": 715234,
	"./LATEST/step/gravel4.ogg": 75213,
	"./LATEST/step/ladder1.ogg": 142517,
	"./LATEST/step/ladder2.ogg": 664573,
	"./LATEST/step/ladder3.ogg": 594199,
	"./LATEST/step/ladder4.ogg": 670217,
	"./LATEST/step/ladder5.ogg": 531968,
	"./LATEST/step/sand1.ogg": 663969,
	"./LATEST/step/sand2.ogg": 124563,
	"./LATEST/step/sand3.ogg": 85250,
	"./LATEST/step/sand4.ogg": 536033,
	"./LATEST/step/sand5.ogg": 374189,
	"./LATEST/step/scaffold1.ogg": 849942,
	"./LATEST/step/scaffold2.ogg": 268797,
	"./LATEST/step/scaffold3.ogg": 593365,
	"./LATEST/step/scaffold4.ogg": 911510,
	"./LATEST/step/scaffold5.ogg": 819856,
	"./LATEST/step/scaffold6.ogg": 201628,
	"./LATEST/step/scaffold7.ogg": 653295,
	"./LATEST/step/snow1.ogg": 123219,
	"./LATEST/step/snow2.ogg": 477218,
	"./LATEST/step/snow3.ogg": 765597,
	"./LATEST/step/snow4.ogg": 663691,
	"./LATEST/step/stone1.ogg": 819409,
	"./LATEST/step/stone2.ogg": 650850,
	"./LATEST/step/stone3.ogg": 336344,
	"./LATEST/step/stone4.ogg": 386240,
	"./LATEST/step/stone5.ogg": 867903,
	"./LATEST/step/stone6.ogg": 672480,
	"./LATEST/step/wet_grass1.ogg": 439682,
	"./LATEST/step/wet_grass2.ogg": 394773,
	"./LATEST/step/wet_grass3.ogg": 100297,
	"./LATEST/step/wet_grass4.ogg": 640468,
	"./LATEST/step/wet_grass5.ogg": 6867,
	"./LATEST/step/wet_grass6.ogg": 136244,
	"./LATEST/step/wood1.ogg": 796397,
	"./LATEST/step/wood2.ogg": 11113,
	"./LATEST/step/wood3.ogg": 50559,
	"./LATEST/step/wood4.ogg": 829468,
	"./LATEST/step/wood5.ogg": 207844,
	"./LATEST/step/wood6.ogg": 227114,
	"./LATEST/tile/piston/in.ogg": 300754,
	"./LATEST/tile/piston/out.ogg": 498080,
	"./LATEST/ui/cartography_table/drawmap1.ogg": 356290,
	"./LATEST/ui/cartography_table/drawmap2.ogg": 800069,
	"./LATEST/ui/cartography_table/drawmap3.ogg": 3449,
	"./LATEST/ui/loom/select_pattern1.ogg": 835853,
	"./LATEST/ui/loom/select_pattern2.ogg": 986235,
	"./LATEST/ui/loom/select_pattern3.ogg": 304134,
	"./LATEST/ui/loom/select_pattern4.ogg": 76191,
	"./LATEST/ui/loom/select_pattern5.ogg": 372794,
	"./LATEST/ui/loom/take_result1.ogg": 975156,
	"./LATEST/ui/loom/take_result2.ogg": 347263,
	"./LATEST/ui/stonecutter/cut1.ogg": 545024,
	"./LATEST/ui/stonecutter/cut2.ogg": 803642,
	"./LATEST/ui/toast/challenge_complete.ogg": 63571,
	"./LATEST/ui/toast/in.ogg": 449212,
	"./LATEST/ui/toast/out.ogg": 951145,
	"./LEGACY/ambient/cave/cave1.ogg": 573949,
	"./LEGACY/ambient/cave/cave10.ogg": 978191,
	"./LEGACY/ambient/cave/cave11.ogg": 890966,
	"./LEGACY/ambient/cave/cave12.ogg": 96835,
	"./LEGACY/ambient/cave/cave13.ogg": 6215,
	"./LEGACY/ambient/cave/cave2.ogg": 381287,
	"./LEGACY/ambient/cave/cave3.ogg": 983992,
	"./LEGACY/ambient/cave/cave4.ogg": 348810,
	"./LEGACY/ambient/cave/cave5.ogg": 520341,
	"./LEGACY/ambient/cave/cave6.ogg": 127595,
	"./LEGACY/ambient/cave/cave7.ogg": 45265,
	"./LEGACY/ambient/cave/cave8.ogg": 821914,
	"./LEGACY/ambient/cave/cave9.ogg": 865645,
	"./LEGACY/ambient/weather/rain1.ogg": 441060,
	"./LEGACY/ambient/weather/rain2.ogg": 912526,
	"./LEGACY/ambient/weather/rain3.ogg": 512153,
	"./LEGACY/ambient/weather/rain4.ogg": 806412,
	"./LEGACY/ambient/weather/thunder1.ogg": 433134,
	"./LEGACY/ambient/weather/thunder2.ogg": 932049,
	"./LEGACY/ambient/weather/thunder3.ogg": 828602,
	"./LEGACY/damage/fallbig.ogg": 800375,
	"./LEGACY/damage/fallsmall.ogg": 826280,
	"./LEGACY/damage/hit1.ogg": 378113,
	"./LEGACY/damage/hit2.ogg": 420861,
	"./LEGACY/damage/hit3.ogg": 402670,
	"./LEGACY/dig/cloth1.ogg": 950954,
	"./LEGACY/dig/cloth2.ogg": 217120,
	"./LEGACY/dig/cloth3.ogg": 353549,
	"./LEGACY/dig/cloth4.ogg": 486395,
	"./LEGACY/dig/grass1.ogg": 649921,
	"./LEGACY/dig/grass2.ogg": 365772,
	"./LEGACY/dig/grass3.ogg": 407127,
	"./LEGACY/dig/grass4.ogg": 580706,
	"./LEGACY/dig/gravel1.ogg": 429619,
	"./LEGACY/dig/gravel2.ogg": 588192,
	"./LEGACY/dig/gravel3.ogg": 771355,
	"./LEGACY/dig/gravel4.ogg": 386085,
	"./LEGACY/dig/sand1.ogg": 277889,
	"./LEGACY/dig/sand2.ogg": 350227,
	"./LEGACY/dig/sand3.ogg": 975273,
	"./LEGACY/dig/sand4.ogg": 313404,
	"./LEGACY/dig/snow1.ogg": 907119,
	"./LEGACY/dig/snow2.ogg": 257065,
	"./LEGACY/dig/snow3.ogg": 675243,
	"./LEGACY/dig/snow4.ogg": 791635,
	"./LEGACY/dig/stone1.ogg": 888108,
	"./LEGACY/dig/stone2.ogg": 614285,
	"./LEGACY/dig/stone3.ogg": 714370,
	"./LEGACY/dig/stone4.ogg": 393029,
	"./LEGACY/dig/wood1.ogg": 991506,
	"./LEGACY/dig/wood2.ogg": 678548,
	"./LEGACY/dig/wood3.ogg": 753772,
	"./LEGACY/dig/wood4.ogg": 864733,
	"./LEGACY/fire/fire.ogg": 192998,
	"./LEGACY/fire/ignite.ogg": 119329,
	"./LEGACY/fireworks/blast1.ogg": 875718,
	"./LEGACY/fireworks/blast_far1.ogg": 725556,
	"./LEGACY/fireworks/largeBlast1.ogg": 190783,
	"./LEGACY/fireworks/largeBlast_far1.ogg": 154768,
	"./LEGACY/fireworks/launch1.ogg": 532264,
	"./LEGACY/fireworks/twinkle1.ogg": 882941,
	"./LEGACY/fireworks/twinkle_far1.ogg": 873902,
	"./LEGACY/liquid/lava.ogg": 361121,
	"./LEGACY/liquid/lavapop.ogg": 707802,
	"./LEGACY/liquid/splash.ogg": 448842,
	"./LEGACY/liquid/splash2.ogg": 10940,
	"./LEGACY/liquid/swim1.ogg": 563222,
	"./LEGACY/liquid/swim2.ogg": 548349,
	"./LEGACY/liquid/swim3.ogg": 567258,
	"./LEGACY/liquid/swim4.ogg": 638225,
	"./LEGACY/liquid/water.ogg": 404848,
	"./LEGACY/minecart/base.ogg": 1077,
	"./LEGACY/minecart/inside.ogg": 365536,
	"./LEGACY/mob/bat/death.ogg": 912345,
	"./LEGACY/mob/bat/hurt1.ogg": 30830,
	"./LEGACY/mob/bat/hurt2.ogg": 964338,
	"./LEGACY/mob/bat/hurt3.ogg": 66465,
	"./LEGACY/mob/bat/hurt4.ogg": 42176,
	"./LEGACY/mob/bat/idle1.ogg": 781420,
	"./LEGACY/mob/bat/idle2.ogg": 572312,
	"./LEGACY/mob/bat/idle3.ogg": 229732,
	"./LEGACY/mob/bat/idle4.ogg": 931955,
	"./LEGACY/mob/bat/loop.ogg": 56861,
	"./LEGACY/mob/bat/takeoff.ogg": 499557,
	"./LEGACY/mob/blaze/breathe1.ogg": 105610,
	"./LEGACY/mob/blaze/breathe2.ogg": 744115,
	"./LEGACY/mob/blaze/breathe3.ogg": 75063,
	"./LEGACY/mob/blaze/breathe4.ogg": 242451,
	"./LEGACY/mob/blaze/death.ogg": 740208,
	"./LEGACY/mob/blaze/hit1.ogg": 893161,
	"./LEGACY/mob/blaze/hit2.ogg": 472462,
	"./LEGACY/mob/blaze/hit3.ogg": 897455,
	"./LEGACY/mob/blaze/hit4.ogg": 31427,
	"./LEGACY/mob/cat/hiss1.ogg": 424947,
	"./LEGACY/mob/cat/hiss2.ogg": 622507,
	"./LEGACY/mob/cat/hiss3.ogg": 63927,
	"./LEGACY/mob/cat/hitt1.ogg": 840385,
	"./LEGACY/mob/cat/hitt2.ogg": 443959,
	"./LEGACY/mob/cat/hitt3.ogg": 98556,
	"./LEGACY/mob/cat/meow1.ogg": 497489,
	"./LEGACY/mob/cat/meow2.ogg": 136895,
	"./LEGACY/mob/cat/meow3.ogg": 307785,
	"./LEGACY/mob/cat/meow4.ogg": 997931,
	"./LEGACY/mob/cat/purr1.ogg": 562378,
	"./LEGACY/mob/cat/purr2.ogg": 164660,
	"./LEGACY/mob/cat/purr3.ogg": 899792,
	"./LEGACY/mob/cat/purreow1.ogg": 679519,
	"./LEGACY/mob/cat/purreow2.ogg": 989265,
	"./LEGACY/mob/chicken/hurt1.ogg": 329074,
	"./LEGACY/mob/chicken/hurt2.ogg": 622097,
	"./LEGACY/mob/chicken/plop.ogg": 290516,
	"./LEGACY/mob/chicken/say1.ogg": 109267,
	"./LEGACY/mob/chicken/say2.ogg": 871420,
	"./LEGACY/mob/chicken/say3.ogg": 972193,
	"./LEGACY/mob/chicken/step1.ogg": 486435,
	"./LEGACY/mob/chicken/step2.ogg": 465937,
	"./LEGACY/mob/cow/hurt1.ogg": 673862,
	"./LEGACY/mob/cow/hurt2.ogg": 242509,
	"./LEGACY/mob/cow/hurt3.ogg": 87706,
	"./LEGACY/mob/cow/say1.ogg": 750885,
	"./LEGACY/mob/cow/say2.ogg": 468613,
	"./LEGACY/mob/cow/say3.ogg": 926328,
	"./LEGACY/mob/cow/say4.ogg": 222126,
	"./LEGACY/mob/cow/step1.ogg": 332906,
	"./LEGACY/mob/cow/step2.ogg": 412585,
	"./LEGACY/mob/cow/step3.ogg": 757259,
	"./LEGACY/mob/cow/step4.ogg": 223368,
	"./LEGACY/mob/creeper/death.ogg": 226307,
	"./LEGACY/mob/creeper/say1.ogg": 781211,
	"./LEGACY/mob/creeper/say2.ogg": 854659,
	"./LEGACY/mob/creeper/say3.ogg": 86671,
	"./LEGACY/mob/creeper/say4.ogg": 203867,
	"./LEGACY/mob/enderdragon/end.ogg": 936303,
	"./LEGACY/mob/enderdragon/growl1.ogg": 982156,
	"./LEGACY/mob/enderdragon/growl2.ogg": 166327,
	"./LEGACY/mob/enderdragon/growl3.ogg": 88335,
	"./LEGACY/mob/enderdragon/growl4.ogg": 664944,
	"./LEGACY/mob/enderdragon/hit1.ogg": 378351,
	"./LEGACY/mob/enderdragon/hit2.ogg": 812174,
	"./LEGACY/mob/enderdragon/hit3.ogg": 892205,
	"./LEGACY/mob/enderdragon/hit4.ogg": 470062,
	"./LEGACY/mob/enderdragon/wings1.ogg": 152933,
	"./LEGACY/mob/enderdragon/wings2.ogg": 549974,
	"./LEGACY/mob/enderdragon/wings3.ogg": 8634,
	"./LEGACY/mob/enderdragon/wings4.ogg": 354419,
	"./LEGACY/mob/enderdragon/wings5.ogg": 139685,
	"./LEGACY/mob/enderdragon/wings6.ogg": 896143,
	"./LEGACY/mob/endermen/death.ogg": 368959,
	"./LEGACY/mob/endermen/hit1.ogg": 311348,
	"./LEGACY/mob/endermen/hit2.ogg": 660956,
	"./LEGACY/mob/endermen/hit3.ogg": 630682,
	"./LEGACY/mob/endermen/hit4.ogg": 456161,
	"./LEGACY/mob/endermen/idle1.ogg": 407115,
	"./LEGACY/mob/endermen/idle2.ogg": 276527,
	"./LEGACY/mob/endermen/idle3.ogg": 902396,
	"./LEGACY/mob/endermen/idle4.ogg": 158627,
	"./LEGACY/mob/endermen/idle5.ogg": 484264,
	"./LEGACY/mob/endermen/portal.ogg": 235182,
	"./LEGACY/mob/endermen/portal2.ogg": 866798,
	"./LEGACY/mob/endermen/scream1.ogg": 105155,
	"./LEGACY/mob/endermen/scream2.ogg": 749038,
	"./LEGACY/mob/endermen/scream3.ogg": 482958,
	"./LEGACY/mob/endermen/scream4.ogg": 612093,
	"./LEGACY/mob/endermen/stare.ogg": 752742,
	"./LEGACY/mob/ghast/affectionate_scream.ogg": 162489,
	"./LEGACY/mob/ghast/charge.ogg": 12915,
	"./LEGACY/mob/ghast/death.ogg": 129645,
	"./LEGACY/mob/ghast/fireball4.ogg": 458288,
	"./LEGACY/mob/ghast/moan1.ogg": 221825,
	"./LEGACY/mob/ghast/moan2.ogg": 633566,
	"./LEGACY/mob/ghast/moan3.ogg": 145606,
	"./LEGACY/mob/ghast/moan4.ogg": 437546,
	"./LEGACY/mob/ghast/moan5.ogg": 422390,
	"./LEGACY/mob/ghast/moan6.ogg": 115754,
	"./LEGACY/mob/ghast/moan7.ogg": 558276,
	"./LEGACY/mob/ghast/scream1.ogg": 485391,
	"./LEGACY/mob/ghast/scream2.ogg": 114898,
	"./LEGACY/mob/ghast/scream3.ogg": 875218,
	"./LEGACY/mob/ghast/scream4.ogg": 201613,
	"./LEGACY/mob/ghast/scream5.ogg": 891551,
	"./LEGACY/mob/guardian/attack_loop.ogg": 42023,
	"./LEGACY/mob/guardian/curse.ogg": 694732,
	"./LEGACY/mob/guardian/elder_death.ogg": 635486,
	"./LEGACY/mob/guardian/elder_hit1.ogg": 906908,
	"./LEGACY/mob/guardian/elder_hit2.ogg": 385981,
	"./LEGACY/mob/guardian/elder_hit3.ogg": 823459,
	"./LEGACY/mob/guardian/elder_hit4.ogg": 303419,
	"./LEGACY/mob/guardian/elder_idle1.ogg": 759885,
	"./LEGACY/mob/guardian/elder_idle2.ogg": 968062,
	"./LEGACY/mob/guardian/elder_idle3.ogg": 534645,
	"./LEGACY/mob/guardian/elder_idle4.ogg": 666562,
	"./LEGACY/mob/guardian/flop1.ogg": 679457,
	"./LEGACY/mob/guardian/flop2.ogg": 160239,
	"./LEGACY/mob/guardian/flop3.ogg": 681955,
	"./LEGACY/mob/guardian/flop4.ogg": 125236,
	"./LEGACY/mob/guardian/guardian_death.ogg": 894218,
	"./LEGACY/mob/guardian/guardian_hit1.ogg": 100479,
	"./LEGACY/mob/guardian/guardian_hit2.ogg": 760898,
	"./LEGACY/mob/guardian/guardian_hit3.ogg": 786301,
	"./LEGACY/mob/guardian/guardian_hit4.ogg": 390547,
	"./LEGACY/mob/guardian/guardian_idle1.ogg": 60046,
	"./LEGACY/mob/guardian/guardian_idle2.ogg": 686389,
	"./LEGACY/mob/guardian/guardian_idle3.ogg": 720759,
	"./LEGACY/mob/guardian/guardian_idle4.ogg": 571774,
	"./LEGACY/mob/guardian/land_death.ogg": 389683,
	"./LEGACY/mob/guardian/land_hit1.ogg": 432569,
	"./LEGACY/mob/guardian/land_hit2.ogg": 199711,
	"./LEGACY/mob/guardian/land_hit3.ogg": 928180,
	"./LEGACY/mob/guardian/land_hit4.ogg": 937931,
	"./LEGACY/mob/guardian/land_idle1.ogg": 187290,
	"./LEGACY/mob/guardian/land_idle2.ogg": 993763,
	"./LEGACY/mob/guardian/land_idle3.ogg": 295284,
	"./LEGACY/mob/guardian/land_idle4.ogg": 354323,
	"./LEGACY/mob/horse/angry1.ogg": 171377,
	"./LEGACY/mob/horse/armor.ogg": 126521,
	"./LEGACY/mob/horse/breathe1.ogg": 404742,
	"./LEGACY/mob/horse/breathe2.ogg": 268215,
	"./LEGACY/mob/horse/breathe3.ogg": 129844,
	"./LEGACY/mob/horse/death.ogg": 210803,
	"./LEGACY/mob/horse/donkey/angry1.ogg": 79656,
	"./LEGACY/mob/horse/donkey/angry2.ogg": 4405,
	"./LEGACY/mob/horse/donkey/death.ogg": 673501,
	"./LEGACY/mob/horse/donkey/hit1.ogg": 969129,
	"./LEGACY/mob/horse/donkey/hit2.ogg": 348172,
	"./LEGACY/mob/horse/donkey/hit3.ogg": 891057,
	"./LEGACY/mob/horse/donkey/idle1.ogg": 275098,
	"./LEGACY/mob/horse/donkey/idle2.ogg": 645178,
	"./LEGACY/mob/horse/donkey/idle3.ogg": 733574,
	"./LEGACY/mob/horse/gallop1.ogg": 385104,
	"./LEGACY/mob/horse/gallop2.ogg": 919156,
	"./LEGACY/mob/horse/gallop3.ogg": 559146,
	"./LEGACY/mob/horse/gallop4.ogg": 14016,
	"./LEGACY/mob/horse/hit1.ogg": 306775,
	"./LEGACY/mob/horse/hit2.ogg": 638619,
	"./LEGACY/mob/horse/hit3.ogg": 439622,
	"./LEGACY/mob/horse/hit4.ogg": 338377,
	"./LEGACY/mob/horse/idle1.ogg": 408369,
	"./LEGACY/mob/horse/idle2.ogg": 73596,
	"./LEGACY/mob/horse/idle3.ogg": 189606,
	"./LEGACY/mob/horse/jump.ogg": 723932,
	"./LEGACY/mob/horse/land.ogg": 669498,
	"./LEGACY/mob/horse/leather.ogg": 742270,
	"./LEGACY/mob/horse/skeleton/death.ogg": 30896,
	"./LEGACY/mob/horse/skeleton/hit1.ogg": 276915,
	"./LEGACY/mob/horse/skeleton/hit2.ogg": 112825,
	"./LEGACY/mob/horse/skeleton/hit3.ogg": 701632,
	"./LEGACY/mob/horse/skeleton/hit4.ogg": 783671,
	"./LEGACY/mob/horse/skeleton/idle1.ogg": 167,
	"./LEGACY/mob/horse/skeleton/idle2.ogg": 143632,
	"./LEGACY/mob/horse/skeleton/idle3.ogg": 637820,
	"./LEGACY/mob/horse/soft1.ogg": 931698,
	"./LEGACY/mob/horse/soft2.ogg": 139420,
	"./LEGACY/mob/horse/soft3.ogg": 286019,
	"./LEGACY/mob/horse/soft4.ogg": 906959,
	"./LEGACY/mob/horse/soft5.ogg": 391543,
	"./LEGACY/mob/horse/soft6.ogg": 846350,
	"./LEGACY/mob/horse/wood1.ogg": 366371,
	"./LEGACY/mob/horse/wood2.ogg": 201258,
	"./LEGACY/mob/horse/wood3.ogg": 602759,
	"./LEGACY/mob/horse/wood4.ogg": 387002,
	"./LEGACY/mob/horse/wood5.ogg": 545783,
	"./LEGACY/mob/horse/wood6.ogg": 276966,
	"./LEGACY/mob/horse/zombie/death.ogg": 675316,
	"./LEGACY/mob/horse/zombie/hit1.ogg": 104731,
	"./LEGACY/mob/horse/zombie/hit2.ogg": 301110,
	"./LEGACY/mob/horse/zombie/hit3.ogg": 81218,
	"./LEGACY/mob/horse/zombie/hit4.ogg": 2121,
	"./LEGACY/mob/horse/zombie/idle1.ogg": 954338,
	"./LEGACY/mob/horse/zombie/idle2.ogg": 344112,
	"./LEGACY/mob/horse/zombie/idle3.ogg": 161820,
	"./LEGACY/mob/irongolem/death.ogg": 750752,
	"./LEGACY/mob/irongolem/hit1.ogg": 670135,
	"./LEGACY/mob/irongolem/hit2.ogg": 244154,
	"./LEGACY/mob/irongolem/hit3.ogg": 755723,
	"./LEGACY/mob/irongolem/hit4.ogg": 195307,
	"./LEGACY/mob/irongolem/throw.ogg": 649929,
	"./LEGACY/mob/irongolem/walk1.ogg": 416175,
	"./LEGACY/mob/irongolem/walk2.ogg": 482314,
	"./LEGACY/mob/irongolem/walk3.ogg": 419570,
	"./LEGACY/mob/irongolem/walk4.ogg": 50491,
	"./LEGACY/mob/magmacube/big1.ogg": 475353,
	"./LEGACY/mob/magmacube/big2.ogg": 952068,
	"./LEGACY/mob/magmacube/big3.ogg": 166676,
	"./LEGACY/mob/magmacube/big4.ogg": 847150,
	"./LEGACY/mob/magmacube/jump1.ogg": 822867,
	"./LEGACY/mob/magmacube/jump2.ogg": 822359,
	"./LEGACY/mob/magmacube/jump3.ogg": 74692,
	"./LEGACY/mob/magmacube/jump4.ogg": 600813,
	"./LEGACY/mob/magmacube/small1.ogg": 41974,
	"./LEGACY/mob/magmacube/small2.ogg": 556111,
	"./LEGACY/mob/magmacube/small3.ogg": 744510,
	"./LEGACY/mob/magmacube/small4.ogg": 249990,
	"./LEGACY/mob/magmacube/small5.ogg": 806723,
	"./LEGACY/mob/pig/death.ogg": 537794,
	"./LEGACY/mob/pig/say1.ogg": 895240,
	"./LEGACY/mob/pig/say2.ogg": 303261,
	"./LEGACY/mob/pig/say3.ogg": 949778,
	"./LEGACY/mob/pig/step1.ogg": 391766,
	"./LEGACY/mob/pig/step2.ogg": 428270,
	"./LEGACY/mob/pig/step3.ogg": 958142,
	"./LEGACY/mob/pig/step4.ogg": 768576,
	"./LEGACY/mob/pig/step5.ogg": 521115,
	"./LEGACY/mob/rabbit/bunnymurder.ogg": 927718,
	"./LEGACY/mob/rabbit/hop1.ogg": 319013,
	"./LEGACY/mob/rabbit/hop2.ogg": 130541,
	"./LEGACY/mob/rabbit/hop3.ogg": 655955,
	"./LEGACY/mob/rabbit/hop4.ogg": 491215,
	"./LEGACY/mob/rabbit/hurt1.ogg": 110113,
	"./LEGACY/mob/rabbit/hurt2.ogg": 669048,
	"./LEGACY/mob/rabbit/hurt3.ogg": 147138,
	"./LEGACY/mob/rabbit/hurt4.ogg": 24755,
	"./LEGACY/mob/rabbit/idle1.ogg": 633963,
	"./LEGACY/mob/rabbit/idle2.ogg": 541140,
	"./LEGACY/mob/rabbit/idle3.ogg": 943328,
	"./LEGACY/mob/rabbit/idle4.ogg": 149574,
	"./LEGACY/mob/sheep/say1.ogg": 849327,
	"./LEGACY/mob/sheep/say2.ogg": 611459,
	"./LEGACY/mob/sheep/say3.ogg": 106539,
	"./LEGACY/mob/sheep/shear.ogg": 518482,
	"./LEGACY/mob/sheep/step1.ogg": 341247,
	"./LEGACY/mob/sheep/step2.ogg": 752432,
	"./LEGACY/mob/sheep/step3.ogg": 722803,
	"./LEGACY/mob/sheep/step4.ogg": 176074,
	"./LEGACY/mob/sheep/step5.ogg": 231897,
	"./LEGACY/mob/silverfish/hit1.ogg": 114168,
	"./LEGACY/mob/silverfish/hit2.ogg": 188966,
	"./LEGACY/mob/silverfish/hit3.ogg": 359253,
	"./LEGACY/mob/silverfish/kill.ogg": 262058,
	"./LEGACY/mob/silverfish/say1.ogg": 667260,
	"./LEGACY/mob/silverfish/say2.ogg": 393306,
	"./LEGACY/mob/silverfish/say3.ogg": 668846,
	"./LEGACY/mob/silverfish/say4.ogg": 776805,
	"./LEGACY/mob/silverfish/step1.ogg": 66089,
	"./LEGACY/mob/silverfish/step2.ogg": 901192,
	"./LEGACY/mob/silverfish/step3.ogg": 504393,
	"./LEGACY/mob/silverfish/step4.ogg": 915315,
	"./LEGACY/mob/skeleton/death.ogg": 335115,
	"./LEGACY/mob/skeleton/hurt1.ogg": 174166,
	"./LEGACY/mob/skeleton/hurt2.ogg": 147673,
	"./LEGACY/mob/skeleton/hurt3.ogg": 863016,
	"./LEGACY/mob/skeleton/hurt4.ogg": 36593,
	"./LEGACY/mob/skeleton/say1.ogg": 797107,
	"./LEGACY/mob/skeleton/say2.ogg": 482026,
	"./LEGACY/mob/skeleton/say3.ogg": 179967,
	"./LEGACY/mob/skeleton/step1.ogg": 718110,
	"./LEGACY/mob/skeleton/step2.ogg": 836187,
	"./LEGACY/mob/skeleton/step3.ogg": 355007,
	"./LEGACY/mob/skeleton/step4.ogg": 465185,
	"./LEGACY/mob/slime/attack1.ogg": 180862,
	"./LEGACY/mob/slime/attack2.ogg": 303976,
	"./LEGACY/mob/slime/big1.ogg": 953428,
	"./LEGACY/mob/slime/big2.ogg": 289779,
	"./LEGACY/mob/slime/big3.ogg": 574576,
	"./LEGACY/mob/slime/big4.ogg": 627259,
	"./LEGACY/mob/slime/small1.ogg": 722722,
	"./LEGACY/mob/slime/small2.ogg": 441632,
	"./LEGACY/mob/slime/small3.ogg": 753642,
	"./LEGACY/mob/slime/small4.ogg": 366820,
	"./LEGACY/mob/slime/small5.ogg": 962011,
	"./LEGACY/mob/spider/death.ogg": 864237,
	"./LEGACY/mob/spider/say1.ogg": 144072,
	"./LEGACY/mob/spider/say2.ogg": 893329,
	"./LEGACY/mob/spider/say3.ogg": 969739,
	"./LEGACY/mob/spider/say4.ogg": 752571,
	"./LEGACY/mob/spider/step1.ogg": 11249,
	"./LEGACY/mob/spider/step2.ogg": 920554,
	"./LEGACY/mob/spider/step3.ogg": 198243,
	"./LEGACY/mob/spider/step4.ogg": 796175,
	"./LEGACY/mob/villager/death.ogg": 855549,
	"./LEGACY/mob/villager/haggle1.ogg": 163978,
	"./LEGACY/mob/villager/haggle2.ogg": 152594,
	"./LEGACY/mob/villager/haggle3.ogg": 34056,
	"./LEGACY/mob/villager/hit1.ogg": 535041,
	"./LEGACY/mob/villager/hit2.ogg": 548737,
	"./LEGACY/mob/villager/hit3.ogg": 153129,
	"./LEGACY/mob/villager/hit4.ogg": 689413,
	"./LEGACY/mob/villager/idle1.ogg": 302714,
	"./LEGACY/mob/villager/idle2.ogg": 139659,
	"./LEGACY/mob/villager/idle3.ogg": 540211,
	"./LEGACY/mob/villager/no1.ogg": 972338,
	"./LEGACY/mob/villager/no2.ogg": 811106,
	"./LEGACY/mob/villager/no3.ogg": 486069,
	"./LEGACY/mob/villager/yes1.ogg": 240539,
	"./LEGACY/mob/villager/yes2.ogg": 741084,
	"./LEGACY/mob/villager/yes3.ogg": 225234,
	"./LEGACY/mob/wither/death.ogg": 919712,
	"./LEGACY/mob/wither/hurt1.ogg": 407994,
	"./LEGACY/mob/wither/hurt2.ogg": 87714,
	"./LEGACY/mob/wither/hurt3.ogg": 297895,
	"./LEGACY/mob/wither/hurt4.ogg": 173272,
	"./LEGACY/mob/wither/idle1.ogg": 445426,
	"./LEGACY/mob/wither/idle2.ogg": 603726,
	"./LEGACY/mob/wither/idle3.ogg": 781569,
	"./LEGACY/mob/wither/idle4.ogg": 144236,
	"./LEGACY/mob/wither/shoot.ogg": 271929,
	"./LEGACY/mob/wither/spawn.ogg": 250358,
	"./LEGACY/mob/wolf/bark1.ogg": 381342,
	"./LEGACY/mob/wolf/bark2.ogg": 757312,
	"./LEGACY/mob/wolf/bark3.ogg": 289445,
	"./LEGACY/mob/wolf/death.ogg": 172576,
	"./LEGACY/mob/wolf/growl1.ogg": 953469,
	"./LEGACY/mob/wolf/growl2.ogg": 703142,
	"./LEGACY/mob/wolf/growl3.ogg": 589392,
	"./LEGACY/mob/wolf/howl1.ogg": 361994,
	"./LEGACY/mob/wolf/howl2.ogg": 191331,
	"./LEGACY/mob/wolf/hurt1.ogg": 72726,
	"./LEGACY/mob/wolf/hurt2.ogg": 175259,
	"./LEGACY/mob/wolf/hurt3.ogg": 663365,
	"./LEGACY/mob/wolf/panting.ogg": 229599,
	"./LEGACY/mob/wolf/shake.ogg": 838914,
	"./LEGACY/mob/wolf/step1.ogg": 274267,
	"./LEGACY/mob/wolf/step2.ogg": 957750,
	"./LEGACY/mob/wolf/step3.ogg": 125468,
	"./LEGACY/mob/wolf/step4.ogg": 331221,
	"./LEGACY/mob/wolf/step5.ogg": 207122,
	"./LEGACY/mob/wolf/whine.ogg": 565666,
	"./LEGACY/mob/zombie/death.ogg": 658017,
	"./LEGACY/mob/zombie/hurt1.ogg": 284431,
	"./LEGACY/mob/zombie/hurt2.ogg": 938207,
	"./LEGACY/mob/zombie/infect.ogg": 650207,
	"./LEGACY/mob/zombie/metal1.ogg": 911075,
	"./LEGACY/mob/zombie/metal2.ogg": 874261,
	"./LEGACY/mob/zombie/metal3.ogg": 292974,
	"./LEGACY/mob/zombie/remedy.ogg": 661834,
	"./LEGACY/mob/zombie/say1.ogg": 960761,
	"./LEGACY/mob/zombie/say2.ogg": 381297,
	"./LEGACY/mob/zombie/say3.ogg": 865951,
	"./LEGACY/mob/zombie/step1.ogg": 82309,
	"./LEGACY/mob/zombie/step2.ogg": 577557,
	"./LEGACY/mob/zombie/step3.ogg": 959155,
	"./LEGACY/mob/zombie/step4.ogg": 942975,
	"./LEGACY/mob/zombie/step5.ogg": 486969,
	"./LEGACY/mob/zombie/unfect.ogg": 718257,
	"./LEGACY/mob/zombie/wood1.ogg": 260849,
	"./LEGACY/mob/zombie/wood2.ogg": 372666,
	"./LEGACY/mob/zombie/wood3.ogg": 212169,
	"./LEGACY/mob/zombie/wood4.ogg": 924736,
	"./LEGACY/mob/zombie/woodbreak.ogg": 208592,
	"./LEGACY/mob/zombiepig/zpig1.ogg": 355802,
	"./LEGACY/mob/zombiepig/zpig2.ogg": 776859,
	"./LEGACY/mob/zombiepig/zpig3.ogg": 595461,
	"./LEGACY/mob/zombiepig/zpig4.ogg": 720168,
	"./LEGACY/mob/zombiepig/zpigangry1.ogg": 130617,
	"./LEGACY/mob/zombiepig/zpigangry2.ogg": 25613,
	"./LEGACY/mob/zombiepig/zpigangry3.ogg": 900883,
	"./LEGACY/mob/zombiepig/zpigangry4.ogg": 876619,
	"./LEGACY/mob/zombiepig/zpigdeath.ogg": 357498,
	"./LEGACY/mob/zombiepig/zpighurt1.ogg": 709357,
	"./LEGACY/mob/zombiepig/zpighurt2.ogg": 550657,
	"./LEGACY/music/game/calm1.ogg": 477051,
	"./LEGACY/music/game/calm2.ogg": 716057,
	"./LEGACY/music/game/calm3.ogg": 295151,
	"./LEGACY/music/game/creative/creative1.ogg": 935373,
	"./LEGACY/music/game/creative/creative2.ogg": 149866,
	"./LEGACY/music/game/creative/creative3.ogg": 886062,
	"./LEGACY/music/game/creative/creative4.ogg": 480709,
	"./LEGACY/music/game/creative/creative5.ogg": 718701,
	"./LEGACY/music/game/creative/creative6.ogg": 404721,
	"./LEGACY/music/game/end/boss.ogg": 136856,
	"./LEGACY/music/game/end/credits.ogg": 334410,
	"./LEGACY/music/game/end/end.ogg": 560836,
	"./LEGACY/music/game/hal1.ogg": 775076,
	"./LEGACY/music/game/hal2.ogg": 404124,
	"./LEGACY/music/game/hal3.ogg": 471897,
	"./LEGACY/music/game/hal4.ogg": 878414,
	"./LEGACY/music/game/nether/nether1.ogg": 197494,
	"./LEGACY/music/game/nether/nether2.ogg": 90387,
	"./LEGACY/music/game/nether/nether3.ogg": 307007,
	"./LEGACY/music/game/nether/nether4.ogg": 634999,
	"./LEGACY/music/game/nuance1.ogg": 524099,
	"./LEGACY/music/game/nuance2.ogg": 77638,
	"./LEGACY/music/game/piano1.ogg": 746379,
	"./LEGACY/music/game/piano2.ogg": 698113,
	"./LEGACY/music/game/piano3.ogg": 446286,
	"./LEGACY/music/menu/menu1.ogg": 204600,
	"./LEGACY/music/menu/menu2.ogg": 301135,
	"./LEGACY/music/menu/menu3.ogg": 38996,
	"./LEGACY/music/menu/menu4.ogg": 929334,
	"./LEGACY/note/bass.ogg": 515215,
	"./LEGACY/note/bassattack.ogg": 751777,
	"./LEGACY/note/bd.ogg": 463163,
	"./LEGACY/note/harp.ogg": 4775,
	"./LEGACY/note/hat.ogg": 478346,
	"./LEGACY/note/pling.ogg": 752598,
	"./LEGACY/note/snare.ogg": 591806,
	"./LEGACY/portal/portal.ogg": 558664,
	"./LEGACY/portal/travel.ogg": 632015,
	"./LEGACY/portal/trigger.ogg": 67016,
	"./LEGACY/random/anvil_break.ogg": 592069,
	"./LEGACY/random/anvil_land.ogg": 89829,
	"./LEGACY/random/anvil_use.ogg": 652622,
	"./LEGACY/random/bow.ogg": 252472,
	"./LEGACY/random/bowhit1.ogg": 137694,
	"./LEGACY/random/bowhit2.ogg": 593045,
	"./LEGACY/random/bowhit3.ogg": 835349,
	"./LEGACY/random/bowhit4.ogg": 371565,
	"./LEGACY/random/break.ogg": 29355,
	"./LEGACY/random/breath.ogg": 152119,
	"./LEGACY/random/burp.ogg": 32169,
	"./LEGACY/random/chestclosed.ogg": 75205,
	"./LEGACY/random/chestopen.ogg": 65295,
	"./LEGACY/random/classic_hurt.ogg": 381504,
	"./LEGACY/random/click.ogg": 28472,
	"./LEGACY/random/door_close.ogg": 863993,
	"./LEGACY/random/door_open.ogg": 938700,
	"./LEGACY/random/drink.ogg": 952606,
	"./LEGACY/random/eat1.ogg": 753874,
	"./LEGACY/random/eat2.ogg": 27391,
	"./LEGACY/random/eat3.ogg": 666785,
	"./LEGACY/random/explode1.ogg": 968672,
	"./LEGACY/random/explode2.ogg": 368252,
	"./LEGACY/random/explode3.ogg": 590991,
	"./LEGACY/random/explode4.ogg": 35247,
	"./LEGACY/random/fizz.ogg": 8005,
	"./LEGACY/random/fuse.ogg": 195941,
	"./LEGACY/random/glass1.ogg": 142300,
	"./LEGACY/random/glass2.ogg": 897188,
	"./LEGACY/random/glass3.ogg": 553278,
	"./LEGACY/random/levelup.ogg": 169557,
	"./LEGACY/random/orb.ogg": 964255,
	"./LEGACY/random/pop.ogg": 755352,
	"./LEGACY/random/splash.ogg": 422648,
	"./LEGACY/random/successful_hit.ogg": 327268,
	"./LEGACY/random/wood_click.ogg": 10936,
	"./LEGACY/records/11.ogg": 764708,
	"./LEGACY/records/13.ogg": 689070,
	"./LEGACY/records/blocks.ogg": 448409,
	"./LEGACY/records/cat.ogg": 11395,
	"./LEGACY/records/chirp.ogg": 970996,
	"./LEGACY/records/far.ogg": 780215,
	"./LEGACY/records/mall.ogg": 708970,
	"./LEGACY/records/mellohi.ogg": 900248,
	"./LEGACY/records/stal.ogg": 975608,
	"./LEGACY/records/strad.ogg": 173843,
	"./LEGACY/records/wait.ogg": 227190,
	"./LEGACY/records/ward.ogg": 719539,
	"./LEGACY/step/cloth1.ogg": 456199,
	"./LEGACY/step/cloth2.ogg": 291029,
	"./LEGACY/step/cloth3.ogg": 445647,
	"./LEGACY/step/cloth4.ogg": 155034,
	"./LEGACY/step/grass1.ogg": 59538,
	"./LEGACY/step/grass2.ogg": 126578,
	"./LEGACY/step/grass3.ogg": 281657,
	"./LEGACY/step/grass4.ogg": 729299,
	"./LEGACY/step/grass5.ogg": 731370,
	"./LEGACY/step/grass6.ogg": 969588,
	"./LEGACY/step/gravel1.ogg": 838587,
	"./LEGACY/step/gravel2.ogg": 995985,
	"./LEGACY/step/gravel3.ogg": 659302,
	"./LEGACY/step/gravel4.ogg": 661695,
	"./LEGACY/step/ladder1.ogg": 146391,
	"./LEGACY/step/ladder2.ogg": 372098,
	"./LEGACY/step/ladder3.ogg": 383856,
	"./LEGACY/step/ladder4.ogg": 101647,
	"./LEGACY/step/ladder5.ogg": 452450,
	"./LEGACY/step/sand1.ogg": 630551,
	"./LEGACY/step/sand2.ogg": 203057,
	"./LEGACY/step/sand3.ogg": 666636,
	"./LEGACY/step/sand4.ogg": 837399,
	"./LEGACY/step/sand5.ogg": 503864,
	"./LEGACY/step/snow1.ogg": 446447,
	"./LEGACY/step/snow2.ogg": 524068,
	"./LEGACY/step/snow3.ogg": 654105,
	"./LEGACY/step/snow4.ogg": 406246,
	"./LEGACY/step/stone1.ogg": 612193,
	"./LEGACY/step/stone2.ogg": 621074,
	"./LEGACY/step/stone3.ogg": 782122,
	"./LEGACY/step/stone4.ogg": 920972,
	"./LEGACY/step/stone5.ogg": 572014,
	"./LEGACY/step/stone6.ogg": 539298,
	"./LEGACY/step/wood1.ogg": 650726,
	"./LEGACY/step/wood2.ogg": 999858,
	"./LEGACY/step/wood3.ogg": 16402,
	"./LEGACY/step/wood4.ogg": 474417,
	"./LEGACY/step/wood5.ogg": 930485,
	"./LEGACY/step/wood6.ogg": 842531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570935;